import React, {useState, useContext, useRef, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import {
  DataTable,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TableToolbar,
  TableSelectRow,
  TableBatchActions,
  TableBatchAction,
  Tooltip,
  Button,
  Grid,
  Column,
  TextInput,
  TextArea,
  Select,
  SelectItem,
  FileUploader,  
  Modal,  
  Tabs,
  Tab,
  TabPanel,
  Checkbox,  
  TabList,
  Theme,
  TabPanels,
  RadioButtonGroup,
  RadioButton,
  ComboBox,  
  DatePicker,
  DatePickerInput
} from 'carbon-components-react';
import MessageModal from '../../components/MessageModal/MessageModal';
import { Account, AddAlt, SubtractAlt,TrashCan,DocumentAttachment } from '@carbon/icons-react';
import {elegirDoc, 
  getCurrentDoc,  
  getDocumentViewResources, 
  getListMailNameEmployeeByKey,
  responderPedidoSrv,
  getIerpAccountsList,
  getCategoryCommcodeIerp,
  getListTaxTreatyAttachments,
  getListInvoiceAttachments,
  postReturnToVendor,
  getRejectionInformation,
  postCancelReturnToVendor,
  postApproverAttachment,
  getInvoiceCoversheet} from '../../services/services';
import {ThemeContext} from '../../context/ThemeProvider';
import CommodityHeader from '../../components/Header';
import SessionController from '../../components/FrontSessionController/SessionController';
import ModalRequestEmployee from '../../content/ModalRequestEmployee/ModalRequestEmployee';

const DocumentView = () => {
  const EMAIL_IS_NOT_CORRECT_FORMAT = 'One of your emails is not in a correct email format';
  const EMAIL_IS_FROM_IBMER = 'One of your emails is from a IBM employee';
  const ERROR_MESSAGE_GL_ACCOUNT_REQUIRED = 'Please select GL Account';
  const ERROR_MESSAGE_COMMCODE_REQUIRED = 'Please select Commodity';
  const ERROR_MESSAGE_COST_CENTER_REQUIRED = 'Please select Cost Center';
  const ERROR_MESSAGE_INTERNAL_ORDER_REQUIRED = 'Please select Internal Order';
  const ERROR_MESSAGE_WBS_REQUIRED = 'Please select Cost Center';
  const ERROR_MESSAGE_INTERNAL_ORDER_WITH_WBS_REQUIRED = 'You selected WBS. Please, select Internal Order as \nboth fields are required together.';
  const ERROR_MESSAGE_WBS_WITH_INTERNAL_ORDER_REQUIRED = 'You selected Internal Order. Please, select WBS as \nboth fields are required together.';
  const ERROR_MESSAGE_PROFIT_CENTER_REQUIRED = 'Please select Profit Center';
  const ERROR_MESSAGE_ACCOUNT_REQUIRED = 'You need to load an account first. After split you can modify the account.';
  const REGEX_ONLY_NUMBER_AND_DOT = /[^0-9.]/g;
  const TAX_APPROVER_MESSAGE_FOR_MODAL = `Per the non-PO commodity code you selected (%commcode%), \n\r
                                          Procurement's pre-approval is required prior you \n\r
                                          want to engage any new service from this supplier, \n\r
                                          any non-compliance will exposure procurement bypass \n\r
                                          risk. Please upload your pre-approval from procurement \n\r
                                          as an attachment in Web-Portal.\n\r `;
  const MESSAGEPR = "Rejection is possible only within 7 days from the invoice submission due to fiscal reasons";
  const COMMCODES_FOR_PROCUREMENTS_PRE_APPROVAL = ["Z46", "XP4", "XD4", "XJ7", "X03", "X05", "X07", "X26", "X29", "XR0"];
  const AP_ACCOUNTING_SEPARATOR = '#';
  const ACCOUNT_JAPAN_IS_EMPTY =
  [
    {
      code: 'Not result found',
      desc: '',
      disabled:true
    }
  ];
  const ACCOUNT_JAPAN_SEARCH_INPUT = [
      {
        code: 'Please enter 2 or more characters',
        desc: '',
        disabled:true
      }
    ]

    const MANAGERS_EMPTY =
  [
    {
      mail: 'Not result found',
      name: '',
      disabled:true
    }
  ];

  const MANAGERS_SEARCH_INPUT = [
    {
      mail: 'Please enter 4 or more characters',
      name: '',
      disabled:true
    }
  ]

  const DEPARTMENT_CAAPS_SEARCH_INPUT = [
    {
      key: {
        depacode : '',
      },
      depanumb: 'Please enter 2 or more characters',
      depaname: '',
      disabled:true
    }
  ]

  const DEPARTMEMT_CAAPS_IS_EMPTY =
  [
    {
      key: {
        depacode : '',
      },
      depanumb: 'Not result found',
      depaname: '',
      disabled:true
    }
  ];

  const EMPTY_DEPARTMEMT_CAAPS_STATE =
  [
    {
      key: {
        depacode : '',
      },
      depanumb: '',
      depaname: '',
      disabled:true
    }
  ];

  const MINORS_CAAPS_SEARCH_INPUT = [
    {      
      minor: 'Please enter 2 or more characters',     
      disabled:true
    }
  ]

  const MINORS_CAAPS_IS_EMPTY =
  [
    {      
      minor: 'Not result found',      
      disabled:true
    }
  ];

  const EMPTY_MINORS_CAAPS_STATE =
  [
    {      
      minor: '',      
      disabled:true
    }
  ];

  const PROJECT_CAAPS_SEARCH_INPUT = [
    { 
      key: {
        projecod:'Please enter 2 or more characters',
      },           
      disabled:true
    }
  ]

  const PROJECT_CAAPS_IS_EMPTY =
  [
    {      
      key: {
        projecod:'Not result found',      
      },
      disabled:true
    }
  ];

  const EMPTY_PROJECT_CAAPS_STATE =
  [
    {      
      key: {
        projecod:'',      
      },
      disabled:true
    }
  ];
  const EMPTY_ACCOUNT_AP_STATE = {code:'',desc:'',disabled:true};
  const EMPTY_PAYMENT_TERM_AP_STATE = {code:'',description:'',disabled:true};
  const COMMENT_FIELD_MANDATORY = 'Comment field is mandatory. Please press the Comment button and provide a detailed description of the purchase.';
  const MESSAGE_SELECT_ONE_RECEPTION = 'You need to mark one of the account items to split';
  const DEBOUNCE_TIME_FOR_REQUEST = 300;

  const MESSAGE_CONFIRM_SPECIAL_CATEGORIES = `When utilizing code X42, XW3, and XW4 please also note procurement approval is required in addition to this form. 
				Please reach out to the respective procurement code owner for each transactional preapproval by providing them the following 
				required details: Ariba PDF form, summary of benefits IBM will receive, all contracts and or quotes related to this sponsorship,
				the name of who will be submitting the Web Portal purchase request and for which country it is for. All external client and 
				partner facing events now require an approved event brief number in addition to code approval. The brief number will be 
				requested in the Web Portal tool  in the comment section prior to submission, please attach the form before the approval`;

  const navigate = useNavigate();
  const theme = useContext(ThemeContext);
  const user = theme.theme.email;
  const userType = theme.theme.userType;
  const profileName = theme.theme.profile;
  const rol = theme.theme.rol;
  const [userApplicationRol, setUserApplicationRol] = useState("user")
  const emeaVatSplitEnable = theme.theme.emeaVatSplitEnable;  
  const [accountingUnitModal, setAccountingUnitModal] = useState(false);
  
  const [accountingUnitModalAP, setAccountingUnitModalAP] = useState(false);
  const [approvalRole, setApprovalRole] = useState("Select role");
  const [idDoc, setIdDoc] = useState(0);
  const [invitedEmployee, setInvitedEmployee] = useState("");
  
  const [findEmployeesModal, setFindEmployeesModal] = useState(false);
  const employeeModalAction = useRef('');
  const findManagerOrAuthorized = useRef('N');

  const [invitedEmployeeResponse, setInvitedEmployeeResponse] = useState([]);
  const [showMsgDD2Modal, setShowMsgDD2Modal] = useState(false);
  

  //useStates modal comments
  const [commentModal, setCommentModal] = useState(false);
  

  //useState modal first step in the approval
  const [approvalModal, setApprovalModal] = useState(false);
  const DEFAULT_APPROVE_MESSAGE = 'You are approving the reception of the goods and services and you are responsible of the reception of the goods';
  const [messageForModalApproveInvoice, setMessageForModalApproveInvoice] = useState(DEFAULT_APPROVE_MESSAGE);

  //useState modal return to vendor
  const [invoiceRejectionInformation,setInvoiceRejectionInformation] = useState({});
  const [returnToVendor, setReturnToVendor] = useState(false);
  const [returnToVendorOverdue, setReturnToVendorOverdue] = useState(false);
  const [returnToVendorOverdue2, setReturnToVendorOverdue2] = useState(false);
  const [messageReturnToVendorOverdue, setMessageReturnToVendorOverdue] = useState('');
  const [isCheckedReturnToVendor2, setIsCheckedReturnToVendor2] = useState(false);

  const [returnToVendor2, setReturnToVendor2] = useState(false);
  const [enableSecondEmailRTV, setEnableSecondEmailRTV] = useState(false);
  const [enableThirdEmailRTV, setEnableThirdEmailRTV] = useState(false);

  const [firstEmailRTV,setFirstEmailRTV] = useState('');
  const [secondEmailRTV,setSecondEmailRTV] = useState('');
  const [thirdEmailRTV,setThirdEmailRTV] = useState('');
  const [isFirstRTVEmailInvalid,setIsFirstRTVEmailInvalid] = useState(true);
  const [errorMessageReturnToVendor2Modal, setErrorMessageReturnToVendor2Modal] = useState('');

  const [enableRenderTextAreaReasonReject, setEnableRenderTextAreaReasonReject] = useState(false);
  const [returnToVendor3, setReturnToVendor3] = useState(false);

  const [returnToVendor4, setReturnToVendor4] = useState(false);
  const [rtvReasonRejection, setRtvReasonRejection] = useState({label:'',value:''});
  const [rtvReasonOtherRejection, setRtvReasonOtherRejection] = useState('');
  const [rtvAttachmentToSave, setRtvAttachmentToSave] = useState({});
  const [commentToRtv, setCommentToRtv] = useState('');

  //useState cancel return to vendor
  const [cancelReturnToVendor, setCancelReturnToVendor] = useState(false);
  const [reasonToCancelRejection, setReasonToCancelRejection] = useState('');

  
  const [lDeptos, setLDeptos] = useState([]);
  const [lMinors, setLMinors] = useState([]);
  const [lProyects, setLProyects] = useState([]);
  const [lBalanceSheet, setLBalanceSheet] = useState([]);
  const [lCommSerial, setLCommSerial] = useState([]);
  const [lCommWithUniques, setLCommWithUniques] = useState([]);

  const [iERPCommoditiesList,setIERPCommodityList] = useState([]);
  const [ierpGlAccounts,setIerpGlAccounts] = useState([]);
  const [ierpGlAccountsToShow,setIerpGlAccountsToShow] = useState(ACCOUNT_JAPAN_SEARCH_INPUT);  
  const [ierpCostCenterToShow,setIerpCostCenterToShow] = useState(ACCOUNT_JAPAN_SEARCH_INPUT);  
  const [ierpInternalOrderToShow,setIerpInternalOrderToShow] = useState(ACCOUNT_JAPAN_SEARCH_INPUT);
  
  const [ierpWbs,setIerpWbs] = useState([]);
  const [ierpWbsToShow,setIerpWbsToShow] = useState(ACCOUNT_JAPAN_SEARCH_INPUT);
  
  const [ierpProfitCenterToShow,setIerpProfitCenterToShow] = useState(ACCOUNT_JAPAN_SEARCH_INPUT);

  const [ierpTransactionType,setIerpTransactionType] = useState([]);
  const [ierpTransactionTypeToShow,setIerpTransactionTypeToShow] = useState(ACCOUNT_JAPAN_SEARCH_INPUT);
  
  const [ierpWithholding,setIerpWithholding] = useState([]);
  const [ierpCommSpecials,setIerpCommSpecials] = useState([]);
  const [ierpPaymentTerms,setIerpPaymentTerms] = useState([]);
  const [rtvReasonList,setRtvReasonList] = useState([]);

  const [sumReceptions, setSumReceptions] = useState();

  const [caapsDepartmentToShow,setCaapsDepartmentToShow] = useState(DEPARTMENT_CAAPS_SEARCH_INPUT);  
  const [caapsMinorToShow,setCaapsMinorToShow] = useState(MINORS_CAAPS_SEARCH_INPUT);  
  const [caapsProjectsToShow,setCaapsProjectsToShow] = useState(PROJECT_CAAPS_SEARCH_INPUT);  
  const [defaultBalanceSheet,setDefaultBalanceSheet] = useState('')

  const [departmentAccountToInput,setDepartmentAccountToInput] = useState(EMPTY_DEPARTMEMT_CAAPS_STATE);
  const [minorAccountToInput,setMinorAccountToInput] = useState(EMPTY_MINORS_CAAPS_STATE);
  const [projectAccountToInput,setProjectAccountToInput] = useState(EMPTY_PROJECT_CAAPS_STATE);
  const [keyCountBalanceSheet,setKeyCountBalanceSheet] = useState(0);
  const [showRemoveEmailRTV,setShowRemoveEmailRTV] = useState(false);

  
  const [documentIAS, setDocumentIAS] = useState([]);

  const [countryWithRTV,setCountryWithRTV] = useState(false);
  const [countryWithHold, setCountryWithHold] = useState(false);

  //start useReff for invoice information
  const isIPVN = useRef(false);
  const isNCE = useRef(false);
  const isNC = useRef(false);
  const isNonPO = useRef(false);
  const typeFlow = useRef('');
  const wasPaid = useRef(false);
  const isHold = useRef(false);
  const isRTV = useRef(false);
  const isRelatedUser = useRef(false);
  const wentToConfiar = useRef(false);
  const isViewer = useRef(false);  
  const nextApproverMail = useRef('');
  const realNextApproverMail = useRef('');
  const docStatus = useRef('');
  const isAwaiting = useRef('');
  const hasTurn = useRef(false);
  const wasExported = useRef(false);
  const wasFinalized = useRef(false);
  const isSecondRequired = useRef(false);
  const hasUniqueExpenditure = useRef(false);
  const directDebit = useRef('N');
  const directDebitEnable = useRef(false);
  const loggedUserStatusInInvoice = useRef('');
  const actualUserWithTurnStatus = useRef('');
  const previousEffectiveApprover = useRef('');
  const previousApproverAction = useRef('');
  const isLoggedUserPreviousEffectiveApprover = useRef(false);
  const wentToComfiar = useRef(false);
  const actualRol = useRef('');
  const zone = useRef('');
  const isForeignInvoice = useRef(false);
  const japanLocalCurrency = useRef('JPY');
  
  const disabledRTV = useRef(false);
  const legalDevolutionTimeExpired = useRef(false);
  const rtvIsProhibited = useRef(false);
  const rtvAndHoldPrOverdue = useRef(false);
  
  //set invoice ref for Comment modal
  const newComment = useRef('');

  //start useStates for actions Buttons
  
  const [enableCancelApprovalButtons, setEnableCancelApprovalButtons] = useState(false);
  const [enableRejectButtons, setEnableRejectButtons] = useState(false);
  const [enableCancelRTVButton, setEnableCancelRTVButton] = useState(false);
  const [enableCancelHoldButton, setEnableCancelHoldButton] = useState(false);
  const [enableAllOptionsButtons, setEnableAllOptionsButtons] = useState(true);
  const [enableReassingButton, setEnableReassingButton] = useState(false);
  const [enableCommonUserButtonOption, setEnableCommonUserButtonOption] = useState(true);

  const [enableRejectMessageForApprovedInvoices, setEnableRejectMessageForApprovedInvoices] = useState(false);

  //Start useState for dinamic header tables
  const [headersAccountingUnit, setHeadersAccountingUnit] = useState([]);   

  //start useState commodities for LA controller
  const [changeCommodityLA, setChangeCommodityLA] = useState(false);  
  

  //start useStates selected by user
  const [commoditySelected, setCommoditySelected] = useState('');
  const commodityIsChange = useRef(false)
  const [departmentSelected, setDepartmentSelected] = useState('');
  const [minorSelected, setMinorSelected] = useState('');
  const [projectSelected, setProjectSelected] = useState('');
  const [balanceSheetSelected, setBalanceSheetSelected] = useState('');
  
  const accountRowOpen = useRef(0);  
  const [accountingTableKey, setAccountingTableKey] = useState('tableAccountingKey0');

  const [glAccountSelected,setGlAccountSelected] = useState('');
  const [costCenterSelected,setCostCenterSelected] = useState('');
  const [profitCenterSelected,setProfitCenterSelected] = useState('');
  const [internalOrderSelected,setInternalOrderSelected] = useState('');
  const [wbsSelected,setWbsSelected] = useState('');
  const [transactionTypeSelected,setTransactionTypeSelected] = useState('');
  
  const [itemDescription,setItemDescription] = useState('');
  const [withholdingId,setWithholdingId] = useState('');

  const [enableWithholdingPreSelectTable,setEnableWithholdingPreSelectTable] = useState(false);

  const [enableRenderingWithholdingIdInput,setEnableRenderingWithholdingIdInput] = useState(false);//this one is for enabling disabling rendering
  const [disableWithholdingIdInput,setDisableWithholdingIdInput] = useState(true);//this one is for enabling disabling HTML option
  const [withholdingIdDefaultValueSelected,setWithholdingIdDefaultValueSelected] = useState('');

  const [enableWithholdingSearchId,setEnableWithholdingSearchId] = useState(false);

  const [enableRenderingWithholdingTaxSelect,setEnableRenderingWithholdingTaxSelect] = useState(false);//this one is for enabling disabling rendering
  const [disabledWithholdingTaxSelect,setDisabledWithholdingTaxSelect] = useState(true); //this one is for enabling disabling HTML option
  const [withholdingCodeAndTypeSelected,setWithholdingCodeAndTypeSelected] = useState('');

  const [enableRenderOnShoreRadioButton,setEnableRenderOnShoreRadioButton] = useState(false);
  const [disableOnShoreRadioButtons,setDisableOnShoreRadioButtons] = useState(true);
  

  
  const [enableRenderOnShorePercentage,setEnableRenderOnShorePercentage] = useState(false);
  const [disableOnShorePercentage,setDisableOnShorePercentage] = useState(true);
  const [percentageOnshore,setPercentageOnshore] = useState(0);
  const [defaultPercentageOnshore,setDefaultPercentageOnshore] = useState('');
  const [onShoreValueSelected,setOnShoreValueSelected] = useState('');
  

  const [withholdingCodeDefaultValueSelect,setWithholdingCodeDefaultValueSelect] = useState('');
  const showModalForAddTaxApprover = useRef(false);
  
  const optionSelectedForCurrentWithholding = useRef('');

  const [errorMessageAccountingAp,setErrorMessageAccountingAp] = useState('');
  
  const [commcodeToInput, setCommcodeToInput] = useState({commcode:'',key:true})
  const [itemDescriptionToInput, setItemDescriptionToInput] = useState('')

  const [glAccountValueToInput1,setGlAccountValueToInput1] = useState(EMPTY_ACCOUNT_AP_STATE);
  const [costCenterValueToInput1,setCostCenterValueToInput1] = useState(EMPTY_ACCOUNT_AP_STATE);
  const [internalOrderValueToInput1,setInternalOrderValueToInput1] = useState(EMPTY_ACCOUNT_AP_STATE);
  const [wbsValueToInput1,setWbsValueToInput1] = useState(EMPTY_ACCOUNT_AP_STATE);

  const [glAccountValueToInput2,setGlAccountValueToInput2] = useState(EMPTY_ACCOUNT_AP_STATE);
  const [profitCenterValueToInput2,setProfitCenterValueToInput2] = useState(EMPTY_ACCOUNT_AP_STATE);
  const [internalOrderValueToInput2,setInternalOrderValueToInput2] = useState(EMPTY_ACCOUNT_AP_STATE);
  const [transactionTypeValueToInput2,setTransactionTypeValueToInput2] = useState(EMPTY_ACCOUNT_AP_STATE);

  const [glAccountValueToInput3,setGlAccountValueToInput3] = useState(EMPTY_ACCOUNT_AP_STATE);
  const [costCenterValueToInput3,setCostCenterValueToInput3] = useState(EMPTY_ACCOUNT_AP_STATE);
  const [profitCenterValueToInput3,setProfitCenterValueToInput3] = useState(EMPTY_ACCOUNT_AP_STATE);
  
  const [tabValuePreSelected,setTabValuePreSelected] = useState(0);

  //control for mandatory accounting fields
  //tab1
  const [enableMandatoryInternalOrderTab1,setEnableMandatoryInternalOrderTab1] = useState(false);
  const [enableMandatoryWbsTab1,setEnableMandatoryWbsTab1] = useState(false);
  //tab2
  const [enableMandatoryInternalOrderTab2,setEnableMandatoryInternalOrderTab2] = useState(true);
  const [enableMandatoryTransactionTypeTab2,setEnableMandatoryTransactionTypeTab2] = useState(true);
  //tab3
  const [enableMandatoryCostCenterTab3,setEnableMandatoryCostCenterTab3] = useState(true);
  const [enableMandatoryProfitCenterTab3,setEnableMandatoryProfitCenterTab3] = useState(true);

  //start use state for TableMenu and all the invoice table
  const [rowsSelectedFromAllInvoiceTable, setRowsSelectedFromAllInvoiceTable] = useState([]);

  const [selectedAccountingTabIndex, setSelectedAccountingTabIndex] = useState(0);
  const handleTabAccountingChange = (evt) => {
    setSelectedAccountingTabIndex(evt.selectedIndex);
  };
  
  const handleTabAccountingChangeAp = (evt) => {
    setSelectedAccountingTabIndex(evt.selectedIndex);
    setTabValuePreSelected(evt.selectedIndex)
  };

  // start useState for Approval Information table  
  const [newApproverId, setNewApproverId] = useState({});
  const DEFAULT_SELECTED_APPROVER = {name: "", mail: ""};
  const [selectedAppover, setSelectedAppover] = useState(DEFAULT_SELECTED_APPROVER);
  let preApprover = [];
  let newApprover = {
    "key": {
      "idDoc": 0,
      "requestId": 0
    },
    "order": 0,
    "orderExp": 0,
    "designatorMail": "",
    "designatorNotesId": "",
    "designatorName": "",
    "designatorOrderId": 0,
    "designationType": "",
    "originalMailApprover": "",
    "originalApproverNotesId": "",
    "originalApproverName": "",
    "effectiveApproverMail": "",
    "effectiveApproverNotesId": "",
    "effectiveApproverName": "",
    "role": "",
    "haveTurn": "",
    "turnDate": "",
    "turnTime": "",
    "action": "",
    "actionDate": "",
    "actionTime": "",
    "flagDeleted": "",
    "flagCanceled": "",
    "requestStatus": "",
    "orderIdAux": 0,
    "rolFE": "",
    "id": 0,
    "effectiveApproverNameFE": "",
    "isNew":true
  };  
  const [rowsApprovalInformation, setRowsApprovalInformation] = useState([]);
  const [invitedAfter, setInvitedAfter] = useState(true);
  const [lastApprover, setLastApprover] = useState(true);
  const [taxApprover, setTaxApprover] = useState(true);
  const [secondLastApprover, setsecondLastApprover] = useState(true);
  
  // start useState for Approval Unit
  const [headersApprovalUnit, setHeadersApprovalUnit] = useState([]); 
  
  const [rowsApprovalUnit, setRowsApprovalUnit] = useState([]);
  const [rowsAccountinglUnit, setRowsAccountinglUnit] = useState([]);  
  const [totalRowsApprovalUnit, setTotalRowsApprovalUnit] = useState([]);

  // start useState for Approval Unit
  const [vatTableKey, setVatTableKey] = useState('vatTableKey'); 
  const [headersVatUnit, setHeadersVatUnit] = useState([]); 
  const [rowsVatUnit, setRowsVatUnit] = useState([]); 

  const [withholdingTableKey, setWithholdingTableKey] = useState('withholdingTableKey'); 
  const [headersWithholdingUnit, setHeadersWithholdingUnit] = useState([]); 
  const [rowsWithholdingUnit, setRowsWithholdingUnit] = useState([]); 

  const [showWithholdingTaxes, setShowWithholdingTaxes] = useState(true);

  //for IERP payment selections

  const [disablePaymentWireTransferRadioButton,setDisablePaymentWireTransferRadioButton] = useState(false);
  const [disableManualPaymentTransferRadioButton,setDisableManualPaymentTransferRadioButton] = useState(false);
  const [disableDirectDebitTransferRadioButton,setDisableDirectDebitTransferRadioButton] = useState(false);
  const [disablePaymentTermSelect,setDisablePaymentTermSelect] = useState(false);
  
  const [paymentInfo,setPaymentInfo] = useState([]);
  const [paymentTermValueSelected,setPaymentTermValueSelected] = useState(EMPTY_PAYMENT_TERM_AP_STATE);
  const [paymentMethodSelected,setPaymentMethodSelected] = useState('');
  const [dueDateValueSelected,setDueDateValueSelected] = useState('');
  const [disableDueDatePicker,setDisableDueDatePicker] = useState(true);
  const [enableRenderDueDateSelection,setEnableRenderDueDateSelection] = useState(false);
  
  
  //for showing message and making cursong round for request
  const processingRequest = useRef(false);

  //for manager selecctions in last approver
  const [managersToShow,setManagersToShow] = useState({});


  //for modal error or information use
  const [messageModal, setMessageModal] = useState('');
  const messageResponse = useRef([]);  
  //setMessageResponse
  const [rowsForeingWithholding,setRowsForeingWithholding] = useState([])
  const [headersForeingWithholdingAp,setHeadersForeingWithholdingAp] = useState([
    {
      key:'taxetype',
      header:'Taxe Type'
    },
    {
      key:'taxecode',
      header:'Taxe Code'
    }
  ])

  //attachments Controllers
  const [approverAttachments, setApproverAttachments] = useState([]);
  const [supplierAttachments, setSupplierAttachments] = useState([]);
  const [approverAttachmentToSave,setApproverAttachmentToSave] = useState({});
  const [approverAttachmentIdToRemove,setApproverAttachmentIdToRemove] = useState('');

  //tax treaty controllers  
  const [enableRenderTaxTreatyRadioButtons,setEnableRenderTaxTreatyRadioButtons] = useState(false);
  const [renderTaxTreatyAttachmentUpload,setRenderTaxTreatyAttachmentUpload] = useState(false);
  const [taxTreatyAttachmentToSave,setTaxTreatyAttachmentToSave] = useState({});
  const [disabledTaxTreatySaveButton,setDisabledTaxTreatySaveButton] = useState(true);
  const [titleTaxTreatySaveButtons,setTitleTaxTreatySaveButtons] = useState('');
  
  const [disabledTaxTreatyRemoveButton,setDisabledTaxTreatyRemoveButton] = useState(true);
  const [titleTaxTreatyRemoveButtons,setTitleTaxTreatyRemoveButtons] = useState('');

  const [attachmentsForTaxTreaty,setAttachmentsForTaxTreaty] = useState([])
  const [invoiceHasTaxTreaty,setInvoiceHasTaxTreaty] = useState(false)
  const [taxTreatyIdToRemove,setTaxTreatyIdToRemove] = useState('');
  
  
  const myFileUploadRefference = useRef();
  const myApproverFileUploadRefference = useRef();
  const myRtvFileUploadRefference = useRef();

  //input Refference
  const inputSearchInviteEmployee = useRef(null);

  //hold payment modal
  const [holdPaymentModalS1, setHoldPaymentModalS1] = useState(false);
  const [holdPaymentModalS2, setHoldPaymentModalS2] = useState(false);
  const [holdPaymentModalS3, setHoldPaymentModalS3] = useState(false);
  const [holdPaymentModalS4, setHoldPaymentModalS4] = useState(false);
  const [holdPaymentModalS5, setHoldPaymentModalS5] = useState(false);

  const [holdPaymentCause, setHoldPaymentCause] = useState("");
  const [holdPaymentCauseLabel, setHoldPaymentCauseLabel] = useState("");
  const [holdPaymentJustification, setHoldPaymentJustification] = useState("");

  //cancel hold payment    
  const [cancelHoldPaymentModal, setCancelHoldPaymentModal] = useState(false);

  const japanLocalCurrencyDecimalQuantitiesLength = useRef(0);
  const japanForeignCurrencyDecimalQuantitiesLength = useRef(2);
  const decimalQuantitiesForAmount = useRef(3);
  const decimalQuantitiesForItemQuantity = useRef(3);
  
  const countriesWithAmountFourDecimals = useRef('862,847');

  const showRowSelectCell = (row) => {
    return rowShouldShowSelectRowCell(row) && employeeHasAccessToSeeRowSelectCell(row);
  }

  const rowShouldShowSelectRowCell = (row) => {
    return !rowShouldNotShowSelectRowCell(row)
  }

  const rowShouldNotShowSelectRowCell = (row) => {
    return row.cells[0].value === "AP Approver" || row.cells[0].value === "First Approver" || row.cells[0].value === "Ap Paper Approver" || row.cells[0].value === "Unique Expenditure";
  }

  const employeeHasAccessToSeeRowSelectCell = (row) => {
    return hasTurn.current && ((isApprovalTypeInRowInvited(row) && actualRol.current !== 'InvitedAfter') || actualRol.current === 'FirstApprover')
  }

  const isApprovalTypeInRowInvited = (row) => {
    return (row.cells[0].value == 'Tax Approver' || row.cells[0].value == 'Invited After');
  }

  const isDebitDocument = () => {
    return documentIAS.flowType != 'NC' && documentIAS.flowType != 'NCE';
  }

  //confirm specials categories
  const [confirmSpecialsCategories,setConfirmSpecialsCategories] = useState(false)
  const acceptedConfirmSpecialCategories = useRef(false);  
  
  //confirm modal
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmModalMessage, setConfirmModalMessage] = useState('');

  const [messageSessionLost, setMessageSessionLost] = useState('');

  //start controller error modal
  const openMessageModal = (response) => {    
    let newMessageResponse = [messageResponse.current,<br/>,<br/>,response];    
    messageResponse.current = newMessageResponse;
    setMessageModal(true);
  }

  const closeMessageModal = () => {
    setMessageModal(false);    
    messageResponse.current = [];
  }
    
  const setHeadersForReceptionUnitTable = (documentIas) => {
    let headersAccountingUnit = [];
    
    let headerAccountingUnit = {};
    headerAccountingUnit.key = 'checkbox';
    headerAccountingUnit.header = '';
    headersAccountingUnit.push(headerAccountingUnit);

    headerAccountingUnit = {};
    headerAccountingUnit.key = 'account';
    headerAccountingUnit.header = 'Account';
    headersAccountingUnit.push(headerAccountingUnit);
    
    if(documentIas.flowType == 'NORMAL' || documentIas.flowType == 'IPVN' || documentIas.flowType == 'NCE'){
      headerAccountingUnit = {};
      headerAccountingUnit.key = "ponumber";
      headerAccountingUnit.header = 'PO Number';
      headersAccountingUnit.push(headerAccountingUnit);

      headerAccountingUnit = {};
      headerAccountingUnit.key = "item";
      headerAccountingUnit.header = 'Item';
      headersAccountingUnit.push(headerAccountingUnit);

      headerAccountingUnit = {};
      headerAccountingUnit.key = "description";
      headerAccountingUnit.header = 'Description';
      headersAccountingUnit.push(headerAccountingUnit);

      headerAccountingUnit = {};
      headerAccountingUnit.key = 'quantity';
      headerAccountingUnit.header = 'Quantity';
      headersAccountingUnit.push(headerAccountingUnit);

      headerAccountingUnit = {};
      headerAccountingUnit.key = "price";
      headerAccountingUnit.header = 'Amount';
      headersAccountingUnit.push(headerAccountingUnit);
    }else{
      if(documentIas.zone === 'AP'){
        headerAccountingUnit = {};
        headerAccountingUnit.key = "commodity";
        headerAccountingUnit.header = 'Commodity';
        headersAccountingUnit.push(headerAccountingUnit);
      }else{
        headerAccountingUnit = {};
        headerAccountingUnit.key = "invonumb";
        headerAccountingUnit.header = 'Intreference';
        headersAccountingUnit.push(headerAccountingUnit);
      }

      headerAccountingUnit = {};
      headerAccountingUnit.key = "description";
      headerAccountingUnit.header = 'Commodity Description';
      headersAccountingUnit.push(headerAccountingUnit);

      if(documentIas.zone == 'AP' || (emeaVatSplitEnable && documentIas.zone == 'EMEA')){
        headerAccountingUnit = {};
        headerAccountingUnit.key = 'originalAmount';
        headerAccountingUnit.header = 'Original Amount';
        headersAccountingUnit.push(headerAccountingUnit);  
      }

      headerAccountingUnit = {};
      headerAccountingUnit.key = 'quantity';
      headerAccountingUnit.header = 'Quantity';
      headersAccountingUnit.push(headerAccountingUnit);

      headerAccountingUnit = {};
      headerAccountingUnit.key = 'amount';
      headerAccountingUnit.header = 'Amount';
      headersAccountingUnit.push(headerAccountingUnit);
    }  
    
    headerAccountingUnit = {};
    headerAccountingUnit.key = 'total';
    headerAccountingUnit.header = 'Total';
    headersAccountingUnit.push(headerAccountingUnit);

    if(documentIas.zone == 'AP' || (emeaVatSplitEnable && documentIas.zone == 'EMEA')){
      headerAccountingUnit = {};
      headerAccountingUnit.key = 'vatcode';
      headerAccountingUnit.header = 'VAT';
      headersAccountingUnit.push(headerAccountingUnit);
    }

    setHeadersAccountingUnit(headersAccountingUnit)
  }
  const headersApprovalInformation = [
    {
      key: 'rolFE',
      header: 'Approval Role',
    },
    {
      key: 'effectiveApproverNameFE',
      header: 'Name',
    },
    {
      key: 'realApprover',
      header: 'Real Approver',
    },
    {
      key: 'action',
      header: 'Status',
    },
    {
      key: 'actionDate',
      header: 'Approval Date',
    },
    {
      key: 'designatorMail',
      header: 'Invited By',
    }
  ];
  
  const openAccountingUnitModal = (id) => {
    accountRowOpen.current = id;
    if(documentIAS.zone === "AP")
      openIerpAccountingModal(id);
    else
      openCaapsAccountingModal(id) ;
  }
  
  const openCaapsAccountingModal = (id) => {
    setValuesOnCaapsAccountingModal(id);
    setAccountingUnitModal(true);
  }

  const setValuesOnCaapsAccountingModal = (id) => {
    if(actualRol.current === 'FirstApprover')
      return;
    let rowAccountSelected = getCurrentAccountSelectedById(id);
    if(rowAccountSelected === undefined)
      return;
    let department = {};
    department.key = {};
    department.key.depacode = '';
    department.depanumb = rowAccountSelected.department;
    department.depaname = '';
    department.disabled = true;
    setDepartmentAccountToInput(department);

    let minor = {};
    minor.minor = rowAccountSelected.minor;
    minor.disabled = true;
    setMinorAccountToInput(minor);

    let project = {};
    project.key = {};
    project.key.projecod = rowAccountSelected.project;
    setProjectAccountToInput(project);    
  }

  const openIerpAccountingModal = (id) => {
    setValuesOnAccountingApInputs(id);
    setAccountingUnitModalAP(true);
  }

  const setValuesOnAccountingApInputs = (id) => {
    let rowAccountSelected = getCurrentAccountSelectedById(id);
    if(rowAccountSelected === undefined)
      return;
    setInputsOnAccountingByScenary(rowAccountSelected)
    setCommoditySelected(rowAccountSelected.commodity)
    setReceptionForeignData(rowAccountSelected)
    
  }

  const setReceptionForeignData = async (rowAccountSelected) => {
    if(!isForeignInvoice.current){
      return;
    }
    console.log(rowAccountSelected)
    setOnShoreValueSelected(rowAccountSelected.onShoreSelection);
    setDefaultPercentageOnshore(rowAccountSelected.percentageOnShore);
    getCommodityForeignCategory(rowAccountSelected.commodity,rowAccountSelected);        
  }  

  const setWithholdingCodeAndTypeAlreadySelected = (rowAccountSelected) => {
    
    if(rowAccountSelected.whtaxecode === '' && rowAccountSelected.whtaxetype === ''){
      return;
    }
    let accountSelectedValue = rowAccountSelected.whtaxetype + '-' + rowAccountSelected.whtaxecode;
    setWithholdingCodeDefaultValueSelect(accountSelectedValue);
    console.log('finish first the default assignemtn')
  }

  const closeConfirmModal = () => {
    setConfirmModal(false);
  }

  const closeConfirmSpecialsCategories = () => {  
    setConfirmSpecialsCategories(false);
  }

  const openConfirmSpecialsCategories = () => {
    acceptedConfirmSpecialCategories.current = false;
    setConfirmSpecialsCategories(true);
  }

  const setInputsOnAccountingByScenary = (accountRow) => {  
    let commcodeObj = {};
    commcodeObj.commcode = accountRow.commodity;    
    commcodeObj.key = !commcodeToInput.key;
    setCommcodeToInput(commcodeObj);
    setItemDescription(accountRow.itemdesc);
    setItemDescriptionToInput(accountRow.itemdesc);
    if(accountRow.scenario != undefined && accountRow.scenario != ''){
      setTabValuePreSelected(Number.parseInt(accountRow.scenario)-1);
      setSelectedAccountingTabIndex(Number.parseInt(accountRow.scenario)-1)
    }
    cleanAllInputComboBoxForAccounts();
    if(accountRow.scenario == 1){    
      let accountToShowOnComboBox = {};
      accountToShowOnComboBox.code = accountRow.gl_acc;
      accountToShowOnComboBox.desc = '';      
      setGlAccountValueToInput1(accountToShowOnComboBox);

      let input = getInputForDefaultAccountState(accountRow.gl_acc);
      processSelectGlAccount(input,accountRow.scenario)

      accountToShowOnComboBox = {};
      accountToShowOnComboBox.code = accountRow.cost_center;
      accountToShowOnComboBox.desc = '';
      setCostCenterValueToInput1(accountToShowOnComboBox);

      input = getInputForDefaultAccountState(accountRow.cost_center);
      processSelectCostCenter(input);

      accountToShowOnComboBox = {};
      accountToShowOnComboBox.code = accountRow.int_ord;
      accountToShowOnComboBox.desc = '';      
      setInternalOrderValueToInput1(accountToShowOnComboBox);

      input = getInputForDefaultAccountState(accountRow.int_ord);
      processSelectInternalOrder(input);

      accountToShowOnComboBox = {};
      accountToShowOnComboBox.code = accountRow.wbs;
      accountToShowOnComboBox.desc = '';
      setWbsValueToInput1(accountToShowOnComboBox);

      input = getInputForDefaultAccountState(accountRow.wbs);
      processSelectWbs(input)
    }else if(accountRow.scenario == 2){    
      let accountToShowOnComboBox = {};
      accountToShowOnComboBox.code = accountRow.gl_acc;
      accountToShowOnComboBox.desc = '';      
      setGlAccountValueToInput2(accountToShowOnComboBox);

      let input = getInputForDefaultAccountState(accountRow.gl_acc);
      processSelectGlAccount(input,accountRow.scenario)

      accountToShowOnComboBox = {};
      accountToShowOnComboBox.code = accountRow.prof_center;
      accountToShowOnComboBox.desc = '';
      setProfitCenterValueToInput2(accountToShowOnComboBox);

      input = getInputForDefaultAccountState(accountRow.prof_center);
      processSelectProfitCenter(input);

      accountToShowOnComboBox = {};
      accountToShowOnComboBox.code = accountRow.int_ord;
      accountToShowOnComboBox.desc = '';      
      setInternalOrderValueToInput2(accountToShowOnComboBox);
      
      input = getInputForDefaultAccountState(accountRow.int_ord);
      processSelectInternalOrder(input);

      accountToShowOnComboBox = {};
      accountToShowOnComboBox.code = accountRow.trans_type;
      accountToShowOnComboBox.desc = '';
      setTransactionTypeValueToInput2(accountToShowOnComboBox);

      input = getInputForDefaultAccountState(accountRow.trans_type);
      processSelectTransactionType(input)
    }else if(accountRow.scenario == 3){    
      let accountToShowOnComboBox = {};
      accountToShowOnComboBox.code = accountRow.gl_acc;
      accountToShowOnComboBox.desc = '';      
      setGlAccountValueToInput3(accountToShowOnComboBox);

      let input = getInputForDefaultAccountState(accountRow.gl_acc);
      processSelectGlAccount(input,accountRow.scenario)

      accountToShowOnComboBox = {};
      accountToShowOnComboBox.code = accountRow.cost_center;
      accountToShowOnComboBox.desc = '';
      setCostCenterValueToInput3(accountToShowOnComboBox);

      input = getInputForDefaultAccountState(accountRow.cost_center);
      processSelectCostCenter(input)

      accountToShowOnComboBox = {};
      accountToShowOnComboBox.code = accountRow.prof_center;
      accountToShowOnComboBox.desc = '';      
      setProfitCenterValueToInput3(accountToShowOnComboBox);    

      input = getInputForDefaultAccountState(accountRow.prof_center);
      processSelectProfitCenter(input);
    }
  }

  const cleanAllInputComboBoxForAccounts = (scenaryId) => {
    let accountToShowOnComboBox = {};
    accountToShowOnComboBox.code = '';
    accountToShowOnComboBox.desc = '';      
    
    setGlAccountValueToInput1(accountToShowOnComboBox);
    setCostCenterValueToInput1(accountToShowOnComboBox)
    setInternalOrderValueToInput1(accountToShowOnComboBox)
    setWbsValueToInput1(accountToShowOnComboBox)
    setGlAccountValueToInput2(accountToShowOnComboBox)
    setProfitCenterValueToInput2(accountToShowOnComboBox)
    setInternalOrderValueToInput2(accountToShowOnComboBox)
    setTransactionTypeValueToInput2(accountToShowOnComboBox)
    setGlAccountValueToInput3(accountToShowOnComboBox)
    setCostCenterValueToInput3(accountToShowOnComboBox)
    setProfitCenterValueToInput3(accountToShowOnComboBox)    
    let input = getInputForDefaultAccountState('');
    input.selectedItem.desc = '';
    processSelectProfitCenter(input);
    processSelectCostCenter(input);
    processSelectGlAccount(input);
    processSelectTransactionType(input);
    processSelectInternalOrder(input);
    processSelectWbs(input);            
  }

  const getInputForDefaultAccountState = (inputValue) => {
    let input = {};
    let selectedItem = {code:inputValue};
    input.selectedItem = selectedItem;
    return input
  }

  const closeAccountinModal = () => {
    clearAccountUnitModal();
    setAccountingUnitModal(false);
  }

  const clearAccountUnitModal = () => {
    setDepartmentAccountToInput(EMPTY_DEPARTMEMT_CAAPS_STATE);
    setMinorAccountToInput(EMPTY_MINORS_CAAPS_STATE);
    setProjectAccountToInput(EMPTY_PROJECT_CAAPS_STATE);    
    setKeyCountBalanceSheet(keyCountBalanceSheet+1);
  }

  const closeAccountinModalAP = () => {
    setAccountingUnitModalAP(false);
  }
  const openFindEmployeesModal = () => {
    setInvitedEmployee("");
    setInvitedEmployeeResponse([]);
    employeeModalAction.current = 'invite';
    openSearchEmployeeModal()
    approverSelectUpdate();
  }
  const closeFindEmployeesModal = () => {
    setInvitedEmployee("");
    inputSearchInviteEmployee.current.value = '';
    closeSearchEmployeeModal();
    setInvitedEmployeeResponse([]);
  }

  const openReassignModal = () => {
    employeeModalAction.current = 'reassign';
    if(actualRol.current === 'FirstApprover' || actualRol.current.includes('Invited') || actualRol.current === 'UniqueExpenditure'){
      findManagerOrAuthorized.current = 'N'
    }else{
      findManagerOrAuthorized.current = 'Y'
    }
    openSearchEmployeeModal()
  }

  const openSearchEmployeeModal = () => {
    setSelectedAppover(DEFAULT_SELECTED_APPROVER)
    setFindEmployeesModal(true);
  }

  const closeSearchEmployeeModal = () => {
    setFindEmployeesModal(false);
  }

  const selectNewApprover = (selectEmployee) => {
    setSelectedAppover(selectEmployee);
  }

  const processEmployeeSelected = () => {
    if(employeeModalAction.current === 'reassign'){
      finalSubmitRequest('Reassign');
      closeFindEmployeesModal();
    }else if(employeeModalAction.current === 'invite'){
      addInvitedEmployee();
    }
  }

 
  const addInvitedEmployee = (managerSelected) => {

    let newApproverSelected = selectedAppover;
    if((managerSelected != null || managerSelected != undefined)){
      newApproverSelected = managerSelected;
    }
    if(newApproverSelected.mail.includes('Please enter 4 or more characters') || newApproverSelected.mail.trim() === ''){
      return;
    }
    

    if((managerSelected === null && selectedAppover === null) || (selectedAppover.mail === '' &&  managerSelected === null)){
      return;
    }
    setApprovalRole("Select role");
    if(newApprover.role === "LastApprover") {
      setLastApprover(false);
    };
    if(newApprover.role === "InvitedAfter") {
      setInvitedAfter(false);
    };
    if(newApprover.role === "SecondLastApprover") {
      setsecondLastApprover(false);
    };
    if(newApprover.role === "TaxApprover") {
      setTaxApprover(false);
    };
    newApprover.rolFE = approvalRole;
    newApprover.role = approvalRole === "Second Last Approver" ? "SecondLastApprover" : approvalRole === "Invited After" ? "InvitedAfter" : approvalRole === "Last Approver" ? "LastApprover" : approvalRole === "Tax Approver" ? "TaxApprover" : approvalRole;
    newApprover.designatorMail = user;
    newApprover.effectiveApproverName = newApproverSelected.name;
    newApprover.effectiveApproverMail = newApproverSelected.mail;
    newApprover.id = documentIAS.approvalRequests.length >= 0 ? documentIAS.approvalRequests.length : 0;
    newApprover.effectiveApproverNameFE = newApproverSelected.name + " => " + newApproverSelected.mail;
    newApprover.key.idDoc = idDoc;
    newApprover.key.requestId = documentIAS.approvalRequests.length >= 0 ? documentIAS.approvalRequests.length : 0;
    setDocumentIAS(documentIAS => ({ ...documentIAS, approvalRequests: [...documentIAS.approvalRequests, newApprover] }));
    closeFindEmployeesModal();
  };

  const selectRol = (e) => {
    setApprovalRole(e.target.value);    
  }
  
  const searchInvitedEmployee = (key) => {
    if(key.length <= 3){
      return;
    }
    let request = {};
    request.clave = key;
    request.manager = findManagerOrAuthorized.current;
    if(isRequestActive(true)){
      return;
    }
    getListMailNameEmployeeByKey(request)
    .then(response => {
      if(response.status === 200){
        response.json()
        .then(response => {          
          setInvitedEmployeeResponse(response.length != 0 ? response : [{name: "", mail: "No result found with that key, try another word."}]);
          isRequestActive(false)
        })
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      }  
    });
  };
  
  const closeCommentModal = () => {
    setCommentModal(false);
  }

  const openCommentModal = () => {
    setCommentModal(true);
  }

  const submitCommentModal = () => {
    let newDocumentIas = documentIAS;
    newDocumentIas.comment = newComment.current;
    finalSubmitRequest('Comment');
    setDocumentIAS(newDocumentIas);
    closeCommentModal();
  }

  const updateComment = (value) => {
    newComment.current = value;        
  }
  //end modal comments controllers

  //start modal approval controller
  const openApprovalModal = () => {
    if(documentIAS.zone === 'AP'){
      processIerpApproval()
    }else{
      processApproval();
    }    
  }

  const processApproval = () => {
    setApprovalModal(true);
    setMessageForModalApproveInvoice(DEFAULT_APPROVE_MESSAGE);    
  }

  const processIerpApproval = () => {
    
    let isAccountCorrect = rowsAccountinglUnit.every((rowReception) => {
      if(rowReception.account === '' || rowReception.account===undefined){
        return false;
      }else{
        return true;
      }
    })
    if(!isAccountCorrect){
      openMessageModal("Please check missing information in field Account on Reception Unit Table.");
      return false;
    }

    if(paymentMethodSelected === ''){
      openMessageModal("You must select a payment method to approve this invoice.");
      return false;
    }

    if(actualRol.current.includes("First")){
      if(dueDateValueSelected === '' && enableRenderDueDateSelection && (paymentTermValueSelected.code==='')){
        openMessageModal("You must complete the due date or payment term field")
        return;
      }else if(dueDateValueSelected === '' && paymentTermValueSelected.code===''){
        openMessageModal("You must complete the payment term field");
        return;
      }      
    }
    setApprovalModal(true);
    setMessageForModalApproveInvoice(DEFAULT_APPROVE_MESSAGE)
    if(actualRol.current.includes('TaxApprover') && documentIAS.ctrycode === '760'){
      setMessageForModalApproveInvoice("By clicking approve button, means you are approving WHT tax treatment for this payment request.");
    }else if((documentIAS.zone === 'AP') && !(actualRol.current.includes('First') || actualRol.current.includes('Last'))){
      setMessageForModalApproveInvoice("You are approving the invoice, do you confirm?");
    }
  }

  const closeApprovalModal = () => {
    setApprovalModal(false)
  }
  
  const submitApprovalModalWithComodityConfirmation = async () => {
    acceptedConfirmSpecialCategories.current = true;
    submitApprovalModal();
    closeConfirmSpecialsCategories();
  }

  const submitApprovalModal = async () => {
    let action = 'Approve';
    closeApprovalModal();
    if(documentIAS.zone === 'AP'){
      if(!isRequestDataValidForIerp(action)){
        return;
      }
    }else{
      if(!isRequestDataValidForCaaps(action)){
        return;
      }
    }
    
    await finalSubmitRequest(action)
  }

  //start return to vendor modal controller
  const openReturnToVendor = () => {
    setReturnToVendor(true);
  }

  const closeReturnToVendor = () => {
    setReturnToVendor(false);
  }

  const submitReturnToVendor = () => {
    closeReturnToVendor();
    
    if(legalDevolutionTimeExpired.current && rtvAndHoldPrOverdue.current){
      if(documentIAS.ctrycode === '815') {
        setMessageReturnToVendorOverdue(MESSAGEPR);
      }else{
        setMessageReturnToVendorOverdue('This action is not allowed as the '+
          'due date of the invoice is going to be in five days, less or has '+
          'already being exceeded');
      }
      openReturnToVendorOverdue()
    }else if(legalDevolutionTimeExpired.current && rtvIsProhibited.current){
      setMessageReturnToVendorOverdue('This action exceeds the legal period to RTV an invoice, you could Hold ' +
        'the invoice, going through the Hold button, but have in mind that this action is very sensitive because you are ' +
        'stopping the payment and you have to get and you have to attach the evidence for this holding');
      openReturnToVendorOverdue()
    }else if(legalDevolutionTimeExpired.current && !rtvIsProhibited.current){
      openReturnToVendorOverdue2()
    }else{
      openReturnToVendor2();
    }
    
  }

  //start return to vendor overdue modal controller
  const openReturnToVendorOverdue = () => {
    setReturnToVendorOverdue(true);
  }

  const closeReturnToVendorOverdue = () => {
    setReturnToVendorOverdue(false);
  }

  //start return to vendor 2 overdue modal controller
  const openReturnToVendorOverdue2 = () => {
    setReturnToVendorOverdue2(true);
  }

  const closeReturnToVendorOverdue2 = () => {
    setReturnToVendorOverdue2(false);
  }

  const submitReturnToVendorOverdue2 = () => {
    closeReturnToVendorOverdue2();
    openReturnToVendor2();
  }

  //start return to vendor 2 modal controller
  const closeReturnToVendor2 = () => {
    setReturnToVendor2(false);
  }

  const openReturnToVendor2 = () => {
    setReturnToVendor2(true);
  }

  const submitReturnToVendor2 = () => {    
    let errorMessage = validateEmailsLoadedFromRTV();
    setErrorMessageReturnToVendor2Modal(errorMessage);
    if(errorMessage != '')
      return;    
    closeReturnToVendor2();
    openReturnToVendor3();
  }

  const validateFirstEmail = (email) => {
    
    if(isEmailValid(email)){
      setFirstEmailRTV(email)
      setIsFirstRTVEmailInvalid(false);
    }else{
      setIsFirstRTVEmailInvalid(true);
    }
  }

  const validateEmailsLoadedFromRTV = () => {
    let emailsLoaded = [firstEmailRTV,secondEmailRTV,thirdEmailRTV];
    let emailIsWrongMessage = '';
    emailsLoaded.map((emailLoaded,index) => {
      if(emailLoaded != ''){
        if(!isEmailValid(emailLoaded)){
          emailIsWrongMessage=EMAIL_IS_NOT_CORRECT_FORMAT;
        }
        if(isEmailFromIBMER(emailLoaded) && documentIAS.zone === 'LA'){
          emailIsWrongMessage = EMAIL_IS_FROM_IBMER;
        }
      }           
    })
    console.log(emailIsWrongMessage);
    return emailIsWrongMessage;
  }

  const isEmailFromIBMER = (email) => {
    return email.toLowerCase().includes('ibm.com');
  }

  const isEmailValid = (email) => {
    let emailReg=/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;   
      return emailReg.test( email );          
   };

  //start return to vendor 3 modal controller 
  const closeReturnToVendor3 = () => {
    setReturnToVendor3(false);
  }

  const openReturnToVendor3 = () => {
    setReturnToVendor3(true);
  }

  const submitReturnToVendor3 = () => {
    if(rtvReasonRejection.label === ''){
      return;
    }

    if(rtvReasonRejection.label === 'Others' && rtvReasonOtherRejection ===''){
      return;
    }
    
    if(rtvAttachmentToSave.name === undefined && documentIAS.zone !== 'AP'){
      return;
    }
    closeReturnToVendor3();
    openReturnToVendor4();
  }

  const submitReturnToVendor4 = async () => {
    let request = new FormData();
    request.append('accion', 'RTV');
    request.append('tipoReject', 'RTV');
    request.append('idDoc', documentIAS.idDoc);
    request.append('fuera_periodo', false);
    request.append('emailRTV', firstEmailRTV);
    if(secondEmailRTV !== ''){
      request.append('emailRTV',firstEmailRTV +','+secondEmailRTV)
    }
    if(thirdEmailRTV !== ''){
      request.append('emailRTV',firstEmailRTV +','+secondEmailRTV +','+thirdEmailRTV);
    }
    request.append('reasonRTV', rtvReasonRejection.value)
    if(rtvReasonRejection.label === 'Others'){
      request.append('otherReasonRTV', rtvReasonOtherRejection);
    }
    request.append('comentariosRTV',commentToRtv);
    request.append('file',rtvAttachmentToSave);
    request.append('con_soporte',rtvAttachmentToSave.name !== undefined);

    if(isRequestActive(true)){
      return;
    }
    await postReturnToVendor(request)
    .then(async response => {
      if(response.status === 200){              
        await getAllDocument(documentIAS.idDoc);
        window.location.reload();
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      }else{
        response.text()
          .then(response => {            
            openMessageModal(response);
          })
      }
    });
    
    isRequestActive(false)
    closeReturnToVendor4();
  }

  const openReturnToVendor4 = () => {
    setReturnToVendor4(true);
  }
  const closeReturnToVendor4 = () => {
    setReturnToVendor4(false);
  }
  const processCommentToRtv = (value) => {
    setCommentToRtv(value);
  }

  const processSelectionReasonRtv = (selectedOptions) => {
    
    setRtvReasonRejection(selectedOptions[0]);
    let isOtherSelected = selectedOptions[0].label === 'Others';
    setEnableRenderTextAreaReasonReject(isOtherSelected);    
  }

  const processRejectionAttachment = (input) => {
    let files = input.target.files;
    let fileFound = false;
    if(files[0] != undefined){
      fileFound = true;
    }
    if(!fileFound){
      return;
    }
    setRtvAttachmentToSave(files[0]);
  }

  const addNewEmail = () => {
    setShowRemoveEmailRTV(true);
    if(!enableSecondEmailRTV){
      setEnableSecondEmailRTV(true)
      return;
    }
    if(!enableThirdEmailRTV){
      setEnableThirdEmailRTV(true)
    }      
  }

  const removeNewEmail = () => {
    if(enableThirdEmailRTV){
      setEnableThirdEmailRTV(false)
      setThirdEmailRTV('');
      return;
    }
    if(enableSecondEmailRTV){
      setSecondEmailRTV('');
      setEnableSecondEmailRTV(false)
      setShowRemoveEmailRTV(false);
      return;
    }      
  }

  //start cancel return to vendor
  const openCancelReturnToVendor = () => {
    setCancelReturnToVendor(true);
  }

  const closeCancelReturnToVendor = () => {
    setCancelReturnToVendor(false);
  }
  
  const processSetReasonToCancelRejection = (inputValue) => {
    setReasonToCancelRejection(inputValue);
  }

  const submitCancelRejection = async (action) => {
    let request = {};
    
    request.justificacion = reasonToCancelRejection;
    if(request.justificacion.trim() === ''){
      return;
    }
    request.accion = action;
    request.idDoc = documentIAS.idDoc;
    if(isRequestActive(true)){
      return;
    }
    await postCancelReturnToVendor(request)
    .then(async response => {
      if(response.status === 200){
        
        await getAllDocument(documentIAS.idDoc);
        window.location.reload();
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      }else{
        response.text()
          .then(response => {
            openMessageModal(response);
          })
      }
    });
    isRequestActive(false)
    closeCancelReturnToVendor();
    closeCancelHoldPaymentModal();
  }

  //start direct debit controller
  const changeDirectDebit = (value) => {
    documentIAS.directDebit = value;
    setDocumentIAS(documentIAS);
  }

  const finalSubmitRequest = async (action) => {
    let requestBody = {};
    requestBody.accion = action;
    requestBody.idDoc = documentIAS.idDoc;
    
    if(action === 'Approve' || action === 'Save'){
      requestBody = getApprovalData(action,requestBody);
    }    
        
    requestBody.reassignedTo = selectedAppover.mail.trim();
    requestBody.listaDesignados = getDesignatesList();    

    if(action === 'Comment'){
      requestBody.comment = newComment.current;
    }  
    
    if(isRequestActive(true)){
      return;
    }
    let pageIsGoingToReload = false;
    await responderPedidoSrv(requestBody)
    .then(async response => {
      if(response.status === 200){   
        openMessageModal("Request was Successful");
        if(requestBody.accion === 'Approve'){
          pageIsGoingToReload = true;
          setTimeout(function(){
            goHomeScreen();
          }, 2000);
        }
        if(action !== 'Comment' && action !== 'Approve'){
          await getAllDocument(documentIAS.idDoc);
          window.location.reload();
        }
      }else if(response.status === 410) {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      }else{
        response.text()
          .then(response => {            
            openMessageModal(response);
          })
      }      
    });      
    if(!pageIsGoingToReload) {
      isRequestActive(false);
    }
  }

  const cancelApproval = () => {
    finalSubmitRequest('CancelApproval');
  }
  
  const isRequestActive = (enable) => {
    if(enable){
      if(processingRequest.current){
        openMessageModal('The request is processing');
        return true;
      }
      document.body.className = 'waiting';
      processingRequest.current = enable;      
      return false;
    }else{
      processingRequest.current = enable;
      document.body.className = '';
    }
    return false;
  }

  const getApprovalData = (action, requestBody) => {
    if(documentIAS.zone === 'AP'){
      requestBody = getDataForIERP(action,requestBody);
    }else{
      requestBody = getDataForCaaps(requestBody);
    }
    return requestBody;
  }

  const getDataForCaaps = (requestBody) => {
    
    if(actualRol.current.includes('First') || actualRol.current.includes('Invited')){
      if(directDebitEnable.current){
        requestBody.isInvoiceDirectDebit = documentIAS.directDebit;
      }
    }

    if(documentIAS.zone == 'LA' && commodityIsChange){
      requestBody.commodity = commoditySelected;
    }

    let listReceptions = [];
    listReceptions = getReceptionsUnitsForSubmit();
    requestBody.listaRU = listReceptions;
    console.log("request body to submit => ",requestBody);

    return requestBody;
  }

  const isRequestDataValidForCaaps = (action) => {
    if(typeFlow.current === 'NONPO' && zone.current === 'LA' && actualRol.current === 'FirstApprover'){
      if(newComment.current === ''){
        openMessageModal(COMMENT_FIELD_MANDATORY);
        return false;
      }
    }

    if(!isReceptionAmountsValid(action)){
      return false;
    }
    if(typeFlow.current === 'NONPO' || typeFlow.current === 'NC'){
      if(isAccountFieldEmpty()){
        openMessageModal('Please, add the department or project in all Reception Unit rows');
        return false;
      }
      if(isCommodityWithRestriction() && actualRol.current==='FirstApprover' && !acceptedConfirmSpecialCategories.current){
        openConfirmSpecialsCategories();        
        return false;
      }
    }

    return true;
  }

  const isCommodityWithRestriction = () => {
    let categories = 'X42,XW3,XW4';
    let hasRestricted = false; 
    
    rowsAccountinglUnit.every((element) => {
      if(zone.current === 'LA'){
        categories.split(',').forEach(category => {
          if(element.description.includes(category)){
            hasRestricted = true;
          }				
        });
      }else{
        if(categories.includes(element.commcode)){
          hasRestricted = true;
        }
      }
    });
    return hasRestricted;
  }

  const isAccountFieldEmpty = () => {
    let isOneAccountEmpty = !rowsAccountinglUnit.every((e) => {
      if(e.account === '' || e.account === undefined || e.account === null){
        return false;
      }else{
        return true;
      }
    })
    return isOneAccountEmpty;
  }

  const getDataForIERP = (action,request) => {    
    
    if(action === 'Approve' || action === 'Save'){
      request.payMethod = paymentMethodSelected;
      if((paymentTermValueSelected.code !== 'Select' && paymentTermValueSelected.code !== '')){
        request.payTerm = paymentTermValueSelected.code;
      }else if(dueDateValueSelected !== '' && enableRenderDueDateSelection){
        request.dueDate = dueDateValueSelected;
      }
    }

    request.commodity = commoditySelected;
    request.taxtreatyaccess = '';
    if(enableRenderTaxTreatyRadioButtons){
      request.taxtreatyaccess = invoiceHasTaxTreaty ? 'Y' : 'N';
    }    

    request.listaRU = getIERPReceptionsUnitsForSubmit();
    return request;
  }
  

  const isRequestDataValidForIerp = (action) => {
    return isReceptionAmountsValid(action);
  }

  const isReceptionAmountsValid = (action) => {
    if(action === 'Approve' || action === 'Save'){
      if(typeFlow.current === 'NONPO' || typeFlow.current === 'NC'){
        if(isAtLeastOneReceptionQuantityEmpty()){
          openMessageModal('Please, add the quantity in all Reception Unit rows');
          return false;
        }
        if(!isAmountOk()){
          openMessageModal('The total reception unit is incorrect');
          return false;
        }
      }
    }
    return true;
  }

  const isAtLeastOneReceptionQuantityEmpty = () => {
    let isAllAmountLoaded = rowsAccountinglUnit.every((e) => {
      if(e.amount === '' || e.amount === undefined || e.amount === null){
        return false;
      }else{
        return true;
      }
    })
    return !isAllAmountLoaded;
  }

  const isAmountOk = () => {
    let substraction = Number(parseFloat(documentIAS.netAmount).toFixed(decimalQuantitiesForAmount.current)) - Number(parseFloat(sumReceptions).toFixed(decimalQuantitiesForAmount.current));
    return substraction === 0;
  }

  const getIERPReceptionsUnitsForSubmit = () => {
    let receptions = [];

    rowsAccountinglUnit.forEach((e,index) => {
      let reception = {};
      reception.row = index+1;
      reception.account = e.account;
      reception.poNumber = documentIAS.invonumb;
      reception.quantity = e.invoiceQty;
      reception.unitPrice = e.amount;
      reception.description = e.description;
      if(e.description.includes('-') && e.description.indexOf('-') === 3){
        reception.description = e.description.substr(4);
      }
      reception.commcode = e.commodity;
      reception.vatcode = e.vatCode;
      reception.vatdesc = e.vatDesc

      reception.whtaxcode = e.whtaxecode === 'EMPTY' ? '' : e.whtaxecode;
      reception.whtaxtype = e.whtaxetype === 'EMPTY' ? '' : e.whtaxetype;
      reception.withholdingid = e.withholdingscenaryid === 'EMPTY' ? '' : e.withholdingscenaryid;
      reception.onShoreSelection = e.onShoreSelection;
      reception.percentageOnShore = e.percentageOnShore;
      receptions.push(reception);
    })
    return receptions;
  }

  const getDesignatesList = (action) => {
    let designates = [];
    documentIAS.approvalRequests.forEach((e,index) => {
      let isNew = false;
      if(e.isNew || (action === 'Save' && actualRol.current.includes("First") && !e.rolFE.includes('First') && index>0)){
        isNew = true;
      }else if(actualRol.current === 'FirstApprover' && index > 0){
        isNew = true;
      }

      if(isNew){
        let obj = {};
        obj.mail = e.effectiveApproverMail.trim();
        obj.rol = e.role.trim();
        designates.push(obj);
      } 
    })
    return designates;
  }

  const getReceptionsUnitsForSubmit = () => {
    let receptions = [];
    rowsAccountinglUnit.forEach((rowReception,index) => {
      let reception = {};
      reception.row = index + 1;
      reception.account = rowReception.account;
      if(typeFlow.current == 'NONPO' || typeFlow.current == 'NC'){
        reception.poNumber = rowReception.invonumb;
      }else{
        reception.poNumber = rowReception.ponumber;
      }
      reception.quantity = rowReception.quantity;
      reception.unitPrice = rowReception.amount;
      reception.description = rowReception.description;
      if(reception.description.includes('-') && reception.description.indexOf('-') == 3){
        reception.description = reception.description.substr(4);
      }
      reception.commcode = rowReception.commodity;
      if(emeaVatSplitEnable){
        reception.vatcode = rowReception.vatCode;
        reception.vatdesc = rowReception.vatDesc
      }
      receptions.push(reception);
    });
    console.log("receptions to submit => ",receptions)
    return receptions;
  }

  const processCommoditySelected = (value) => {
    if(zone.current === 'AP' && isForeignInvoice.current){
      getCommodityForeignCategory(value);
    }
    commodityIsChange.current = true;
    setCommoditySelected(value);
  }

  const getCommodityForeignCategory = (commcode,rowAccountSelected) => {    
    let request = {};
    if(commcode === undefined || commcode === 'undefined' )
      return;
    request.commcode = commcode;
    request.ctrycode = documentIAS.ctrycode;
    request.compcode = documentIAS.compcode;
    request.invonumb = documentIAS.invonumb;
    
    getCategoryCommcodeIerp(request)
    .then(response => {
      if(response.status === 200){
        response.text()
          .then(response => {
            processWithholdingOption(response);
            if(rowAccountSelected !== undefined)
              setWithholdingCodeAndTypeAlreadySelected(rowAccountSelected)
          })
        }else if(response.status === 410)   {
          response.text()
            .then(res => {
              setMessageSessionLost(res)                             
            })
        }else{
        response.text()
          .then(response => {
            openMessageModal(response);
          })
      }
    });
  }

  const processWithholdingOption = async (withholdingOption) => {
    setEnableWithholdingPreSelectTable(false);
    setEnableWithholdingSearchId(false);
    setEnableRenderingWithholdingIdInput(false);
    setEnableRenderingWithholdingTaxSelect(false);
    setEnableRenderOnShoreRadioButton(false);
    setEnableRenderOnShorePercentage(false);
    setDisableOnShoreRadioButtons(true);
    setDisableOnShorePercentage(true);
    setWithholdingId('');
    setWithholdingIdDefaultValueSelected('');
    
    setRowsForeingWithholding([]);
    optionSelectedForCurrentWithholding.current = '';

    let isSpecialCategory = false;
    let withholdingValues = withholdingOption.split(',');
    let inputOption = withholdingValues[0];
    let taxOption = withholdingValues[1];
    let approver = withholdingValues[2];

    if(taxOption === undefined) taxOption = '';

    if((taxOption.includes('select')) && (inputOption == 'taxcode')){
      processWithholdingSelectOption(inputOption,taxOption,approver);
      isSpecialCategory = true;
    }else if((taxOption == 'input') && (inputOption == 'id')){
      processWithholdingInputOption(inputOption,approver);
      isSpecialCategory = true;
    }else if(((!taxOption.includes('select') && inputOption == 'taxcode') || (taxOption != 'input' && inputOption == 'id'))){
      setDefaultWithholdingValue(inputOption,taxOption);
      isSpecialCategory = true;
    }
    if(isSpecialCategory){
      setEnableRenderOnShoreRadioButton(true);
      if(('FirstApprover' === actualRol.current && hasTurn.current && isAwaiting.current)){
        setDisableOnShoreRadioButtons(false);
        setDisableOnShorePercentage(false);        
      }

      let currentRowOpen = getCurrentAccountSelectedById(accountRowOpen.current);          
      let onShoreSelection = currentRowOpen.onShoreSelection;
  
      if(onShoreSelection != '' && onShoreSelection=='Y'){
        setOnShoreValueSelected('Y')
        setEnableRenderOnShorePercentage(true);        
      }else{
        setOnShoreValueSelected('N');
        setEnableRenderOnShorePercentage(false);        
      }
      let iPercentageOnShore = currentRowOpen.percentageOnShore;
        
      if(iPercentageOnShore == ''){
        iPercentageOnShore = 0.0;
      }
      setDefaultPercentageOnshore(iPercentageOnShore);
      setPercentageOnshore(iPercentageOnShore)            
      setButtonsTaxTreatyByCommodityType(approver)
    }    
  }


  const setButtonsTaxTreatyByCommodityType = (approver) => {
    setDisabledTaxTreatySaveButton(false);
    setTitleTaxTreatySaveButtons('Save selected files as attachment');
    setDisabledTaxTreatyRemoveButton(false);
    setTitleTaxTreatyRemoveButtons('Remove attachment');
    let currentRowOpen = getCurrentAccountSelectedById(accountRowOpen.current);    
    let withholdingId = currentRowOpen.withholdingscenaryid;
    if(actualRol.current  != approver && 
        ((withholdingId != 'WH00' || withholdingId != 'WH04') && !(actualRol.current  === 'TaxApprover' && hasTurn.current))){
      disableTaxTreatyDoc();
    }
  }

  const disableTaxTreatyDoc = () => {
    setDisabledTaxTreatySaveButton(true);
    setTitleTaxTreatySaveButtons('You are not allowed to make change on Tax Treaty');
    setDisabledTaxTreatyRemoveButton(true);
    setTitleTaxTreatyRemoveButtons('You are not allowed to make change on Tax Treaty');
  }

  const processWithholdingSelectOption = (inputOption,taxOption,approver) => {  
    optionSelectedForCurrentWithholding.current = 'select';
    setEnableRenderingWithholdingTaxSelect(true);
    let currentRowOpen = getCurrentAccountSelectedById(accountRowOpen.current);
    let withholdingValue = currentRowOpen.whtaxecode + '-' + currentRowOpen.whtaxetype;
    if(withholdingValue.length < 3){
      withholdingValue = '';
    }        
    setWithholdingCodeDefaultValueSelect(withholdingValue);
    console.log('finish first the withholding selection')
    if(approver == actualRol.current && hasTurn.current && isAwaiting.current){
      setDisabledWithholdingTaxSelect(false);
    }
    if(taxOption.includes('-')){
      let aTaxOption = taxOption.split('-');
      taxOption = aTaxOption[0];      
      inputOption = 'id';
      setDefaultWithholdingValue(inputOption,taxOption);
      optionSelectedForCurrentWithholding.current = 'id-select';
    }
    showModalForAddTaxApprover.current = true;
  }

  const processWithholdingInputOption = (inputOption,approver) => {
    optionSelectedForCurrentWithholding.current = 'input';
    let currentRowOpen = getCurrentAccountSelectedById(accountRowOpen.current);    
    let withholdingId = currentRowOpen.withholdingscenaryid;
    setDefaultWithholdingValue(inputOption,withholdingId);
    setEnableWithholdingSearchId(true);    
    if(approver == actualRol.current && hasTurn.current){
      setDisableWithholdingIdInput(false);
    }
    
    if((withholdingId === 'WH00' || withholdingId === 'WH04')){
      let withholdingValue = currentRowOpen.whtaxecode + '-'+ currentRowOpen.whtaxetype;
      if(withholdingValue.length < 3){
        withholdingValue = '';
      }
      setWithholdingCodeDefaultValueSelect(withholdingValue);            
          
      if(actualRol.current.includes('TaxApprover') && hasTurn.current && isAwaiting.current){
        setDisabledWithholdingTaxSelect(false);
      }
      setEnableRenderingWithholdingTaxSelect(true); 
      optionSelectedForCurrentWithholding.current = 'id-select';     
    }
    showModalForAddTaxApprover.current = true;
  }



  const setDefaultWithholdingValue = (inputOption,taxOption) => {    
    setEnableWithholdingSearchId(false);
    if(inputOption == 'taxcode'){
      let taxValues = taxOption.split('-');
      setEnableWithholdingPreSelectTable(true);
      
      let newRowsForeingWithholding = [
        {
          taxetype:taxValues[0],
          taxecode:taxValues[1]
        }
      ];            
      setRowsForeingWithholding(newRowsForeingWithholding);
      showModalForAddTaxApprover.current = true;      
      optionSelectedForCurrentWithholding.current = 'table';
      return;
    }else if(inputOption == 'id'){
      setEnableRenderingWithholdingIdInput(true);
      setDisableWithholdingIdInput(true);
      setWithholdingIdDefaultValueSelected(taxOption);     
      setWithholdingId(taxOption);
      optionSelectedForCurrentWithholding.current = 'input';      
      return;
    }
    optionSelectedForCurrentWithholding.current = '';      
  }

  const getCurrentAccountSelectedById = (id) => {
    let newRowAccountinglUnit = [...rowsAccountinglUnit];
    let rowAccountSelected = newRowAccountinglUnit.filter((row) => {
      return row.id === id;
    })
    if(rowAccountSelected[0] === undefined){
      return undefined;
    }
    return rowAccountSelected[0];
  }

  const processWithholdingTaxes = (value) => {
    setWithholdingCodeAndTypeSelected(value);
  }

  const getNewReceptionUnit = (reception, quantity, id) => {    
    reception["id"] = id+'';
    reception["total"] = parseFloat(quantity).toFixed(decimalQuantitiesForAmount.current) * reception.amount;
    reception["quantity"] = parseFloat(quantity).toFixed(decimalQuantitiesForItemQuantity.current).toString();              ;
    reception["checkbox"] = 'idCheckBoxAccount'+id;    
          
    return reception;
  }

  const setNewValuesForSplitReception = (reception) => {
    reception["onShoreSelection"] = '';
    reception["percentageOnShore"] = 0;    
    reception["whtaxecode"]  = ''
    reception["whtaxetype"]  = ''
    return reception;
  }

  const addNewReception = () => {
    let newRowAccountinglUnit = [...rowsAccountinglUnit];
    let accountLength = newRowAccountinglUnit.length;
    let newRowCount = parseInt(newRowAccountinglUnit[accountLength-1].id) + 1;
    let reception = {};
    let checkboxsParents = document.getElementsByClassName('classNameCheckBoxAccount');
    if(checkboxsParents.length == 0){      
      return;
    }
    
    let result = searchReceptionSelected(newRowAccountinglUnit);
    if(!result.receptionFound) {
      openMessageModal(MESSAGE_SELECT_ONE_RECEPTION);
      return;
    }     
    if(newRowAccountinglUnit[result.rowPosition].account == '' && 
      (documentIAS.zone == 'AP' || (emeaVatSplitEnable && documentIAS.zone == 'EMEA'))){
      openMessageModal(ERROR_MESSAGE_ACCOUNT_REQUIRED)
      return;
    }

    modifyReceptionForVatSplit(newRowAccountinglUnit[result.rowPosition]);
    reception = structuredClone(newRowAccountinglUnit[result.rowPosition]);
    reception = getNewReceptionUnit(reception,reception.quantity,newRowCount);
    reception  = setNewValuesForSplitReception(reception);

    setRowsAccountinglUnit(newRowAccountinglUnit.concat(reception));
    calculateSumToReception();
  }

  const searchReceptionSelected = (newRowAccountinglUnit) => {
    let result = {};
    result.receptionFound = false;
    result.rowPosition = 0;
    let checkboxsParents = document.getElementsByClassName('classNameCheckBoxAccount');
    for(let i = 0; i < checkboxsParents.length; i++){
      if(result.receptionFound) break;
      let childDiv = checkboxsParents[i];
      for(let j = 0; j < childDiv.childNodes.length; j++){
        if(result.receptionFound) break;
        let childObj = childDiv.childNodes[j]
        if(childObj.localName != 'input')
          continue
        if(!childObj.checked)
          continue
        let inputId = childObj.id;
        let rowIndexId = inputId.substring(inputId.length-1,inputId.length);
        //running over all the receptions in the array to find the id and remove
        //the element from the array
        for (let k = 0; k < newRowAccountinglUnit.length; k++) {
          if(result.receptionFound) break;
          let indexId = newRowAccountinglUnit[k].id;
          if(indexId == rowIndexId){            
            result.rowPosition = k;            
            result.receptionFound = true;
          }
        }
      }
    }  
    return result;
  }

  const modifyReceptionForVatSplit = (reception) => {
    if(!(documentIAS.zone == 'AP' || (emeaVatSplitEnable && documentIAS.zone == 'EMEA'))) return;
    reception.amount = reception.amount / 2;    
    document.getElementById('idInputAmount'+reception.id).value = reception.amount;
  }

  const removeReception = () => {
    //get all the checkbox parents for the reception table    
    let checkboxsParents = document.getElementsByClassName('classNameCheckBoxAccount');
    if(checkboxsParents.length == 0)
      return;
    if(rowsAccountinglUnit.length <= 1){
      openMessageModal("You can't delete this row. You need to have at least one row in the table.");
      return;
    }
    let newRowsAccountinglUnit = [...rowsAccountinglUnit];
    let rowRemove = false;
    for(let i = 0; i < checkboxsParents.length; i++){
      if(rowRemove) break;
      let childDiv = checkboxsParents[i];
      for(let j = 0; j < childDiv.childNodes.length; j++){
        let childObj = childDiv.childNodes[j]
        if(childObj.localName != 'input')
          continue
        if(!childObj.checked)
          continue
        let inputId = childObj.id;
        let rowIndexId = inputId.substring(inputId.length-1,inputId.length);
        
        //running over all the receptions in the array to find the id and remove
        //the element from the array
        for (let k = 0; k < newRowsAccountinglUnit.length; k++) {
          let indexId = newRowsAccountinglUnit[k].id;
          if(indexId == rowIndexId){            
            newRowsAccountinglUnit.splice(k,1);
            rowRemove = true;
          }
        }
      }
    }
    
    setRowsAccountinglUnit(newRowsAccountinglUnit)            
    calculateSumToReception();
  }      

  const getDocumentIAS = async () => {
    await getCurrentDoc()
      .then(response => {
        if(response.status === 200){
          response.json()
          .then(response => {
            console.log("response (getCurrentDoc) DocumentIAS: ",response)
            setChangeInApprovalsForView(response);
            setDocumentIAS(response)            
            setAmountsDecimalsLength(response);
            let rowsToApprovalUnit = [];
            rowsToApprovalUnit.push(
              {
                id: '0',
                rowT: "1",
                docNumb: response.rcpowayb,
                type: response.invoiceTypeDesc,
                netAmount: parseFloat(response.netAmount).toFixed(decimalQuantitiesForAmount.current).toString(),
                totalAmount: parseFloat(response.totalAmount).toFixed(decimalQuantitiesForAmount.current).toString()
              }
            );
            setRowsApprovalUnit(rowsToApprovalUnit);

            let rowForApprovalUnit = getRowForApprovalUnit();
            let headerForApprovalUnit = getheaderForApprovalUnit();

            let headerForVatUnit = [];
            headerForVatUnit.push({id: 'headerEmpty',key: 'headerEmpty', header: ''});
            headerForVatUnit.push({id: 'header',key: 'header', header: 'Vats'});
            let rowToVatUnit = [{},{}];
            rowToVatUnit[0]['headerEmpty'] = '0';
            rowToVatUnit[0]['headerEmpty'] = 'Vat Amounts:';
            rowToVatUnit[1]['headerEmpty'] = '1';
            rowToVatUnit[1]['headerEmpty'] = 'Vat Codes:';  
            

            let headerForWithholdingUnit = [];
            headerForWithholdingUnit.push({id:'headerEmpty',key: 'headerEmpty', header: ''});
            headerForWithholdingUnit.push({id:'header',key: 'header', header: 'Withholdings'});
            let rowToWithholdingUnit = [{},{}];
            rowToWithholdingUnit[0]['headerEmpty'] = '0';
            rowToWithholdingUnit[0]['headerEmpty'] = 'Withholding Amounts:';
            rowToWithholdingUnit[1]['headerEmpty'] = '1';
            rowToWithholdingUnit[1]['headerEmpty'] = 'Withholding Codes:';

            let id = 'id';
            let invoiceHasWithholding = false;
            response.taxesList.map((tax,i) => {
              if(tax.vattype === 'W'){
                headerForWithholdingUnit.push({key: tax.key.taxecode, header: ''});
                rowToWithholdingUnit[0][id] = '0';
                rowToWithholdingUnit[0][tax.key.taxecode] = parseFloat(tax.taxAmount).toFixed(decimalQuantitiesForAmount.current).toString();
                rowToWithholdingUnit[1][id] = '1';
                rowToWithholdingUnit[1][tax.key.taxecode] = tax.key.taxecode;                  
                invoiceHasWithholding = true;
              }else{
                headerForVatUnit.push({id: i,key: tax.key.taxecode, header: ''});
                rowToVatUnit[0][id] = '0';
                rowToVatUnit[0][tax.key.taxecode] = parseFloat(tax.taxAmount).toFixed(decimalQuantitiesForAmount.current).toString();
                rowToVatUnit[1][id] = '1';
                rowToVatUnit[1][tax.key.taxecode] = tax.key.taxecode;                  
              }
            });
            console.log(rowToWithholdingUnit);
            console.log(rowToVatUnit);
            rowForApprovalUnit[0]["netAmount"] = parseFloat(response.netAmount).toFixed(decimalQuantitiesForAmount.current).toString();
            rowForApprovalUnit[0]["totalAmount"] = parseFloat(response.totalAmount).toFixed(decimalQuantitiesForAmount.current).toString();
            rowsToApprovalUnit.push(rowForApprovalUnit[0]);
            setHeadersApprovalUnit(headerForApprovalUnit);
            setRowsApprovalUnit(rowsToApprovalUnit);

            setHeadersVatUnit(headerForVatUnit);
            setRowsVatUnit(rowToVatUnit);

            setHeadersWithholdingUnit(headerForWithholdingUnit);
            setRowsWithholdingUnit(rowToWithholdingUnit);
            setShowWithholdingTaxes(invoiceHasWithholding && response.ctrycode !== '631')

            let rowsToAccountinglUnit = [];
            
            response.receptionUnitTable.lRuDAO.map((reception, id) => {
              let quantity = response.receptionUnitTable.aRUQuantity[id];
              reception = getNewReceptionUnit(reception,quantity,id);
              reception = setPurchaseOrderRelatedValues(reception,response,id)
              reception = setSplitByVatsRURelatedValues(reception,response,id);
              reception = fixCommodityDescription(reception,response);              
              rowsToAccountinglUnit.push(reception);
            })
            setSumReceptions(parseFloat(response.netAmount).toFixed(decimalQuantitiesForAmount.current).toString());
            setRowsAccountinglUnit(rowsToAccountinglUnit);            
            setRowsApprovalInformation(response.approvalRequests);
            setInvoiceRelatedInformationFromJapan(response);
            if(actualRol.current === 'APApprover' && zone.current === 'AP' && hasTurn.current){
              showModalForTaxApprover(response,rowsToAccountinglUnit);
            }
            setInvoiceDocumentIasInformation(response);
            setButtonsForActions();
            setHeadersForReceptionUnitTable(response);
            setUserApplicationRol(rol);
          })
        }else if(response.status === 410)   {
          response.text()
            .then(res => {
              setMessageSessionLost(res)                             
            })
        } 
      })
  }

  const setChangeInApprovalsForView = (documentIas) => {
    if(documentIas.approvalRequests.length > 0) {
      documentIas.approvalRequests.forEach((item, i) => {
        item.id = i;
        item.effectiveApproverNameFE = item.effectiveApproverName + " => " + item.effectiveApproverMail;
        item.realApprover = '';
        if(item.designationType === 'delegacion'){
          item.effectiveApproverNameFE = item.originalApproverName + " => " + item.originalMailApprover;
          item.realApprover = item.effectiveApproverName + " => " + item.effectiveApproverMail;
        }
      })
    };
  }

  const setInvoiceDocumentIasInformation = (documentIas) => {
    typeFlow.current = documentIas.flowType;   
    isNonPO.current = documentIas.flowType === 'NONPO';
    isIPVN.current = documentIas.flowType === 'IPVN';
    isNCE.current = documentIas.flowType === 'NCE';
    isNC.current = documentIas.flowType === 'NC';

    isHold.current = documentIas.holdPayment;
    wasPaid.current = documentIas.payed;
    isRTV.current = documentIas.rejected;
    if(isRTV.current || isHold.current){
      getInvoiceRejectionInformation(documentIas.idDoc);
    }
    wentToComfiar.current = documentIas.wentToComfiar;
    docStatus.current = documentIas.docStatus;
    isAwaiting.current = documentIas.docStatus.includes('Awaiting');
    wasExported.current = documentIas.exported;
    wasFinalized.current = documentIas.finalApproval;
    isSecondRequired.current = documentIas.montoAlcanzoLimiteSecondLastObligatorio;
    setsecondLastApprover(documentIas.montoAlcanzoLimiteSecondLastObligatorio);
    setCommoditySelected(documentIas.commcode);
    findUniqueExpenditure(documentIas.commcode);
    let userLoggedApprovalRequest = getRelatedApprovalRequest(documentIas,user);
    if(userLoggedApprovalRequest != undefined){
      isRelatedUser.current = true;
      loggedUserStatusInInvoice.current = userLoggedApprovalRequest.action.trim();
    }    
    isViewer.current = documentIas.docStatus === 'Deleted' || documentIas.docStatus === 'idWithError';
    nextApproverMail.current = documentIas.nextApproverMail;
    realNextApproverMail.current = documentIas.realNextApproverMail;
    hasTurn.current = user === documentIas.nextApproverMail || user === documentIas.realNextApproverMail;
    directDebitEnable.current = documentIas.directDebitEnable;
    directDebit.current = documentIas.directDebit;
    actualUserWithTurnStatus.current = documentIas.currentApprovalRequestStatus;
    if(documentIas.previousEffectiveApproverMail != undefined){
      previousEffectiveApprover.current = documentIas.previousEffectiveApproverMail;
      isLoggedUserPreviousEffectiveApprover.current = documentIas.previousEffectiveApproverMail === user;
      let previousApprovalRequest =  getRelatedApprovalRequest(documentIas,previousEffectiveApprover.current);
      if(previousApprovalRequest != undefined){
        previousApproverAction.current = previousApprovalRequest.action.trim();
      }
    }    
    actualRol.current = documentIas.nextApproverRol;
    newComment.current = documentIas.comment;
    zone.current = documentIas.zone;
    legalDevolutionTimeExpired.current = documentIas.rtvOverdue;
    rtvIsProhibited.current = documentIas.rtvForbiddenSugestHold;
    disabledRTV.current = documentIas.rtvDisable;    
    rtvAndHoldPrOverdue.current = documentIas.rtvAndHoldOverdue;
    getInvoiceAttachments(documentIas.idDoc);    
    if(zone.current === 'AP'){      
      getTaxTreatyAttachments(documentIas);
      let disablePaymentRelatedData = !actualRol.current.includes('First') && !actualRol.current.includes('APApprover') ;
      setDisableDueDatePicker(disablePaymentRelatedData);
      setDisablePaymentTermSelect(disablePaymentRelatedData);
      setDisableDirectDebitTransferRadioButton(disablePaymentRelatedData);
      setDisableManualPaymentTransferRadioButton(disablePaymentRelatedData);
      setDisablePaymentWireTransferRadioButton(disablePaymentRelatedData);
    }
  }

  

  const setAmountsDecimalsLength = (documentIas) => {
    if(documentIas.zone === 'AP'){
      setJapanCurrencyDecimalLength(documentIas);      
    }else{
      setInvoiceCurrencyDecimalLength(documentIas);
    }    
  }

  const fixCommodityDescription = (reception,response) => {
    if(reception.commodity === ''){
      reception.commodity = response.commcode;
    }  
    if(!reception.description.includes(reception.commodity) && reception.commodity !== undefined){
      reception.description = reception.commodity + ' - ' + reception.description;
    }
    return reception;
  }

  const getRowForApprovalUnit = () => {
    return [
      {
        id:'1',
        rowT: "",
        docNumb: "",
        type: "Total"
      }
    ];
  }

  const getheaderForApprovalUnit = () => {
    return [
      {
        key: 'rowT',
        header: 'Row',
      },
      {
        key: 'docNumb',
        header: 'Document Number',
      },
      {
        key: 'type',
        header: 'Type',
      },
      {
        key: 'netAmount',
        header: 'Net Amount',
      }  ,
      {
        key: 'totalAmount',
        header: 'Total Amount',
      }
    ];
  }


  const showModalForTaxApprover = (documentIas,currentRowsAccountinglUnit) => {
    
    currentRowsAccountinglUnit.map((row) => {
      let request = {};      

      request.ctrycode = documentIas.ctrycode;
      request.compcode = documentIas.compcode;
      request.invonumb = documentIas.invonumb;
      request.commcode = row.commodity;

      getCategoryCommcodeIerp(request)
      .then(response => {
        if(response.status === 200){
          response.text()
            .then(response => {
              let withholdingValues =  response.split(',');
		          let withholdingId = withholdingValues[1]; 
		          let approver = withholdingValues[2];

              if(approver === 'TaxApprover' || withholdingId === 'input' || withholdingId === '6B-02'){
                modalMessageForTaxApproval();
              }
            })
        }else if(response.status === 410){
          response.text()
            .then(res => {
              setMessageSessionLost(res)                             
            })
        }else{
          response.text()
          .then(response => {
            openMessageModal(response);
          })
        }
      });
    })
  }

  const setInvoiceRelatedInformationFromJapan = (documentIAS) => {
    if(documentIAS.foreingInv != undefined){
      isForeignInvoice.current = documentIAS.foreingInv === 'Y';
    }

    setPaymentMethodSelected(documentIAS.payMethodIERP === '' ? '' : documentIAS.payMethodIERP);    
  }

  const setSplitByVatsRURelatedValues = (reception,response,index) => {
    if(!(response.zone == 'AP' || (emeaVatSplitEnable && response.zone == 'EMEA'))){
      return reception;
    }
    
    reception.vatcode = response.receptionUnitTable.aRUVatCode[index];
    reception.commodity = response.receptionUnitTable.aCommcode[index];          
    reception.originalAmount = response.receptionUnitTable.aRUAmountFormated[index];
    return reception;
  }
  
  const setPurchaseOrderRelatedValues = (reception, response, id) => {
    if(response.typeFlow == 'NONPO' || response.typeFlow == 'NC')
      return reception;
    let item = response.receptionUnitTable.aRUItem[id];
    reception["item"] = item;
    let poNumber = response.receptionUnitTable.aRUPONumber[id];
    reception["ponumber"] = poNumber;
    reception['price'] = response.receptionUnitTable.aRUUnitPrice[id];
    return reception;
  }

 

  const setInvoiceCurrencyDecimalLength = (documentIas) => {
    if(countriesWithAmountFourDecimals.current.includes(documentIas.ctrycode)){
      decimalQuantitiesForAmount.current = 4;
    }
  }

  const setJapanCurrencyDecimalLength = (documentIas) => {
    if(isJapanLocalCurrency(documentIas)){
      setJapanLocalCurrencyDecimalLength();
    }else{
      setJapanForeignCurrencyDecimalLength();
    }
  }

  const setJapanForeignCurrencyDecimalLength = () => {
    decimalQuantitiesForAmount.current = japanForeignCurrencyDecimalQuantitiesLength.current;
  }

  const setJapanLocalCurrencyDecimalLength = () => {
    decimalQuantitiesForAmount.current = japanLocalCurrencyDecimalQuantitiesLength.current;
  }

  const isJapanLocalCurrency = (documentIas) => {
    if(documentIas.currcode === japanLocalCurrency.current){
      return true;
    }
    return false;
  }

  const getInvoiceRejectionInformation = (idDoc) => {
    let request = {};
    request.idDoc = idDoc;      
    getRejectionInformation(request)
      .then(response => {
        if(response.status === 200){
          response.json()
          .then(response => {              
            console.log('response invoice rejection info:',response)                
            if(response.response === 'empty'){
              return;
            }
            setInvoiceRejectionInformation(response);        
          })
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      } else{
        response.text()
          .then(response => {
            openMessageModal(response);
          })
      }
    });      
  }
  const getTaxTreatyAttachments = (documentIas) => {
    if(!isForeignInvoice.current){
      return;
    }

    let request = {};
    request.idDoc = documentIas.idDoc;
    request.pais = documentIas.ctrycode;
    request.compania = documentIas.compcode;
    request.invonumb = documentIas.invonumb;
    getListTaxTreatyAttachments(request)
    .then(response => {
      if(response.status === 200){
        response.json()
          .then(response => {
            if(response.length > 0){
              
              setAttachmentsForTaxTreaty(response);
              setInvoiceHasTaxTreaty(true)
              setEnableRenderTaxTreatyRadioButtons(true);
              setRenderTaxTreatyAttachmentUpload(true);
            }            
          })
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      } else{
        response.text()
          .then(response => {
            openMessageModal(response);
          })
      }
    });        
  }

  const getInvoiceAttachments = (idDoc) => {
    let request = {};
    request.idDoc = idDoc;        
    getListInvoiceAttachments(request)
    .then(response => {
      if(response.status === 200){
        response.json()
          .then(response => {            
            console.log('response invoice attachments:',response);
            setApproverAttachments(response.approverAttachments);
            setSupplierAttachments(response.supplierAttachments);                                                      
          })
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      } else{
        response.text()
          .then(response => {
            openMessageModal(response);
          })
      }
    });        
  }

  const setButtonsForActions = () => {
    setEnableAllOptionsButtons(true);
    setEnableReassingButton(true);
    setEnableCommonUserButtonOption(true);
    setEnableCancelApprovalButtons(false);
    setEnableCancelRTVButton(false);
    setEnableCancelHoldButton(false);
    setEnableRejectMessageForApprovedInvoices(false);
    if(rol.includes('ApAdmin') && !(hasTurn.current && docStatus.current.includes("Awaiting"))){
      setButtonsForPriviligedUser();
    }else{
      setButtonsForCommonUser();
    }
  }

  const setButtonsForPriviligedUser = () => {
    if(isViewer.current){
      return;
    }
    if(isIPVN.current){
      hasTurn.current = false;
    }
    if(!wasPaid.current){
      enablePriviligedButtons();
    }
  }

  const enablePriviligedButtons = () => {
    setEnableAllOptionsButtons(false);
    setEnableReassingButton(false);
    setEnableCommonUserButtonOption(false);
    if(isHold.current){
      
      setEnableCancelHoldButton(true);
    }else if(isRTV.current){
      
      setEnableCancelRTVButton(true);
    }else if(docStatus.current.includes('Approve')){      
      if(isIPVN.current){
        setEnableRejectButtons(true);
      }else{
        setEnableRejectButtons(true);
        setEnableCancelApprovalButtons(true);
      }      
    }else{            
      setEnableRejectButtons(true);
      setEnableReassingButton(true);      
      setEnableCancelApprovalButtons(previousApproverAction.current === 'Approved' || docStatus.current.includes('Approve'));      
    }
  }


  const processReceptionAmounts = (value,id) => {      
    setNewAmountInReceptionArray(value,id);
    calculateSumToReception();
  }

  const setNewAmountInReceptionArray = (value,id) => {
    let newRowsAccountinglUnit = [...rowsAccountinglUnit];
    newRowsAccountinglUnit.forEach(element => {
      if(element.id == id){
        element.amount = value;
      }
    });
    setRowsAccountinglUnit(newRowsAccountinglUnit);
  }

  const setButtonsForCommonUser = () => {
    if(isViewer.current || !isRelatedUser.current){      
      setEnableAllOptionsButtons(false);
      setEnableReassingButton(false);
      setEnableCommonUserButtonOption(false);
      return;
    }

    if(isIPVN.current){
      hasTurn.current = false;
      setEnableAllOptionsButtons(false);
      setEnableReassingButton(false);
      setEnableCommonUserButtonOption(false);
      if(!isRTV.current && !isHold.current && !wasPaid.current && !wentToConfiar.current){
        setEnableRejectButtons(true);
      }else if(isHold.current){      
        setEnableCancelHoldButton(true);
      }else if(isRTV.current){      
        setEnableCancelRTVButton(true);
      }
      return;
    }

    if(isNCE.current || isNC.current){
      if(!wasPaid.current && loggedUserStatusInInvoice.current.includes('Approved') && !wentToConfiar){
        setEnableAllOptionsButtons(false);
        setEnableReassingButton(false);
        setEnableCommonUserButtonOption(false)
        setEnableCancelApprovalButtons(true);
      }else if(isHold.current){
        setEnableAllOptionsButtons(false);
        setEnableReassingButton(false);
        setEnableCommonUserButtonOption(false)
        setEnableCancelHoldButton(true);
      }else if(isRTV.current && !wentToConfiar.current){
        setEnableAllOptionsButtons(false);
        setEnableReassingButton(false);
        setEnableCommonUserButtonOption(false)
        setEnableCancelRTVButton(true);
      }            
    }

    if(!hasTurn.current){
      setEnableAllOptionsButtons(false)
      setEnableReassingButton(false);
      setEnableCommonUserButtonOption(false)
    }

    if(wasFinalized.current && isHold.current && !wasPaid.current){
      setEnableAllOptionsButtons(false);
      setEnableReassingButton(false);
      setEnableCommonUserButtonOption(false);
      setEnableCancelHoldButton(true)
    }else if(wasFinalized.current && !wasPaid.current && isRTV.current && !wentToConfiar.current){
      setEnableAllOptionsButtons(false);
      setEnableReassingButton(false);
      setEnableCommonUserButtonOption(false);
      setEnableCancelRTVButton(true)
    }else if(wasFinalized.current && loggedUserStatusInInvoice.current.includes('Approved') && wasPaid.current){
      setEnableAllOptionsButtons(false);  
      setEnableReassingButton(false);
      setEnableCommonUserButtonOption(false);    
    }else if(wasFinalized.current && loggedUserStatusInInvoice.current.includes('Approved') && !wasPaid.current && hasTurn.current && !wentToConfiar.current){
      setEnableAllOptionsButtons(false);
      setEnableReassingButton(false);
      setEnableCommonUserButtonOption(false);
      setEnableRejectButtons(true);
      if((isNonPO.current || isNC.current) && zone.current !== 'AP'){
        setEnableRejectButtons(false);
        setEnableCancelApprovalButtons(false);
        setEnableRejectMessageForApprovedInvoices(true);
      }
    }else if(wasFinalized.current){
      setEnableAllOptionsButtons(false);
      setEnableReassingButton(false);
      setEnableCommonUserButtonOption(false);      
    }else if(!wasFinalized.current && !hasTurn.current && loggedUserStatusInInvoice.current.includes('Approved') && actualUserWithTurnStatus.current.includes('Awaiting') && isLoggedUserPreviousEffectiveApprover.current){
      setEnableAllOptionsButtons(false);
      setEnableReassingButton(false);
      setEnableCommonUserButtonOption(false);
      setEnableCancelApprovalButtons(true)
    }else if(!wasFinalized.current && !hasTurn.current){
      setEnableAllOptionsButtons(false);  
      setEnableReassingButton(false);
      setEnableCommonUserButtonOption(false);    
    }
  }
    
  const findUniqueExpenditure = (commcode) => {
    if(lCommWithUniques.includes(commcode)){
      hasUniqueExpenditure.current = true;
    }
  }

  const getRelatedApprovalRequest =(documentIas, mailToSearch) =>{
    let requestApproval = undefined;
    documentIas.approvalRequests.forEach(element => {
      let mailToLowerCase = element.effectiveApproverMail.toLowerCase();
      if(mailToLowerCase.includes(mailToSearch)){
        requestApproval = element;        
      }
    })
    return requestApproval;
  }
  
    const getAllDocument = async (idDoc) => {       
      
      await elegirDoc(idDoc)
        .then(response => {
            setIdDoc(parseInt(idDoc));
            if(response.status === 200) {
              //do nothing
            }else if(response.status === 410)   {
              response.text()
                .then(res => {
                  setMessageSessionLost(res)                             
                })
            } 
          })                    
      await getDocumentAlreadySelected(); 
      
    };

    const getDocumentAlreadySelected = async () => {
      document.body.className = 'waiting';      
      await getResources();
      await getDocumentIAS();
      
      document.body.className = '';
    }

    const [lastApprovers, setLasApprovers] = useState([]);   

    const getResources = async () => {
      await getDocumentViewResources()
      .then(response => {
        if(response.status === 200) {
          response.json()
            .then(response => {
              console.log('Response Resources: ',response);
              
              if(response.vDeptos != undefined)
                setLDeptos(response.vDeptos)
              if(response.minorList != undefined)
                setLMinors(response.minorList)
              if(response.vProyectos1)
                setLProyects(response.vProyectos1);
              if(response.lAccounting != undefined)
                setLBalanceSheet(response.lAccounting)
              if(response.lCommSerial != undefined)
                setLCommSerial(response.lCommSerial);
              if(response.listaCommcodeConUnique != undefined)
                setLCommWithUniques(response.listaCommcodeConUnique);
              if(response.ierpCommoditiesList != undefined)
                setIERPCommodityList(response.ierpCommoditiesList)
              if(response.ierpGLAccountList != undefined)
                setIerpGlAccounts(response.ierpGLAccountList)
              if(response.ierpWbsList != undefined)
                setIerpWbs(response.ierpWbsList);
              if(response.ierpTransactionType != undefined)
                setIerpTransactionType(response.ierpTransactionType);
              if(response.ierpWithholding != undefined)
                setIerpWithholding(response.ierpWithholding);
              if(response.IERPCommSpecial != undefined)
                setIerpCommSpecials(response.IERPCommSpecial);
              if(response.IERPPaymentTermsList != undefined)
                setIerpPaymentTerms(response.IERPPaymentTermsList)
              if(response.rtvReasonList != undefined)
                setRtvReasonList(response.rtvReasonList);

              if(response.paymentInfo != undefined)
                setPaymentRelatedInfo(response);

              let lastApproversTemp = response.vManagers;
              response.vAutorizados.forEach(employee => lastApproversTemp.push(employee))
              setLasApprovers(lastApproversTemp);
              setCountryWithRTV(response.with_rtv_ias !== 'N');              
              setCountryWithHold(response.with_hold_ias !== 'N');
            })
        }else if(response.status === 410)   {
          response.text()
            .then(res => {
              setMessageSessionLost(res)                             
            })
        } 
      })  
    }

    const setPaymentRelatedInfo = (resources) => {      
      setPaymentInfo(resources.paymentInfo);
      let paymentObj = resources.IERPPaymentTermsList.filter((element) => {
        return element.code === resources.paymentInfo.payTerm          
      })
      if(paymentObj !== undefined && paymentObj.length > 0) {
        setPaymentTermValueSelected(paymentObj[0]);
      }
      if(resources.paymentInfo.dueDate != ''){
        setEnableRenderDueDateSelection(true);
      }
      setDueDateValueSelected(resources.paymentInfo.dueDate);
    }

    const searchGlAccount = (inputText,scenaryId) => {
      let newIerpGlAccountsToShow;
      if(inputText.length < 2){
        newIerpGlAccountsToShow = ACCOUNT_JAPAN_SEARCH_INPUT;
        setIerpGlAccountsToShow(newIerpGlAccountsToShow)
        return
      }
      inputText = inputText.toLowerCase();
      let count = 0;
      newIerpGlAccountsToShow = ierpGlAccounts.filter((glAccount) => {
        if((glAccount.code.toLowerCase().includes(inputText) || glAccount.desc.toLowerCase().includes(inputText)) 
          && count<4000
          && getGlAccountConditionByScenary(glAccount,scenaryId)){
          count++;
          return true;
        }else{
          return false;
        }          
      })
      if(newIerpGlAccountsToShow.length == 0){
        newIerpGlAccountsToShow = ACCOUNT_JAPAN_IS_EMPTY;
      }
      setIerpGlAccountsToShow(newIerpGlAccountsToShow);
    }    

    const searchDepartment = (inputText) => {
      let newDepartmentToShow;
      if(inputText.length < 2){
        newDepartmentToShow = DEPARTMENT_CAAPS_SEARCH_INPUT;
        setCaapsDepartmentToShow(newDepartmentToShow)
        return
      }
      inputText = inputText.toLowerCase();
      let count = 0;
      newDepartmentToShow = lDeptos.filter((dept) => {
        if((dept.key.depacode.toLowerCase().includes(inputText) 
            || dept.depanumb.toLowerCase().includes(inputText)
            || dept.depaname.toLowerCase().includes(inputText)) 
          && count<4000){
          count++;
          return true;
        }else{
          return false;
        }          
      })
      if(newDepartmentToShow.length == 0){
        newDepartmentToShow = DEPARTMEMT_CAAPS_IS_EMPTY;
      }
      setCaapsDepartmentToShow(newDepartmentToShow);
    }   

    const searchMinor = (inputText) => {
      let newMinorsToShow;
      if(inputText.length < 2){
        newMinorsToShow = MINORS_CAAPS_SEARCH_INPUT;
        setCaapsMinorToShow(newMinorsToShow)
        return
      }
      inputText = inputText.toLowerCase();
      let count = 0;
      newMinorsToShow = lMinors.filter((minor) => {
        if((minor.minor.toLowerCase().includes(inputText)) 
          && count<4000){
          count++;
          return true;
        }else{
          return false;
        }          
      })
      if(newMinorsToShow.length == 0){
        newMinorsToShow = MINORS_CAAPS_IS_EMPTY;
      }
      setCaapsMinorToShow(newMinorsToShow);
    }  
    
    const searchProject = (inputText) => {
      let newProjectToShow;
      if(inputText.length < 2){
        newProjectToShow = PROJECT_CAAPS_SEARCH_INPUT;
        setCaapsProjectsToShow(newProjectToShow)
        return
      }
      inputText = inputText.toLowerCase();
      let count = 0;
      newProjectToShow = lProyects.filter((project) => {
        if((project.key.projecod.toLowerCase().includes(inputText)) 
          && count<4000){
          count++;
          return true;
        }else{
          return false;
        }          
      })
      if(newProjectToShow.length == 0){
        newProjectToShow = PROJECT_CAAPS_IS_EMPTY;
      }
      setCaapsProjectsToShow(newProjectToShow);
    }  

    const getGlAccountConditionByScenary = (glAccount,scenaryId) =>{
      if(scenaryId === 1 && glAccount.code.startsWith('6')){        
        return true;
      }else if(scenaryId === 2 
        && (glAccount.code.startsWith("0") || glAccount.code.startsWith("1") || glAccount.code.startsWith("2"))){
        return true;
      }else if(scenaryId === 3 && glAccount.code.startsWith("7")){
        return true;
      }
      return false;
    }

    const searchCostCenter = (inputText) => {
      let newIerpCostCenterToShow = [];
      if(inputText.length < 2){
        newIerpCostCenterToShow = ACCOUNT_JAPAN_SEARCH_INPUT;
        setIerpCostCenterToShow(newIerpCostCenterToShow);
        return;
      }
      inputText = inputText.toLowerCase();
      getIerpAccountsList('costcenter',inputText)
      .then(response => {
        if(response.status === 200){
          response.json()
          .then(response => {
            if(response.ierpCostCenterList.length != 0){
              setIerpCostCenterToShow(response.ierpCostCenterList);
            }else{
              setIerpCostCenterToShow(ACCOUNT_JAPAN_IS_EMPTY);
            }
          })        
        }else if(response.status === 410)   {
          response.text()
            .then(res => {
              setMessageSessionLost(res)                             
            })
        } else{          
          
        }
      })  
      .catch(error => {        
        console.log("Error in api /GetAccountIERPList: " + error)
      });
    }

    const searchInternalOrder = (inputText) => {
      let newIerpInternalOrderToShow = [];
      if(inputText.length < 2){
        newIerpInternalOrderToShow = ACCOUNT_JAPAN_SEARCH_INPUT;
        setIerpInternalOrderToShow(newIerpInternalOrderToShow);
        return;
      }
      inputText = inputText.toLowerCase();
      getIerpAccountsList('internalorder',inputText)
      .then(response => {
        if(response.status === 200){
          response.json()
          .then(response => {
            if(response.ierpInternalOrderList.length != 0){
              setIerpInternalOrderToShow(response.ierpInternalOrderList);
            }else{
              setIerpInternalOrderToShow(ACCOUNT_JAPAN_IS_EMPTY);
            }
          })        
        }else if(response.status === 410)   {
          response.text()
            .then(res => {
              setMessageSessionLost(res)                             
            })
        }
      })
      .catch(error => {        
        console.log("Error in api /GetAccountIERPList: " + error)
      });     
    }

    const searchWbs = (inputText) => {
      let newIerpWbsToShow;
      if(inputText.length < 2){
        newIerpWbsToShow = ACCOUNT_JAPAN_SEARCH_INPUT;
        setIerpWbsToShow(newIerpWbsToShow)
        return
      }
      inputText = inputText.toLowerCase();
      let count = 0;
      newIerpWbsToShow = ierpWbs.filter((wbs,index) => {
        if((wbs.code.toLowerCase().includes(inputText) || wbs.desc.toLowerCase().includes(inputText)) 
          && count<4000){
          count++;
          return true;
        }else{
          return false;
        }          
      })
      if(newIerpWbsToShow.length == 0){
        newIerpWbsToShow = ACCOUNT_JAPAN_IS_EMPTY;
      }
      setIerpWbsToShow(newIerpWbsToShow);
    }  

    const searchProfitCenter = (inputText) => {
      let newIerpProfitCenterToShow = [];
      
      if(inputText.length < 2){
        newIerpProfitCenterToShow = ACCOUNT_JAPAN_SEARCH_INPUT;
        setIerpProfitCenterToShow(newIerpProfitCenterToShow);
        return;
      }
      inputText = inputText.toLowerCase();
      getIerpAccountsList('profitcenter',inputText)
      .then(response => {
        if(response.status === 200){
          response.json()
          .then(response => {
            if(response.ierpProfitCenterList.length != 0){
              setIerpProfitCenterToShow(response.ierpProfitCenterList);
            }else{
              setIerpProfitCenterToShow(ACCOUNT_JAPAN_IS_EMPTY);
            }
          })        
        }else if(response.status === 410)   {
          response.text()
            .then(res => {
              setMessageSessionLost(res)                             
            })
        }
      }) 
      .catch(error => {        
        console.log("Error in api /GetAccountIERPList: " + error)
      });     
    }

    const searchManagers = (inputText) => {
      let newManagersToShow;
      if(inputText.length < 3){
        newManagersToShow = MANAGERS_SEARCH_INPUT;
        setManagersToShow(newManagersToShow);
        return
      }
      inputText = inputText.toLowerCase();
      let count = 0;
      newManagersToShow = lastApprovers.filter((manager,index) => {
        if((manager.mail.toLowerCase().includes(inputText) || manager.name.toLowerCase().includes(inputText)) 
          && count<4000){
          count++;
          return true;
        }else{
          return false;
        }          
      })
      if(newManagersToShow.length == 0){
        newManagersToShow = MANAGERS_EMPTY;
      }
      setManagersToShow(newManagersToShow);      
    }

    const searchTransactionType = (inputText) => {
      let newIerpTransactionTypeToShow;
      if(inputText.length < 2){
        newIerpTransactionTypeToShow = ACCOUNT_JAPAN_SEARCH_INPUT;
        setIerpTransactionTypeToShow(newIerpTransactionTypeToShow);
        return
      }
      inputText = inputText.toLowerCase();
      let count = 0;
      newIerpTransactionTypeToShow = ierpTransactionType.filter((transactionType,index) => {
        if((transactionType.code.toLowerCase().includes(inputText) || transactionType.desc.toLowerCase().includes(inputText)) 
          && count<4000){
          count++;
          return true;
        }else{
          return false;
        }          
      })
      if(newIerpTransactionTypeToShow.length == 0){
        newIerpTransactionTypeToShow = ACCOUNT_JAPAN_IS_EMPTY;
      }
      setIerpTransactionTypeToShow(newIerpTransactionTypeToShow);      
    }

    const processSelectGlAccount = (input,scenaryId) => {  
      let glAccountCode = ''
      if(input.selectedItem != undefined){
        glAccountCode = input.selectedItem.code.trim();
      }
      if(scenaryId === 1){
        if(glAccountCode.startsWith('6') || !isForeignInvoice.current){
          setEnableMandatoryInternalOrderTab1(false);
          setEnableMandatoryWbsTab1(false);
        }else{
          setEnableMandatoryInternalOrderTab1(true);
          setEnableMandatoryWbsTab1(true);
        }
      }else if(scenaryId === 2){
        setEnableMandatoryInternalOrderTab2(false);
        setEnableMandatoryTransactionTypeTab2(false);
      }else if(scenaryId === 3){
        if(glAccountCode.startsWith('7')){
          setEnableMandatoryCostCenterTab3(true)
          setEnableMandatoryProfitCenterTab3(true)
        }else{
          setEnableMandatoryCostCenterTab3(false)
          setEnableMandatoryProfitCenterTab3(false)
        }
      }
      setGlAccountSelected(glAccountCode)
    }
    
    const processSelectCostCenter = (input) => {      
      let costCenterCode = '';
      if(input.selectedItem != undefined){
        costCenterCode = input.selectedItem.code.trim();
      }
      setCostCenterSelected(costCenterCode);      
    }

    const processSelectInternalOrder = (input) => {      
      let internalOrderCode = '';
      if(input.selectedItem != undefined){
        internalOrderCode = input.selectedItem.code.trim();      
      }
      setInternalOrderSelected(internalOrderCode);      
    }

    const processSelectWbs = (input) => {      
      let wbsCode = '';
      if(input.selectedItem != undefined){
        wbsCode = input.selectedItem.code.trim();
      }
      setWbsSelected(wbsCode);
    }

    const processSelectProfitCenter = (input) => {      
      let profitCenterCode = '';
      if(input.selectedItem != undefined){
        profitCenterCode = input.selectedItem.code.trim();
      }
      setProfitCenterSelected(profitCenterCode);
    }

    const processSelectTransactionType = (input) => {      
      let transactionTypeCode = '';
      if(input.selectedItem != undefined){
        transactionTypeCode = input.selectedItem.code.trim();
      }
      setTransactionTypeSelected(transactionTypeCode);
    }

    const addAccountingToInput = () =>{     
      try{
        const newRowsAccountinglUnit = [...rowsAccountinglUnit];
        let account = '';
        if(documentIAS.zone == 'AP'){
          account = addAccountingToInputAp(newRowsAccountinglUnit);
        }else{
          account = addAccountingToInputCommon(newRowsAccountinglUnit);
        }
        
        if(account != ''){
          setAccounting(newRowsAccountinglUnit,account)  
        }
        
        closeAccountinModal();
        closeAccountinModalAP();
      } catch(e){
        console.log(e)
      }
    }

    const addAccountingToInputAp = (newRowsAccountinglUnit) => {
      let account = '';
      setCommcodeDescriptionOnAccounting(newRowsAccountinglUnit,'idSelectCommcodeAp');
      processAccountingDataRequiredForAllTabs();

      setErrorMessageAccountingAp('');
      if(selectedAccountingTabIndex === 0){
        processExpensesTabs(newRowsAccountinglUnit);
      }else if(selectedAccountingTabIndex ===1){
        processBalanceSheetTabs(newRowsAccountinglUnit);
      }else if(selectedAccountingTabIndex ===2){
        processOIOC(newRowsAccountinglUnit);
      }

      account = getAccountingFromAp();

      if(isForeignInvoice.current){
        setWithholdingForCommodity();
      }
      checkCommoditySelectedIsSpecialCommodities(newRowsAccountinglUnit)
      checkCommoditiesForProcurementPreApproval();
      
      return account;
    }

    const checkCommoditySelectedIsSpecialCommodities = (newRowsAccountinglUnit) => {
      let oneCommodityIsSpecial = false;
      newRowsAccountinglUnit.map((row) => {
        if(ierpCommSpecials.includes(row.commodity)){
          oneCommodityIsSpecial = true;
        }
      })
      
      if(oneCommodityIsSpecial && actualRol.current === 'FirstApprover'){
        setEnableRenderDueDateSelection(true)
      }else{
        setEnableRenderDueDateSelection(false)
      }
    }

    const checkCommoditiesForProcurementPreApproval = () => {
      if(actualRol.current != 'FirstApprover' && zone.current !== 'AP'){
        return;
      }
      if(COMMCODES_FOR_PROCUREMENTS_PRE_APPROVAL.includes(commoditySelected) && actualRol.current === 'FirstApprover'){
        let messageForModal = TAX_APPROVER_MESSAGE_FOR_MODAL.replace('%commcode%',commoditySelected);        
        openMessageModal(messageForModal)
      }
    }

    const setWithholdingForCommodity = () => {
      let withholdingCode = 'EMPTY';
      let withholdingType = 'EMPTY';
      let iWithholdingId = 'EMPTY';
      let newRowsAccountinglUnit = [...rowsAccountinglUnit];
      let rowPosition = getRowAccountPositionFromId(newRowsAccountinglUnit);

      if(optionSelectedForCurrentWithholding.current === 'select'){
        withholdingCode = withholdingCodeAndTypeSelected.split('-')[0];
        withholdingType = withholdingCodeAndTypeSelected.split('-')[1];
        if(withholdingCode === 'Select One'){
          return;        
        }
        setEnableRenderTaxTreatyRadioButtons(true)
      }else if(optionSelectedForCurrentWithholding.current === 'input'){
        iWithholdingId = withholdingId;
        if(!iWithholdingId){
          return;
        }
        setEnableRenderTaxTreatyRadioButtons(true)
      }else if(optionSelectedForCurrentWithholding.current === 'table'){
        withholdingType = rowsForeingWithholding[0].taxetype;
        withholdingCode = rowsForeingWithholding[0].taxecode;
        if(!withholdingCode){
          return;
        }
        setEnableRenderTaxTreatyRadioButtons(true)
      }else if(optionSelectedForCurrentWithholding.current === 'id-select'){
        withholdingCode = withholdingCodeAndTypeSelected.split('-')[0];        
        withholdingType = withholdingCodeAndTypeSelected.split('-')[1];
        if(withholdingCode === 'Select One'){
          withholdingType = '';
          withholdingCode = '';
        }
        iWithholdingId = withholdingId;
        setEnableRenderTaxTreatyRadioButtons(true)
      }else{
        newRowsAccountinglUnit[rowPosition].whtaxecode = '';
        newRowsAccountinglUnit[rowPosition].whtaxetype = '';  
        newRowsAccountinglUnit[rowPosition].withholdingscenaryid = '';
        return;
      }
      
     
      
      newRowsAccountinglUnit[rowPosition].whtaxecode = withholdingCode;
      newRowsAccountinglUnit[rowPosition].whtaxetype = withholdingType;

      if(showModalForAddTaxApprover.current && (actualRol.current !== 'TaxApprover')){
        modalMessageForTaxApproval();
      }
      if((iWithholdingId === 'WH00' || iWithholdingId == 'WH04' || iWithholdingId == 'WH08') 
          && (actualRol.current !== 'TaxApprover')){
        disableTaxTreatyDoc();
      }
      newRowsAccountinglUnit[rowPosition].withholdingscenaryid = iWithholdingId;
      newRowsAccountinglUnit[rowPosition].onShoreSelection = onShoreValueSelected;
      if(onShoreValueSelected === 'Y'){
        newRowsAccountinglUnit[rowPosition].percentageOnShore = percentageOnshore;
      }else{
        newRowsAccountinglUnit[rowPosition].percentageOnShore = '0.0';
      }
      setRowsAccountinglUnit(newRowsAccountinglUnit);
    }

    const modalMessageForTaxApproval = () => {
      openMessageModal("This document has one or more commodities codes that need the Tax Approval Revision of the withholdings, don't forget to add this Approver to the list before approving, Tax approver in Japan is xiao.xiao@ibm.com");
    }

    const processAccountingDataRequiredForAllTabs = () => {
      if(glAccountSelected === '') {
        setErrorMessageAccountingAp(ERROR_MESSAGE_GL_ACCOUNT_REQUIRED);
        throw new Error(ERROR_MESSAGE_GL_ACCOUNT_REQUIRED);
      }
      if(commoditySelected === ''){
        setErrorMessageAccountingAp(ERROR_MESSAGE_COMMCODE_REQUIRED);
        throw new Error(ERROR_MESSAGE_COMMCODE_REQUIRED);
      }
    }

    const processExpensesTabs = (newRowsAccountinglUnit) => {      
      if(costCenterSelected === ''){
        setErrorMessageAccountingAp(ERROR_MESSAGE_COST_CENTER_REQUIRED);
        throw new Error(ERROR_MESSAGE_COST_CENTER_REQUIRED);
      }
      if(!glAccountSelected.startsWith('6') && isForeignInvoice.current){
        if(internalOrderSelected === ''){
          setErrorMessageAccountingAp(ERROR_MESSAGE_INTERNAL_ORDER_REQUIRED);
          throw new Error(ERROR_MESSAGE_INTERNAL_ORDER_REQUIRED);
        } 
        if(wbsSelected === ''){
          setErrorMessageAccountingAp(ERROR_MESSAGE_WBS_REQUIRED);
          throw new Error(ERROR_MESSAGE_WBS_REQUIRED);
        }
      }
      if(internalOrderSelected === '' && wbsSelected!==''){
        setErrorMessageAccountingAp(ERROR_MESSAGE_INTERNAL_ORDER_WITH_WBS_REQUIRED);
        throw new Error(ERROR_MESSAGE_INTERNAL_ORDER_WITH_WBS_REQUIRED);
      }
      if(internalOrderSelected !== '' && wbsSelected===''){ 
        setErrorMessageAccountingAp(ERROR_MESSAGE_WBS_WITH_INTERNAL_ORDER_REQUIRED);
        throw new Error(ERROR_MESSAGE_WBS_WITH_INTERNAL_ORDER_REQUIRED);
      }
      let rowPosition = getRowAccountPositionFromId(newRowsAccountinglUnit);
      newRowsAccountinglUnit[rowPosition].gl_acc = glAccountSelected;
      newRowsAccountinglUnit[rowPosition].cost_center = costCenterSelected;
      newRowsAccountinglUnit[rowPosition].int_ord = internalOrderSelected;
      newRowsAccountinglUnit[rowPosition].wbs = wbsSelected;
      newRowsAccountinglUnit[rowPosition].prof_center = '';
      setProfitCenterSelected('');
      newRowsAccountinglUnit[rowPosition].trans_type= '';        
      setTransactionTypeSelected('');
      newRowsAccountinglUnit[rowPosition].scenario= '1';        
      
      setGlAccountValueToInput1({code:glAccountSelected,desc:''})
      setCostCenterValueToInput1({code:costCenterSelected,desc:''})
      setInternalOrderValueToInput1({code:internalOrderSelected,desc:''})
      setWbsValueToInput1({code:wbsSelected,desc:''})
    }

    const processBalanceSheetTabs = (newRowsAccountinglUnit) => {
      if(profitCenterSelected === ''){
        setErrorMessageAccountingAp(ERROR_MESSAGE_PROFIT_CENTER_REQUIRED);
        throw new Error(ERROR_MESSAGE_PROFIT_CENTER_REQUIRED);        
      }
      let rowPosition = getRowAccountPositionFromId(newRowsAccountinglUnit);
      newRowsAccountinglUnit[rowPosition].gl_acc = glAccountSelected;
      newRowsAccountinglUnit[rowPosition].int_ord = internalOrderSelected;
      newRowsAccountinglUnit[rowPosition].prof_center = profitCenterSelected;
      newRowsAccountinglUnit[rowPosition].trans_type= transactionTypeSelected;        
      newRowsAccountinglUnit[rowPosition].cost_center = '';
      setCostCenterSelected('');
      newRowsAccountinglUnit[rowPosition].wbs = '';
      setWbsSelected('');
      newRowsAccountinglUnit[rowPosition].scenario= '2';

      setGlAccountValueToInput2({code:glAccountSelected,desc:''});
      setProfitCenterValueToInput2({code:profitCenterSelected,desc:''});
      setInternalOrderValueToInput2({code:internalOrderSelected,desc:''});
      setTransactionTypeValueToInput2({code:transactionTypeSelected,desc:''});
    }

    const processOIOC = (newRowsAccountinglUnit) => {
      if(glAccountSelected.startsWith('7')){
        if(profitCenterSelected === ''){
          setErrorMessageAccountingAp(ERROR_MESSAGE_PROFIT_CENTER_REQUIRED);
          throw new Error(ERROR_MESSAGE_PROFIT_CENTER_REQUIRED);        
        }
        if(costCenterSelected === ''){
          setErrorMessageAccountingAp(ERROR_MESSAGE_COST_CENTER_REQUIRED);
          throw new Error(ERROR_MESSAGE_COST_CENTER_REQUIRED);        
        }
      }
      let rowPosition = getRowAccountPositionFromId(newRowsAccountinglUnit);
      newRowsAccountinglUnit[rowPosition].gl_acc = glAccountSelected;
      newRowsAccountinglUnit[rowPosition].cost_center = costCenterSelected;
      newRowsAccountinglUnit[rowPosition].prof_center = profitCenterSelected;
      newRowsAccountinglUnit[rowPosition].int_ord = '';
      setInternalOrderSelected('');
      newRowsAccountinglUnit[rowPosition].wbs = '';
      setWbsSelected('');
      newRowsAccountinglUnit[rowPosition].trans_type= '';        
      setTransactionTypeSelected('');
      newRowsAccountinglUnit[rowPosition].scenario= '3';

      setGlAccountValueToInput3({code:glAccountSelected, desc:''});
      setCostCenterValueToInput3({code:costCenterSelected,desc:''});
      setProfitCenterValueToInput3({code:profitCenterSelected, desc:''});
    }

    const getAccountingFromAp = () => {
      let accounting = '';

      if(selectedAccountingTabIndex == 0){
        accounting = glAccountSelected + AP_ACCOUNTING_SEPARATOR+ 
                          costCenterSelected + AP_ACCOUNTING_SEPARATOR +
                          internalOrderSelected + AP_ACCOUNTING_SEPARATOR +
                          '' + AP_ACCOUNTING_SEPARATOR +
                          wbsSelected + AP_ACCOUNTING_SEPARATOR + 
                          '';
      }else if(selectedAccountingTabIndex === 1){
       accounting = glAccountSelected + AP_ACCOUNTING_SEPARATOR+ 
                          '' + AP_ACCOUNTING_SEPARATOR +
                          internalOrderSelected + AP_ACCOUNTING_SEPARATOR +
                          profitCenterSelected + AP_ACCOUNTING_SEPARATOR +
                          '' + AP_ACCOUNTING_SEPARATOR + 
                          transactionTypeSelected;
      }else if(selectedAccountingTabIndex === 2){
        accounting = glAccountSelected + AP_ACCOUNTING_SEPARATOR+ 
                      costCenterSelected + AP_ACCOUNTING_SEPARATOR +
                      '' + AP_ACCOUNTING_SEPARATOR +
                      profitCenterSelected + AP_ACCOUNTING_SEPARATOR +
                      '' + AP_ACCOUNTING_SEPARATOR + 
                      '';
      }

      if(accounting != AP_ACCOUNTING_SEPARATOR+
                        AP_ACCOUNTING_SEPARATOR+
                        AP_ACCOUNTING_SEPARATOR+
                        AP_ACCOUNTING_SEPARATOR+
                        AP_ACCOUNTING_SEPARATOR){
        let scenaryId = Number.parseInt(selectedAccountingTabIndex) + 1;
        accounting =  scenaryId + AP_ACCOUNTING_SEPARATOR + 
                      accounting + AP_ACCOUNTING_SEPARATOR + 
                      itemDescription;
        return accounting;
      }
      return '';
    }

    const addAccountingToInputCommon = (newRowsAccountinglUnit) => {
      let account = '';
      if(documentIAS.zone != 'LA')
        setCommcodeDescriptionOnAccounting(newRowsAccountinglUnit,'idSelectCommcodeEmea');
        
      if(selectedAccountingTabIndex == 0){
        account = setDepartmentTab();
      }else if(selectedAccountingTabIndex == 1){
        account = setAccountingTab();
      }
      return account;
    }

    const setDepartmentTab = () => {      
      let department = getDeptRuAsString(departmentSelected);
      let minor = minorSelected;
      let project = projectSelected;
      if(department != '' && minor != ''){
        department = department.replace('MINOR',minor);
      }
      let account = '';      
      if(department != '' && project != ''){
        account = '//'+project;
      }else if(department != '' || project != ''){
        account = department + "//" +project;
      }
      return account
    }

    const setAccountingTab = () => {
      let balanceSheet = balanceSheetSelected;
      let account = ''
      if(balanceSheet != ''){
        account = balanceSheet
      }
      return account;      
    }

    const setAccounting = (newRowsAccountinglUnit,account) => {
      let rowPosition = getRowAccountPositionFromId(newRowsAccountinglUnit);
      newRowsAccountinglUnit[rowPosition].account = account;
      if(commodityIsChange && documentIAS.zone !== 'LA'){
        newRowsAccountinglUnit[rowPosition].commcode = commoditySelected;
      }
      if(documentIAS.zone === 'AP'){
        newRowsAccountinglUnit[rowPosition].itemdesc = itemDescription;
        setItemDescriptionToInput(itemDescription)
      }
      if(documentIAS.zone === 'EMEA' ||  documentIAS.zone === 'LA'){
        newRowsAccountinglUnit[rowPosition].department = departmentSelected;
        newRowsAccountinglUnit[rowPosition].minor = minorSelected;
      }
      
      setRowsAccountinglUnit(newRowsAccountinglUnit); 
      let accountInput = document.getElementById('idInputAccount'+accountRowOpen.current+':account');
      accountInput.value = account;
      accountInput.title = account;
    }

    const setCommcodeDescriptionOnAccounting = (newRowsAccountinglUnit,selectId) => {
      let commcodeSelect = document.getElementById(selectId);
      let commcodeDescription = '';
      if(commcodeSelect === null){
        openMessageModal("You don't have access to the selected commodity of the invoice or any commmodity in this country, please request an access")
      }
      for (let i = 0; i<commcodeSelect.length; i++) {
        let option = commcodeSelect[i];
        if (option.value != commoditySelected) 
          continue;
        commcodeDescription = option.text;
        let rowPosition = getRowAccountPositionFromId(newRowsAccountinglUnit);
        newRowsAccountinglUnit[rowPosition].commodity = commoditySelected;
        newRowsAccountinglUnit[rowPosition].description = commcodeDescription;
        let tableCell = document.getElementById('description'+accountRowOpen.current+":description");
        tableCell.innerText = commcodeDescription;
        if(zone.current === 'LA' || zone.current === 'AP'){
          tableCell = document.getElementById('commodity'+accountRowOpen.current+":commodity");
          tableCell.innerText = commoditySelected;
        }
        setRowsAccountinglUnit(newRowsAccountinglUnit);                                  
      }   
    }

    const getRowAccountPositionFromId = (newRowsAccountinglUnit) => {
      let rowPosition = '';
      newRowsAccountinglUnit.map((e,index) => {
        if(e.id === accountRowOpen.current){
          rowPosition = index;
        }          
      })
      return rowPosition;
    }

    const SEPARATOR = '::';
    const getDeptRuAsString = (row) => {
      if(row === null || row === ''){
        return '';
      }
      let deptRu = '';
      deptRu+=row.division.trim()+SEPARATOR;
      deptRu+=row.major.trim()+SEPARATOR;
      deptRu+='MINOR' + SEPARATOR;
      deptRu+=row.key.depacode.trim();
      return deptRu;
    }

    const getProyectRuAsString = (row) => {
      let proyecRu = '';
      if(row === null)
        return proyecRu;
      proyecRu+=row.division.trim()+SEPARATOR;
      proyecRu+=row.major.trim()+SEPARATOR;
      proyecRu+=row.minor.trim() + SEPARATOR;
      proyecRu+=row.depanumb.trim()+SEPARATOR;
      proyecRu+=row.key.projecod.trim();
      return proyecRu;
    }
    const getBalanceSheetRuAsString = (row) => {
      let proyecRu = '';
      if(row === null)
        return proyecRu;
      proyecRu+=row.division.trim()+SEPARATOR;
      proyecRu+=row.major.trim()+SEPARATOR;
      proyecRu+=row.minor.trim() + SEPARATOR;      
      proyecRu+='DUMM';
      return proyecRu;
    }


    const calculateSumToReception = () => {
      let newSumReceptionsFloats = 0;
      let newSumReceptions = '';
      let newRowsAccountinglUnit = [...rowsAccountinglUnit];
      newRowsAccountinglUnit.forEach(element => {
        newSumReceptionsFloats += parseFloat(element.amount);      
      });
      newSumReceptions = parseFloat(newSumReceptionsFloats).toFixed(decimalQuantitiesForAmount.current).toString();              
      setSumReceptions(newSumReceptions);
    }

    const setOnlyNumbers = (input,id) => {
      input.target.value = input.target.value.replace(REGEX_ONLY_NUMBER_AND_DOT,'')      
      if(input.target.value === ''){        
        processReceptionAmounts(0,id)
      }       
    }
    
    const setDefaultCeroValue = (input,id) => {
      if(input.target.value === ''){
        input.target.value = '0.00';
      }   
      input.target.value = parseFloat(input.target.value).toFixed(decimalQuantitiesForAmount.current);     
      processReceptionAmounts(input.target.value,id)
    }

    const controlValueForPercentage = (input) => {      
      formatNumberFloat(input,decimalQuantitiesForAmount.current,',');
      setValueBeetwenOneAndOneHundred(input);
      setPercentageOnshore(input.target.value);
    }

    const setValueBeetwenOneAndOneHundred = (input) => {
      var sval = input.target.value;
      var num = parseFloat(sval);
      if(num < 0){
        input.target.value = '1.00';
      }else if( num > 100){
        input.target.value = '100.00';
      }
    }

    const processOnShoreRadioButton = (radioButtonValue) => {
      setOnShoreValueSelected(radioButtonValue);
      setDefaultPercentageOnshore('');
      setEnableRenderOnShorePercentage(radioButtonValue === 'Y');        
    }

    const formatNumberFloat = (input, decQty, thSeparator) => {
      var sval = input.target.value
      if (sval.includes(thSeparator)) {
        //sval = sval.replace(",","");
        sval = sval.split(',').join(''); //replace all , for nothing
        sval = sval.split('$').join('');
      }
      if (sval != undefined && sval.trim() === ''){
        input.target.value = "0";
        return;
      }
      var num = parseFloat(sval);    
      var cleanNum = num.toFixed(decQty);
      if (isNaN(cleanNum))
        cleanNum = '';
      input.target.value = cleanNum;    
    }

    const goHomeScreen = () => {
        navigate('/home')
    };
   
    const showMsgDD2 = (value) => {
      changeDirectDebit(value); 
      setShowMsgDD2Modal(true);
    }
    const closeShowMsgDD2Modal = () => {
      setShowMsgDD2Modal(false);
    }   

    //start controller commodities from LA
    const openChangeCommodity = () => {
      setChangeCommodityLA(true);
    }

    const closeChangeCommodity = () => {
      setChangeCommodityLA(false);
    }

    const submitChangeCommodity = () => {
      let newRowsAccountinglUnit = [...rowsAccountinglUnit];

      let commcodeSelect = document.getElementById('idSelectCommcodeLA');
      let commcodeDescription = '';
      for (let i = 0; i<commcodeSelect.length; i++) {
        let option = commcodeSelect[i];
        if(option.value == commoditySelected){
          commcodeDescription = option.text;
          break;
        }
      }

      newRowsAccountinglUnit.forEach(row => {
        row.commodity = commoditySelected;
        row.description = commcodeDescription;      
        let tableCell = document.getElementById('description'+row.id+":description");
        tableCell.innerText = commcodeDescription;
      });

      commodityIsChange.current = true;
      setRowsAccountinglUnit(newRowsAccountinglUnit);                                  
      closeChangeCommodity();
    }

    const handleCheckBoxSelected = (row) => {
      let newRowsSelectedFromAllInvoiceTable = [...rowsSelectedFromAllInvoiceTable];
      let elementPosition = newRowsSelectedFromAllInvoiceTable.map(element => element.id).indexOf(row.id);
      if(elementPosition == -1 && !row.isSelected){
        newRowsSelectedFromAllInvoiceTable.push(row);
      }else if(row.isSelected){
        newRowsSelectedFromAllInvoiceTable.splice(elementPosition,1);
      }
      setRowsSelectedFromAllInvoiceTable(newRowsSelectedFromAllInvoiceTable);
    }

    
  const approverSelectUpdate = (role) =>  {
    if(role === "LastApprover") {
      setLastApprover(true);
    };
    if(role === "InvitedAfter") {
      setInvitedAfter(true);
    };
    if(role === "SecondLastApprover") {
      setsecondLastApprover(true);
    };    
  };
  const removeApprover = (selectedRows) => {
    preApprover = [];
    documentIAS.approvalRequests.forEach((emp) => {
      let i = 0
      preApprover.push(emp);
      i++;
    });
    let selectedEmployees = selectedRows.map((e) => e.id);
    preApprover.forEach((employee) => {
      selectedEmployees.forEach((id) => {
        if (id === employee.id) {
          preApprover.splice(id, 1);
        }
      });
    });
    let newId = 0;
    preApprover.forEach((employee) => {
      employee.id = newId;
      newId++;
    });
    setDocumentIAS(documentIAS => ({...documentIAS, approvalRequests: preApprover}));
    approverSelectUpdate(documentIAS.approvalRequests[selectedRows[0].id].role);
  };

  const approverSelectRemove = () =>  {
    if(documentIAS.approvalRequests) {
      documentIAS.approvalRequests.forEach((row) => {
        if(row.role === "LastApprover") {
          setLastApprover(false);
        };
        if(row.role === "InvitedAfter") {
          setInvitedAfter(false);
        };
        if(row.role === "SecondLastApprover") {
          setsecondLastApprover(false);
        };
        if(row.role === "TaxApprover") {
          setTaxApprover(false);
        };
      });
    }
  };

  const processApproverAttachment = (input) => {
    let files = input.target.files;
    let fileFound = false;
    if(files[0] != undefined){
      fileFound = true;
    }
    if(!fileFound){
      return;
    }
    setApproverAttachmentToSave(files[0]);
  }

  const processTaxTreatySelection = (selection) => {
    if(selection === 'Y'){
      setRenderTaxTreatyAttachmentUpload(true);
      setInvoiceHasTaxTreaty(true);
    }else{
      setRenderTaxTreatyAttachmentUpload(false);
      setInvoiceHasTaxTreaty(false);
    }
  }

  const processTaxTreatyAttachment = (input) => {
    let files = input.target.files;
    let fileFound = false;
    if(files[0] != undefined){
      fileFound = true;
    }
    if(!fileFound){
      return;
    }
    setTaxTreatyAttachmentToSave(files[0]);
  }

  const submitAddApproverAttachmentSelected = () => {
    if(approverAttachmentToSave.name === undefined){
      return;
    }    
    let formData = getGenericFormData('',approverAttachmentToSave);    
    if(isRequestActive(true)){
      return;
    }
    postApproverAttachment(formData)
    .then(response => {
      if(response.status === 200){
        myApproverFileUploadRefference.current.clearFiles();
        setApproverAttachmentToSave({})
        getInvoiceAttachments(documentIAS.idDoc);   
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      } else{
        response.text()
        .then(response => {
          openMessageModal(response);
        })
      }
      isRequestActive(false)
    });
  }

  const submitRemoveInvoiceAttachmentSelected = () => {
    if(approverAttachmentIdToRemove === ''){
      return;
    }

    let formData = getGenericFormData('');    
    formData.append('accion','delete');    
    formData.append("indice",approverAttachmentIdToRemove);

    if(isRequestActive(true)){
      return;
    }
    postApproverAttachment(formData)
    .then(response => {
      if(response.status === 200){
        myApproverFileUploadRefference.current.clearFiles();
        getInvoiceAttachments(documentIAS.idDoc);
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      } else{
        response.text()
        .then(response => {
          openMessageModal(response);
        })
      }
      isRequestActive(false)
    });
  }

  const submitAddTaxTreatyAttachmentSelected = () => {
    if(taxTreatyAttachmentToSave.name === undefined){
      return;
    }
    
    let formData = getGenericFormData('taxTreaty',taxTreatyAttachmentToSave);  
    if(isRequestActive(true)){
      return;
    }  
    postApproverAttachment(formData)
    .then(response => {
      if(response.status === 200){
        myFileUploadRefference.current.clearFiles();
        setTaxTreatyAttachmentToSave({});
        getTaxTreatyAttachments(documentIAS);   
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      } else{
        response.text()
        .then(response => {
          openMessageModal(response);
        })
      }
      isRequestActive(false)
    });
  }

  const getGenericFormData = (fileTo, attachmentToSave) => {
    let formData = new FormData();
    formData.append('idDoc',documentIAS.idDoc);
    formData.append('pais',documentIAS.ctrycode);
    formData.append('compania',documentIAS.compcode);
    formData.append('invonumb',documentIAS.invonumb);    
    formData.append('fileTo',fileTo);
    formData.append("file",attachmentToSave);
    return formData;
  }

  const submitRemoveTaxTreatyAttachmentSelected = () => {
    if(taxTreatyIdToRemove === ''){
      return;
    }

    let formData = getGenericFormData('taxTreaty');    
    formData.append('accion','delete');    
    formData.append("indice",taxTreatyIdToRemove);

    if(isRequestActive(true)){
      return;
    }  
    postApproverAttachment(formData)
    .then(response => {
      if(response.status === 200){
        myFileUploadRefference.current.clearFiles();
        getTaxTreatyAttachments(documentIAS);
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      } else{
        response.text()
        .then(response => {
          openMessageModal(response);
        })
      }
      isRequestActive(false)
    });
  }

  const processPaymentMethodSelection = (paymentMethodValue) => {
    console.log(paymentMethodValue)
    setPaymentMethodSelected(paymentMethodValue);
  }

  const processPaymentTermSelection = (paymentTermValue) => {
    if(paymentTermValue.selectedItem === null){
      setPaymentTermValueSelected(EMPTY_PAYMENT_TERM_AP_STATE)  
      return;
    }
    setPaymentTermValueSelected(paymentTermValue.selectedItem);
    if(dueDateValueSelected !== ''){
      setDueDateValueSelected('')
    }
  }

  const processDueDateSelection = (dueDateValue) => {
    let newDueDateValue = dueDateValue[0];
    if(newDueDateValue != undefined){
      //newDueDateValue = newDueDateValue.toISOString();
      const pad = (n) => String(n).padStart(2, '0');
      let year = newDueDateValue.getFullYear();
      let month = pad(newDueDateValue.getMonth() + 1);
      let day = pad(newDueDateValue.getDate());
      newDueDateValue = day + '/' + month + '/' + year;
      setDueDateValueSelected(newDueDateValue);
    }else{
      setDueDateValueSelected('');
    }
    if(paymentTermValueSelected.code !== ''){
      setPaymentTermValueSelected(EMPTY_PAYMENT_TERM_AP_STATE)
    }
  }  

  const formatDate = (dateString) => {
    if(dateString === undefined || dateString === ''){
      return '';
    }
    if(dateString.includes("/")){
      return dateString;
    }
    let [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  }

  const closePaymentModalS1 = () => {
    setHoldPaymentModalS1(false);
  }
  const openHoldPaymentModalS1 = () => {
    setHoldPaymentModalS1(true);
  }
  const holdPaymentGoS2 = () => {
    setHoldPaymentModalS1(false);
    if(legalDevolutionTimeExpired.current && rtvAndHoldPrOverdue.current){
      if(documentIAS.ctrycode === '815') {
        setMessageReturnToVendorOverdue(MESSAGEPR);
      }else{
        setMessageReturnToVendorOverdue('This action is not allowed as the '+
          'due date of the invoice is going to be in five days, less or has '+
          'already being exceeded');        
      }
      openReturnToVendorOverdue()
    }else{
      setHoldPaymentModalS2(true);
    }
  }
  const closePaymentModalS2 = () => {
    setHoldPaymentModalS2(false);
  }
  const holdPaymentGoS3 = () => {
    setHoldPaymentModalS2(false);
    setHoldPaymentModalS3(true);    
  } 
  const closePaymentModalS3 = () => {
    setHoldPaymentModalS3(false);
  }
  const holdPaymentGoS4 = () => {
    if(holdPaymentCauseLabel === ''){
      return;
    }
    setHoldPaymentModalS3(false);
    setHoldPaymentModalS4(true);
  }
  const closePaymentModalS4 = () => {
    setHoldPaymentModalS4(false);
  }
  const holdPaymentGoS5 = () => {
    setHoldPaymentModalS4(false);
    setHoldPaymentModalS5(true);
  }  
  const closePaymentModalS5 = () => {
    setHoldPaymentModalS5(false);
  }
  
  const processSave = () => {
    finalSubmitRequest('Save');
  }

  const submitHoldPayment = async () => {    
    let request = new FormData();
    request.append('accion', 'Hold');
    request.append('tipoReject', 'HoldPayment');
    request.append('idDoc', documentIAS.idDoc);
    request.append('correlation', false);
    request.append('litigation', false);
    request.append('waitingCredit', false);
    
    request.append('correlation', holdPaymentCause === 'correlation');
    request.append('litigation', holdPaymentCause === 'litigation');
    request.append('waitingCredit', holdPaymentCause === 'waitingCredit');

    request.append('opcionHold',holdPaymentCause);
    request.append('justification',holdPaymentJustification);
    request.append('file',rtvAttachmentToSave);
    
    if(isRequestActive(true)){
      return;
    }
    await postReturnToVendor(request)
    .then(async response => {
      if(response.status === 200){
        await getAllDocument(documentIAS.idDoc);
        window.location.reload();
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      } else{
        response.text()
          .then(response => {            
            openMessageModal(response);
          })
      }
    });
    
    isRequestActive(false)
    setHoldPaymentModalS5(false);    
  }  

  const openCancelHoldPaymentModal = () => {    
    setCancelHoldPaymentModal(true);
  }
  const closeCancelHoldPaymentModal = () => {
    setCancelHoldPaymentModal(false);
  }

  const downloadCoversheet = async () => {
      if(isRequestActive(true)){
        return;
      }
      await getInvoiceCoversheet()
      .then(response => {      
        response.blob().then(blob => {
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = response.headers.get('content-disposition');
          a.click();
        });
      });
      isRequestActive(false);
    }
  
  const [modalRequestEmployee,setModalRequestEmployee] = useState(false);
  const openModalRequestEmployee = () => {
    setModalRequestEmployee(true);
  }  

  const closeModalRequestEmployee = () => {    
    setModalRequestEmployee(false);
  }
 
  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      // Collect all arguments passed to the debounced function
      clearTimeout(timeout); // Clear any existing timeout
      timeout = setTimeout(() => {
        func.apply(this, args); // Execute the original function with the correct context and arguments addin coment
      }, delay);
    };
  }

  const debouncedSearchDepartment = debounce(searchDepartment, DEBOUNCE_TIME_FOR_REQUEST);
  const debouncedSearchMinor = debounce(searchMinor, DEBOUNCE_TIME_FOR_REQUEST);
  const debouncedSearchProject = debounce(searchProject, DEBOUNCE_TIME_FOR_REQUEST);
  const debouncedSearchManagers = debounce(searchManagers, DEBOUNCE_TIME_FOR_REQUEST);
  const debouncedSetInvitedEmployee = debounce(setInvitedEmployee, DEBOUNCE_TIME_FOR_REQUEST);
  const debouncedProcessReceptionAmounts = debounce(processReceptionAmounts, DEBOUNCE_TIME_FOR_REQUEST);
  const debouncedSearchInternalOrder = debounce(searchInternalOrder, DEBOUNCE_TIME_FOR_REQUEST);
  const debouncedSearchCostCenter = debounce(searchCostCenter, DEBOUNCE_TIME_FOR_REQUEST);
  const debouncedSearchGlAccount = debounce(searchGlAccount, DEBOUNCE_TIME_FOR_REQUEST);
  const debouncedSearchWbs = debounce(searchWbs, DEBOUNCE_TIME_FOR_REQUEST);
  const debouncedSearchProfitCenter = debounce(searchProfitCenter, DEBOUNCE_TIME_FOR_REQUEST);
  const debouncedSearchTransactionType = debounce(searchTransactionType, DEBOUNCE_TIME_FOR_REQUEST);

  useEffect(() => {
    calculateSumToReception();
  },[rowsAccountinglUnit])

  
  useEffect(() => {
    approverSelectRemove();
  }, [documentIAS])
  
  useEffect(() => {
    if(user && profileName) {
      getDocumentAlreadySelected();    
    }
  },  [user, profileName]);
  return (
    <>   
      <Theme theme="g90">
            <CommodityHeader />
      </Theme>
      <Grid className={"principal-grid"}>
      <Column lg={16} >
      <TableContainer>
        <Button className='style-bttbackID' size="lg" onClick={goHomeScreen}>Back to Home</Button>
        <h2 className="style-title-section">General Information</h2>
        <Grid>
          <Grid className="ids-second-step">
            <Column lg={6}>
              <Column className="rows-general-information" lg={8} md={8}>
                <p className="style-text-docview-idwitherror"><b>Responsible:</b></p>
                <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={documentIAS.firstApproverName} size="md" />
              </Column>
              <Column className="rows-general-information" lg={8} md={8}>
                <p className="style-text-docview-idwitherror"><b>Reception date:</b></p>
                <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={documentIAS.receptionDate} size="md" />
              </Column>
              <Column className="rows-general-information" lg={8} md={8}>
                <p className="style-text-docview-idwitherror"><b>Invoice Date:</b></p>
                <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={formatDate(documentIAS.invoiceDate)} size="md" />
              </Column>
              <Column className="rows-general-information" lg={8} md={8}>
                <p className="style-text-docview-idwitherror"><b>Due Date:</b></p>
                <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={formatDate(documentIAS.duedate)} size="md" />
              </Column>
              <Column className="rows-general-information" lg={8} md={8}>
                <p className="style-text-docview-idwitherror"><b>Approval Status:</b></p>
                {documentIAS.flowType === "IPVN" && (documentIAS.docStatus !== "RTV" && documentIAS.docStatus !== "HOLD") ?
                <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={""} size="md" /> :
                <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={documentIAS.docStatus} size="md" />                
                }                
              </Column>
              <Column className="rows-general-information" lg={8} md={8}>
                <p className="style-text-docview-idwitherror"><b>Form Type:</b></p>
                <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={documentIAS.flowType} size="md" />
              </Column>
              <Column className="rows-general-information" lg={8} md={8}>
                <p className="style-text-docview-idwitherror"><b>Internal Reference:</b></p>
                <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={documentIAS.invonumb} size="md" />
              </Column>
              <Column className="rows-general-information" lg={8} md={8}>
                <p className="style-text-docview-idwitherror"><b>Invoice Ref:</b></p>
                <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={documentIAS.cae} size="md" />
              </Column>
              <Column className="rows-general-information" lg={8} md={8}>
                {documentIAS.flowType=== "NONPO" && documentIAS.zone === "LA" ? <p className="style-text-docview-idwitherror">Comment:(Please use this section to describe the purchase)</p> :
                <p className="style-text-docview-idwitherror"><b>Comment:</b></p>
                }
                <TextArea disabled={true} className="style-input-docview-idwitherror" id="text-area-1" type="text" value={documentIAS.comment} size="md" />
              </Column>
            </Column>
            <Column lg={6}>
              <Column className="rows-general-information" lg={8} md={8}>
                <p className="style-text-docview-idwitherror"><b>Country Code:</b></p>
                <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={documentIAS.ctrycode} size="md" />
              </Column>
              {documentIAS.zone === 'AP' ? (
                  <Column className="rows-general-information" lg={8} md={8}>
                    <p className="style-text-docview-idwitherror"><b>Company:</b></p>
                    <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={documentIAS.compName} size="md" />
                  </Column>
                ):(
                  <Column className="rows-general-information" lg={8} md={8}>
                    <p className="style-text-docview-idwitherror"><b>Company Code:</b></p>
                    <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={documentIAS.compcode} size="md" />
                  </Column>
                )
              }
              <Column className="rows-general-information" lg={8} md={8}>
                <p className="style-text-docview-idwitherror"><b>Currency:</b></p>
                <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={documentIAS.currencyFC} size="md" />
              </Column>
              {documentIAS.zone !== 'AP' && 
                <Column className="rows-general-information" lg={8} md={8}>
                  <p className="style-text-docview-idwitherror"><b>Currency PO:</b></p>
                  <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={documentIAS.currencyRU} size="md" />
                </Column>
              }
              <Column className="rows-general-information" lg={8} md={8}>
                <p className="style-text-docview-idwitherror"><b>Supplier's Name:</b></p>
                <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={documentIAS.supplierName} size="md" />
              </Column>
              <Column className="rows-general-information" lg={8} md={8}>
                <p className="style-text-docview-idwitherror"><b>Invoice Number:</b></p>
                <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={documentIAS.rcpowayb} size="md" />
              </Column>
              {documentIAS.zone == 'AP' &&
                <Column className="rows-general-information" lg={8} md={8}>
                  <p className="style-text-docview-idwitherror"><b>Invoice Coversheet:</b></p>
                  <Column md={5} lg={5}>                  
                    <div style={{display:'inline-block', marginRight:'10px'}}>                
                      <a href="javascript: void(0)"
                        title={"Invoice Coversheet"}                             
                        onClick={downloadCoversheet}
                        >
                        <DocumentAttachment  size={42} style={{display:"block", marginLeft:"35px"}}/>
                        <label style={{display:"block",fontSize:'12px',marginLeft:'2px'}}>
                          Download Coversheet
                        </label>
                      </a>                                            
                    </div>                  
                  </Column>    
                </Column>
              }
              {documentIAS.zone != 'AP' &&
                <Column className="rows-general-information" lg={8} md={8}>
                  <p className="style-text-docview-idwitherror"><b>Exchange rate against dollar:</b></p>
                  <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={documentIAS.dollarExchange} size="md" />
                </Column>
              }
              
              {documentIAS.directDebitEnable && 
              <Column className="rows-general-information" lg={8} md={8}>
                <p className="style-text-docview-idwitherror"><b>Is Direct Debit already paid:</b></p> 
                  <RadioButtonGroup name="radio-button-group" className="general-info-radio">                    
                    <RadioButton labelText="TO BE PAID when due" value={"N"} 
                      disabled={!(hasTurn.current && actualRol.current === 'FirstApprover' && actualUserWithTurnStatus.current === 'Awaiting')}
                      checked={documentIAS.directDebit === "N" ? true : false} id="radio-directd-1" 
                      onClick={(e) => changeDirectDebit(e.target.value)}/>
                    <RadioButton labelText="Already paid, please DO NOT PAY" value={"Y"} 
                      disabled={!(hasTurn.current && actualRol.current === 'FirstApprover' && actualUserWithTurnStatus.current === 'Awaiting')}
                      checked={documentIAS.directDebit === "Y" ? true : false} id="radio-directd-2" 
                      onClick={(e) => showMsgDD2(e.target.value)}/>
                  </RadioButtonGroup>
              </Column>}              
              {userType === "privilegedUser" && documentIAS.fechaExport != "" && 
                <Column className="rows-general-information" lg={8} md={8}> 
                  <p className="style-text-docview-idwitherror">Export To Caaps Date:</p> 
                  <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={documentIAS.fechaExport} size="md" />
                </Column>}              
              {userType === "privilegedUser" && documentIAS.fechaExport != "" && 
                <Column className="rows-general-information" lg={8} md={8}>
                  <p className="style-text-docview-idwitherror">Paid:</p> 
                  <TextInput disabled={true} className="style-input-docview-idwitherror" id="text-input-1" type="text" value={documentIAS.fuePagada} size="md" />
                </Column>}              
            </Column>
          </Grid>
        </Grid>
        <h2 className="style-title-section">Attachments</h2>
        <Grid lg={16} mg={16} style={{marginLeft:'12px'}}>
            {(documentIAS.userInvolved || userType === "privilegedUser") &&              
                <Grid  style={{marginBottom:'20px'}}>            

            
                <TableContainer className={"style-table-attachments-approvers-info"}>
                  <Table useZebraStyles>
                    <TableHead>
                      <TableRow>
                        
                          <TableHeader>
                            <Column md={16} lg={16}>
                              <h5><b>Adding Attachments:</b></h5>
                              <p style={{fontSize:'12px'}}>To add an attachment click on Browse, after selecting the attachment click on Save to finish the upload</p>
                            </Column>    
                          </TableHeader>
                          <TableHeader>
                            <Column md={16} lg={16}>
                              <p><b>Removing Attachment:</b></p>
                            </Column>
                          </TableHeader>
                        
                      </TableRow>
                    </TableHead>
                    <TableBody>                      
                        <TableRow style={{marginTop:'30px'}}>                          
                          <TableCell>
                            <div style={{display:'flex', marginTop:'8px'}}>
                              <FileUploader labelTitle=""
                                ref={fileUploaderRefference => (myApproverFileUploadRefference.current = fileUploaderRefference)}                         
                                buttonLabel="Browse Attachment" 
                                buttonKind="primary" size="lg" filenameStatus="edit" 
                                multiple={false} 
                                onChange={(e) => {processApproverAttachment(e)}} 
                                onDelete={() => setApproverAttachmentToSave({})}
                                disabled={false} iconDescription="Delete file" name="" />    
                                <div>
                                  <Button style={{marginTop: '16px'}}                       
                                    onClick={submitAddApproverAttachmentSelected}>
                                      Save
                                  </Button> 
                              </div>                                            
                            </div>                       
                          </TableCell>                          
                          <TableCell >
                            <div style={{display:'flex'}}>
                              <div>
                                <Select  size="lg"
                                  labelText=""
                                  onChange={(e) => setApproverAttachmentIdToRemove(e.target.value)}
                                  id="idSelectApproverAttachmentidsLoaded">
                                  <SelectItem label="Select to remove" value=""/>
                                  {approverAttachments.map((row) => (              
                                    <SelectItem label={"Approver Attachment "+ (row.key.index+1)} value={row.key.index}/>
                                  ))}
                                </Select>    
                              </div>         
                              <div style={{marginTop:'8px', marginLeft:'30px'}}>
                                <Button onClick={submitRemoveInvoiceAttachmentSelected}>
                                  Remove
                                </Button>
                              </div>
                            </div>
                          </TableCell>                          
                        </TableRow>                                              
                    </TableBody>
                  </Table>
                </TableContainer>
                                        
                </Grid>
              
            }   
          </Grid>    
          <Grid lg={16} mg={16} style={{marginBottom:'10px'}}>
            <Column lg={16} mg={8}>
              <Column md={4} lg={16} style={{marginBottom:'12px'}}>
                <h5><b>Approver Attachment:</b></h5>
              </Column>
                <Column sm={4} md={8} lg={16}>
                    {approverAttachments.map((row) => (
                      <div style={{display:'inline-block', marginRight:'10px'}}>                
                        <a href="javascript: void(0)"
                          title={"Approver Attachment "+row.key.index}                             
                          onClick={() => window.open(row.pathname,"MyWindow","width=600,height=300")}
                          >
                          <DocumentAttachment  size={42} style={{display:"block", marginLeft:"35px"}}/>
                          <label style={{display:"block",fontSize:'12px',marginLeft:'10px'}}>
                            Open Attachment {row.key.index + 1}
                          </label>
                        </a>                      
                        <p>
                          <a href={row.pathname} style={{fontSize:'12px'}}
                            download={'ApproverAttachment-'+row.pathname}
                            >
                            Download Attachment {row.key.index + 1}
                          </a>
                        </p>
                      </div>
                    ))}            
                </Column>
            </Column>
          </Grid>     
          <Grid lg={16} mg={16}>
            <Column lg={16} mg={8}>                
              <Column md={4} lg={4} style={{marginBottom:'12px'}}>
                  <h5><b>Supplier Attachment:</b></h5>
              </Column>
              <Column md={5} lg={5}>
                  {supplierAttachments.map(row => (
                      <div style={{display:'inline-block', marginRight:'10px'}}>                
                      <a href="javascript: void(0)"
                        title={"Supplier Attachment "+row.key.index}                             
                        onClick={() => window.open(row.pathname,"MyWindow","width=600,height=300")}
                        >
                        <DocumentAttachment  size={42} style={{display:"block", marginLeft:"35px"}}/>
                        <label style={{display:"block",fontSize:'12px',marginLeft:'10px'}}>
                          Open Attachment {row.key.index + 1}
                        </label>
                      </a>                      
                      <p>
                        <a href={row.pathname} style={{fontSize:'12px'}}
                          download={'SupplierAttachment-'+row.pathname}
                          >
                          Download Attachment {row.key.index + 1}
                        </a>
                      </p>
                    </div>
                  ))}            
              </Column>                
            </Column>          
          </Grid>       

        <h2 className="style-title-section">Unit Information</h2>
        <Grid>
          <Column md={16} lg={16}>
            <h5><b>A. Approval Unit</b></h5>
          </Column>
          <Column md={16} lg={16}>
            <DataTable
              key={accountingTableKey}
              rows={rowsApprovalUnit}
              headers={headersApprovalUnit}
              render={({
                rows,
                headers,
                getHeaderProps,
                getRowProps,
                getTableProps,
                getSelectionProps
              }) => (
                <TableContainer className={"style-table-unit-info"}>
                  <Table {...getSelectionProps()} useZebraStyles>
                    <TableHead>
                      <TableRow>
                        {headers.map(header => (
                          <TableHeader {...getSelectionProps({ header })}>
                            {header.header}
                          </TableHeader>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((row, id) => (
                        <TableRow {...getRowProps({ row })}>
                          {row.cells.map((cell) => (
                            <TableCell key={id} >{cell.value}</TableCell>
                          ))}
                      </TableRow>                        
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            />
          </Column>
          {(rowsVatUnit[0] !== undefined && rowsVatUnit[0].id !== undefined) &&        
            <Column md={16} lg={16}>
              <DataTable
                key={vatTableKey}
                rows={rowsVatUnit}
                headers={headersVatUnit}
                render={({
                  rows,
                  headers,
                  getHeaderProps,
                  getRowProps,
                  getTableProps,
                  getSelectionProps
                }) => (
                  <TableContainer className={"style-table-unit-info"}>
                    <Table {...getSelectionProps()} useZebraStyles>
                      <TableHead>
                        <TableRow>
                          {headers.map(header => (
                            <TableHeader {...getSelectionProps({ header })}>
                              {header.header}
                            </TableHeader>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows.map((row, id) => (
                          <TableRow {...getRowProps({ row })}>
                            {row.cells.map((cell) => (

                              <TableCell key={id} className={cell.id.includes("headerEmpty") ? "cell-names-bold" : ""} >{cell.value}</TableCell>
                            ))}
                        </TableRow>                        
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              />
            </Column>
          }
          {showWithholdingTaxes &&         
            <Column md={16} lg={16}>
              <DataTable
                key={withholdingTableKey}
                rows={rowsWithholdingUnit}
                headers={headersWithholdingUnit}
                render={({
                  rows,
                  headers,
                  getHeaderProps,
                  getRowProps,
                  getTableProps,
                  getSelectionProps
                }) => (
                  <TableContainer className={"style-table-unit-info"}>
                    <Table {...getSelectionProps()} useZebraStyles>
                      <TableHead>
                        <TableRow>
                          {headers.map(header => (
                            <TableHeader {...getSelectionProps({ header })}>
                              {header.header}
                            </TableHeader>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows.map((row, id) => (
                          <TableRow {...getRowProps({ row })}>
                            {row.cells.map((cell) => (
                              <TableCell key={id} className={cell.id.includes("headerEmpty") ? "cell-names-bold" : ""}>{cell.value}</TableCell>
                            ))}
                        </TableRow>                        
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              />
            </Column>
          }
          <Column md={16} lg={16} style={{marginBottom:'15px'}}>
            <h5><b>B.Accounting Unit</b></h5>
          </Column>
          <Column md={16} lg={16}>
            {documentIAS.flowType === "NONPO" &&
              <p style={{}}>
                <p className="payment-info">NON PO - IMPORTANT REMINDER *** The Global NON PO categories list is updated regularly, requesters must check the latest version published Link: <a href="https://w3.ibm.com/w3publisher/gp-policies-and-practices/procurement-process/non-purchase-order-process/non-po-categories">Global Procurement Polices and Practices site</a>, their descriptions and requirements. </p>                            
                <p className="payment-info">The usage may be restricted only to authorized users or specific geos. In some cases, PRIOR approvals are required, please use the “Attachments” section to upload them.</p>                            
                <p className="payment-info">Please describe the purchase in the “Comment” field above. It is your responsibility to retain supporting documentation for audit purposes.</p>
              </p>
            }
            <DataTable
              
              rows={rowsAccountinglUnit}
              headers={headersAccountingUnit}
              render={({
                rows,
                headers,
                getHeaderProps,
                getRowProps,
                getTableProps,
                getSelectionProps
              }) => (
                <TableContainer className={"style-table-unit-info"}>
                  <Table {...getSelectionProps()} useZebraStyles>
                    <TableHead>
                      <TableRow>
                        {headers.map(header => (
                          <TableHeader {...getSelectionProps({ header })}>
                            {header.header}
                          </TableHeader>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((row,rowIndex) => (
                        <TableRow {...getRowProps({ row })}>
                          
                          {row.cells.map(cell => (
                            <>
                            {cell.id == "".concat(row.id, ":account") ? (
                                <TableCell className='accounting-cell' key={cell.id}>
                                  <Button kind="ghost" 
                                    disabled={!(documentIAS.flowType == 'NONPO'|| documentIAS.flowType == 'NC')} 
                                    renderIcon={Account} 
                                    iconDescription="Add account" 
                                    size="sm" title="" 
                                    onClick={() => openAccountingUnitModal(row.id)}></Button>
                                  <TextInput className="accounting-unit-button"     
                                    id={'idInputAccount'+cell.id}            
                                    title={cell.value}
                                    style={{minWidth: '10rem',  color: '#000000 !important'}} 
                                    disabled size="sm" defaultValue={cell.value}>                                      
                                  </TextInput>                                  
                                </TableCell>
                                ) : cell.id == "".concat(row.id, ":amount") ? (                                                                  
                                <TableCell className='style-size-column-modal-rtvlog2' key={cell.id+ cell.value}>
                                  <TextInput className="classNameTextInputAmounts"  
                                    id={"idInputAmount" + row.id}
                                    disabled={(hasTurn.current && actualRol.current === 'FirstApprover' && actualUserWithTurnStatus.current === 'Awaiting') ? false : true}                                                                      
                                    onKeyUp={(e) => setOnlyNumbers(e,row.id)}
                                    onBlur={(e) => setDefaultCeroValue(e,row.id)}
                                    onChange={(e) => debouncedProcessReceptionAmounts(e.target.value,row.id)} 
                                    style={{minWidth: '8rem', position: 'relative', color: '#000000 !important'}} 
                                    size="sm"  defaultValue={parseFloat(cell.value).toFixed(decimalQuantitiesForAmount.current)}>
                                  </TextInput> 
                                </TableCell>          
                                 ) : cell.id == "".concat(row.id, ":price") ? (                                                                  
                                  <TableCell className='style-size-column-modal-rtvlog2' key={cell.id+ cell.value}>
                                    <TextInput className="classNameTextInputAmounts"  
                                      id={"idInputAmount" + row.id}
                                      disabled={true}                                                                                                                                                                                        
                                      style={{minWidth: '8rem', position: 'relative', color: '#000000 !important'}} 
                                      size="sm"  defaultValue={parseFloat(cell.value).toFixed(decimalQuantitiesForAmount.current)}>
                                    </TextInput> 
                                  </TableCell>                              
                                ): cell.id == "".concat(row.id, ":aRUDescription") ? (
                                <TableCell className='style-size-column-modal-rtvlog2' 
                                  key={cell.id+ cell.value}>{parseFloat(cell.value).toFixed(decimalQuantitiesForAmount.current)}
                                </TableCell>
                                ) : cell.id == "".concat(row.id, ":total") ? (
                                <TableCell className='style-size-column-modal-rtvlog2' key={cell.id+ cell.value}>
                                </TableCell>
                                ) : cell.id == "".concat(row.id, ":checkbox")  ? (
                                  <TableCell className='style-size-column-modal-rtvlog2' key={cell.id+ cell.value}>
                                    {(documentIAS.flowType == 'NONPO'|| documentIAS.flowType == 'NC') &&
                                      <Checkbox id={cell.value} className='classNameCheckBoxAccount' />
                                    }
                                  </TableCell>
                                ) : cell.id == "".concat(row.id, ":description")  ? (                                  
                                  <TableCell className='style-size-column-modal-rtvlog2' id={'description'+cell.id} key={cell.id+ cell.value}>
                                      {cell.value === "" ? ("Empty") : (cell.value)}
                                  </TableCell>
                                ) : cell.id == "".concat(row.id, ":commodity") ? (
                                  <TableCell className='style-size-column-modal-rtvlog2' id={'commodity'+cell.id}  key={cell.id+ cell.value}>
                                    {cell.value === "" ? ("Empty") : (cell.value)}
                                  </TableCell>
                                )  : cell.id == "".concat(row.id, ":item") ? (
                                  <TableCell className='style-size-column-modal-rtvlog2' id={'commodity'+cell.id}  key={cell.id+ cell.value}>
                                    {cell.value === "" ? ("Empty") : (cell.value)}
                                  </TableCell>
                                ) : (
                                <TableCell className='style-size-column-modal-rtvlog2'  key={cell.id+ cell.value}>{cell.value === "" ? ("Empty") : (cell.value)}
                                </TableCell>
                              )}
                            </>
                          ))}
                        </TableRow>
                      ))}
                      <TableRow>
                        <TableCell key='AAk3'>
                        </TableCell>  
                        <TableCell key='AAk1'>
                          {(documentIAS.flowType == 'NONPO'|| documentIAS.flowType == 'NC') && (hasTurn.current && actualRol.current === 'FirstApprover' && actualUserWithTurnStatus.current === 'Awaiting') &&
                            <Button kind="ghost" renderIcon={AddAlt}                                                           
                              iconDescription={documentIAS.zone === 'AP' ? 'Split Row' :"Split Account Item"}
                              size="sm" title={documentIAS.zone === 'AP' ? 'Split Row' :"Split Account Item"}
                              onClick={addNewReception}>{documentIAS.zone === 'AP' ? 'Split Row' :"Split Account Item"}
                            </Button>
                          }
                        </TableCell>
                        <TableCell key='AAk2'>{(documentIAS.flowType == 'NONPO'|| documentIAS.flowType == 'NC') && (hasTurn.current && actualRol.current === 'FirstApprover' && actualUserWithTurnStatus.current === 'Awaiting') &&
                            <Button kind="ghost" 
                              renderIcon={SubtractAlt}                               
                              size="sm" 
                              iconDescription={documentIAS.zone === 'AP' ? 'Remove Row' :"Remove Account Item"}
                              title={documentIAS.zone === 'AP' ? 'Remove Row' :"Remove Account Item"}
                              onClick={removeReception}>{documentIAS.zone === 'AP' ? 'Remove Row' :"Remove Account Item"}
                            </Button>
                          }  </TableCell>
                        
                        <TableCell key='AAk4'>
                        {(documentIAS.zone === 'LA' && (documentIAS.flowType == 'NONPO'|| documentIAS.flowType == 'NC')) && (hasTurn.current && actualRol.current === 'FirstApprover') &&
                          <Button kind="ghost" renderIcon={Account}                             
                            iconDescription="Change Commodity" 
                            size="sm" title="Change Commodity" 
                            onClick={openChangeCommodity}>Change Commodity
                          </Button>
                        }
                        </TableCell>
                        <TableCell key='AAk5'></TableCell>
                        {!(documentIAS.flowType == 'NONPO'|| documentIAS.flowType == 'NC') &&
                          <TableCell key='AAk8'></TableCell>
                        }
                        {((documentIAS.zone == 'AP') || (emeaVatSplitEnable && documentIAS.zone == 'EMEA')) &&
                          <>
                            <TableCell key='AAk9'></TableCell>
                            <TableCell key='AAk10'></TableCell>
                          </>
                        }
                        <TableCell key='AAk6' style={{width: "14rem"}}>
                          <p><strong>Total: </strong>{parseFloat(documentIAS.netAmount).toFixed(decimalQuantitiesForAmount.current).toString()}</p> 
                        </TableCell>
                        {parseFloat(sumReceptions)!=parseFloat(documentIAS.netAmount) && (documentIAS.flowType === "NONPO" || documentIAS.flowType === "NC") ? (
                          <TableCell key='AAk7' style={{width: "14rem",color:'#DA1E28'}}>
                            <p><strong>Calculated: </strong>{parseFloat(sumReceptions).toFixed(decimalQuantitiesForAmount.current)}</p>
                          </TableCell>
                        ):(
                          <TableCell key='AAk7' style={{width: "14rem"}}>
                            <p><strong>Calculated: </strong>{parseFloat(sumReceptions).toFixed(decimalQuantitiesForAmount.current)}</p>
                          </TableCell>
                        )}
                        
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            />
          </Column>
          
          {documentIAS.ctrycode === "760" && 
          <>
            <Column md={16} lg={16}>
              <h5><b>C.Payment</b></h5>
            </Column>
            <Column md={16} lg={16} className="payment-info">          
            <br/>
            <p className="payment-info">When submitting / approving payment request, please ensure you will take full responsibilities as required in Corporate Instruction FIN 101 (e.g., select correct commodity code, utilize the most favorable payment terms for IBM, etc.)</p>
            <p className="payment-info">Please review <a>Corporate Instruction FIN 101</a> to ensure to be in compliance.</p>
            <br/>
            <h5><b>Payment Method</b></h5>
            <br/>
            <RadioButtonGroup legendText="" name="radio-button-vertical-group-payment-info" 
                orientation="vertical" >
              <Tooltip label="振込." align="right"  id="tooltip-1"  >
                <div>
                  <RadioButton className="payment-info" labelText="TT (Wire Transfer)"                     
                    checked={paymentMethodSelected === 'TT (Wire Transfer)'}                    
                    disabled={disablePaymentWireTransferRadioButton}
                    onClick={(e) => processPaymentMethodSelection(e.target.value)}
                    value="TT (Wire Transfer)" id="radio-1" />
                </div>
              </Tooltip>
              <Tooltip label="納付書." align="right" >
                <div>
                  <RadioButton className="payment-info" labelText="Manual Payment (Nofu-Sho)" 
                    checked={paymentMethodSelected === 'Manual payment (Nofu-Sho)'}
                    disabled={disableManualPaymentTransferRadioButton}
                    onClick={(e) => processPaymentMethodSelection(e.target.value)}
                    value="Manual payment (Nofu-Sho)" id="radio-2" />
                </div>
              </Tooltip>
              <Tooltip label="口座振替." align="right" >
                <div>
                  <RadioButton className="payment-info" labelText="Direct Debit" 
                    checked={paymentMethodSelected === 'Direct Debit'}
                    disabled={disableDirectDebitTransferRadioButton}
                    onClick={(e) => processPaymentMethodSelection(e.target.value)}
                    value="Direct Debit" id="radio-3" />
                </div>
              </Tooltip>
            </RadioButtonGroup>
            <br/>
            <h5><b>Payment Term</b></h5>
            <br/>
            <div style={{maxWidth:'290px',marginLeft:'15px'}}>
              <ComboBox onChange={(input) => {processPaymentTermSelection(input)}}                                            
                    id="select-payment-term" 
                    disabled={disablePaymentTermSelect}
                    selectedItem={paymentTermValueSelected.code === '' ? '' : paymentTermValueSelected}
                    items={ierpPaymentTerms} 
                    itemToString={item => item ? item.description.trim() : ''} 
                    placeholder="Select Payment Term" 
                    />            
              </div>
            <br/>
            {enableRenderDueDateSelection && 
            <>
              <div>
                OR
              </div>
              <br/>
              <h5><b>Due Date</b></h5>
              <br/>
              <DatePicker datePickerType="single" size='lg' style={{marginLeft:'-30px'}}
                value={dueDateValueSelected}
                onChange={(e) => processDueDateSelection(e)} dateFormat='d/m/Y'                
              >
                <DatePickerInput id="date-picker-single"                  
                  disabled={disableDueDatePicker}
                  placeholder="dd/mm/yyyy" labelText="" size="lg"/>                
                </DatePicker>
              <br/>                          
            </>
            }
            </Column>            
            </>
          }
        </Grid>
        {enableRenderTaxTreatyRadioButtons &&
          <Grid>
            <Column md={16} lg={16}>
              <RadioButtonGroup name="radio-button-group" className="general-info-radio" 
                  legendText="Does your document has Tax Treaty Access?">                    
                <RadioButton labelText="N" value={"N"} checked={!invoiceHasTaxTreaty} id="radio-directd-1" 
                  onClick={(e) => processTaxTreatySelection(e.target.value)}/>
                <RadioButton labelText="Y" value={"Y"} checked={invoiceHasTaxTreaty} id="radio-directd-2"
                  onClick={(e) => processTaxTreatySelection(e.target.value)}/>
              </RadioButtonGroup>
            </Column>          
          </Grid>
        }
        <br/>
        {renderTaxTreatyAttachmentUpload &&
        
          <Grid>
            <Column md={16} lg={16}>
              <p><b>Adding Attachment:</b></p>
              <p style={{fontSize:'12px'}}>To add an attachment click on Browse, after selecting the attachment click on Save to finish the upload</p>
            </Column>
            <Column sm={3}>
              <FileUploader labelTitle=""     
                ref={fileUploaderRefference => (myFileUploadRefference.current = fileUploaderRefference)}
                buttonLabel="Browse attachment" buttonKind="primary" size="lg" 
                filenameStatus="edit" multiple={false} 
                disabled={false}                
                onChange={(e) => {processTaxTreatyAttachment(e)}} 
                onDelete={() => setTaxTreatyAttachmentToSave({})}
                iconDescription="Delete file" name="" />           
                
            </Column>
            <Column sm={3} style={{marginTop:'15px'}}>
              <Button disabled={disabledTaxTreatySaveButton} 
                title={titleTaxTreatySaveButtons}
                onClick={submitAddTaxTreatyAttachmentSelected}>
                  Save
              </Button>
            </Column>
            <Column md={16} lg={16}>
              <p><b>Removing Attachment:</b></p>
            </Column>
            <Column sm={3} >
                <Select className="style-select-vertical" size="lg"
                    labelText=""
                    onChange={(e) => setTaxTreatyIdToRemove(e.target.value)}
                    id="idSelectTaxTreatiesLoadeds">
                  <SelectItem label="Select to remove" value=""/>
                  {attachmentsForTaxTreaty.map((row) => (              
                    <SelectItem label={"Tax Treaty "+row.index} value={row.index}/>
                  ))}
                </Select> 
            </Column>
            <Column sm={3}>
              <Button disabled={disabledTaxTreatyRemoveButton} 
                title={titleTaxTreatyRemoveButtons}
                onClick={submitRemoveTaxTreatyAttachmentSelected}>
                  Remove
              </Button>
            </Column>
            <Column md={16} lg={16}>
              <br></br>
              {attachmentsForTaxTreaty.map((row) => (              
                <div style={{display:'inline-block', marginRight:'10px'}}>                
                  <a  href="javascript: void(0)"
                      title={"Tax Treaty "+row.index}                                            
                      onClick={() => window.open(row.pathname,"MyWindow","width=600,height=300")}
                      >
                    <DocumentAttachment size={42} style={{display:"block", marginLeft:"35px"}}/>
                    <label style={{display:"block",fontSize:'12px',marginLeft:'10px'}}>
                      Open Tax Treaty {row.index}</label>
                  </a>                      
                  <p>
                    <a href={row.pathname} style={{fontSize:'12px'}}
                            download={row.pathname}>
                      Download Tax Treaty {row.index}
                    </a>
                  </p>
                </div>
              ))}              
            </Column>
          </Grid>
          
          
        }
        {((documentIAS.approvalRequests !== undefined && documentIAS.approvalRequests.length >= 1) && documentIAS.flowType != 'IPVN' )&&
        <>
        <h2 className="style-title-section">
          Approval Information
        </h2>
        <Grid>
          
            <Column md={16} lg={16} >
              <DataTable                
                rows={documentIAS.approvalRequests ? documentIAS.approvalRequests : []}
                headers={headersApprovalInformation}
                render={({
                  rows,
                  headers,
                  selectedRows,
                  getHeaderProps,
                  getRowProps,
                  getTableProps,
                  getSelectionProps,
                  getBatchActionProps,
                }) => (
                  <TableContainer >
                    <Table {...getTableProps()} useZebraStyles>
                      <TableHead>
                        <TableRow>
                          <TableHeader> </TableHeader>
                          {headers.map(header => (
                            <TableHeader {...getHeaderProps({ header })}>
                              {header.header}
                            </TableHeader>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell ></TableCell>
                          <TableCell >
                            
                            {!isDebitDocument()  && 
                            <Select  size="lg"
                              labelText=""
                              
                              id="select-role"
                              onChange={(e) => setApprovalRole(e.target.value)}
                              disabled={(actualRol.current.includes("Invited") || actualRol.current.includes("Last")) ? true : false}
                              
                            >
                              <SelectItem
                                label="Select role" value="Select role"
                              />
                              {documentIAS.ctrycode === "760" && taxApprover && <SelectItem
                                label="Tax Approver" value="Tax Approver"
                              />}
                            </Select>                            
                            }
                            {isDebitDocument() && 
                            <Select  size="lg"
                              labelText=""
                              id="select-role"
                              onChange={(e) => selectRol(e)}
                              disabled={(actualRol.current.includes("Invited")) || !hasTurn.current ? true : false}
                              
                            >
                              <SelectItem
                                label="Select role" value="Select role"
                              />
                              {invitedAfter && <SelectItem
                                label="Invited After" value="Invited After"
                              />}
                              {lastApprover && <SelectItem
                                label="Last Approver" value="Last Approver"
                              />}
                              {documentIAS.ctrycode === "760" && taxApprover && <SelectItem
                                label="Tax Approver" value="Tax Approver"
                              />}
                              {secondLastApprover && isSecondRequired && <SelectItem
                                label="Second Last Approver" value="Second Last Approver"
                              />}
                            </Select>                            
                            }
                            
                          </TableCell>
                          <TableCell>
                            {(approvalRole != "Select role" && approvalRole != "Last Approver" && approvalRole != "Second Last Approver") && <Button onClick={openFindEmployeesModal}>Find Employees</Button>}
                            {((approvalRole != "Select role" && approvalRole == "Last Approver") || (approvalRole != "Select role" && approvalRole == "Second Last Approver")) &&
                              <ComboBox  
                                onChange={(e) => addInvitedEmployee(e.selectedItem, approvalRole)} 
                                onInputChange={(inputText) => debouncedSearchManagers(inputText)}
                                id="carbon-combobox" 
                                size="sm"
                                placeholder="Search Managers" 
                                items={managersToShow} titleText="" helperText="" 
                                itemToString={item => item ? item.name + ' => ' + item.mail: ''}/>
                            }
                          </TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                        {rows.map((row) => (
                          <TableRow {...getRowProps({ row })}>
                            { showRowSelectCell(row)? 
                              <TableSelectRow {...getSelectionProps({ row })} /> : 
                              <TableCell></TableCell>                                
                            }                            
                            {row.cells.map(cell => (
                              <>
                                <TableCell className='' key={cell.id}>{cell.value === "" ? ("") : (cell.value)}</TableCell>
                              </>
                            ))}
                          </TableRow>
                        ))}
                        <TableRow></TableRow>
                        <TableRow></TableRow>
                        
                      </TableBody>
                    </Table>
                    <TableToolbar className='table-toolbar' style={{ marginTop: "0", background: "white" }}>
                      <TableBatchActions {...getBatchActionProps()}>
                        <TableBatchAction renderIcon={TrashCan} iconDescription="Delete" onClick={() => { removeApprover(selectedRows) }}>
                          Remove
                        </TableBatchAction>
                      </TableBatchActions>
                    </TableToolbar>
                  </TableContainer>
                )}
              />
            <Button size="md" kind="ghost" className="" onClick={() => openModalRequestEmployee()} style={{ marginLeft: "15px", width:'500px', maxWidth:'500px'}}>If you cannot add an approver, request access for them by clicking here</Button>
            </Column>
        </Grid>
        </>
        }
        {(documentIAS.docStatus === "RTV"  || documentIAS.docStatus === "Hold" )&& 
        <>
        <h2 className="style-title-section">RTV Information</h2>
        <Grid>
          <Grid className="ids-second-step">
            <Column lg={6}>
              <Column className="rows-general-information" lg={8} md={8}>
                <p className="style-text-docview-idwitherror">User:</p>
                <TextInput className="style-input-docview-idwitherror" id="text-input-1" 
                  type="text" 
                  value={invoiceRejectionInformation.user} 
                  size="md" />
              </Column>
              <Column className="rows-general-information" lg={8} md={8}>
                <p className="style-text-docview-idwitherror">Reason:</p>
                <TextInput className="style-input-docview-idwitherror" 
                  id="text-input-1" type="text" 
                  value={documentIAS.docStatus === 'RTV' ? 
                    invoiceRejectionInformation.rtvReason : invoiceRejectionInformation.justification} 
                  size="md" />
              </Column>
              {(documentIAS.docStatus === 'RTV' && invoiceRejectionInformation.comments !== '') &&
                <Column className="rows-general-information" lg={8} md={8}>
                  <p className="style-text-docview-idwitherror">Additional comments:</p>
                  <TextInput className="style-input-docview-idwitherror" 
                  id="text-input-1" type="text" 
                  value={invoiceRejectionInformation.comments} 
                  size="md" />
                </Column>
              }
              {(documentIAS.docStatus === 'RTV' && invoiceRejectionInformation.fuera_Periodo !== '') &&
                <Column className="rows-general-information" lg={8} md={8}>
                  <p className="style-text-docview-idwitherror">Return Legal Period:</p>
                  <TextInput className="style-input-docview-idwitherror" id="text-input-1" 
                    type="text" value={"Exceeds"} size="md" />
                </Column>
              }
              {documentIAS.docStatus === 'HoldPayment' &&
                <Column className="rows-general-information" lg={8} md={8}>
                  <p className="style-text-docview-idwitherror">Hold Payment:</p>
                  <TextInput className="style-input-docview-idwitherror" id="text-input-1" type="text" 
                    value={invoiceRejectionInformation.holdOption} size="md" />
                </Column>
              }
              {(documentIAS.docStatus === 'HoldPayment' && invoiceRejectionInformation.justificacion !== '') &&
                <Column className="rows-general-information" lg={8} md={8}>
                  <p className="style-text-docview-idwitherror">Reason:</p>
                  <TextInput className="style-input-docview-idwitherror" id="text-input-1" type="text" 
                    value={invoiceRejectionInformation.justification} size="md" />
                </Column>
              }

              <Column className="rows-general-information" lg={8} md={8}>
                <p className="style-text-docview-idwitherror">Date:</p>
                <TextInput className="style-input-docview-idwitherror" id="text-input-1" type="text" 
                  value={invoiceRejectionInformation.date} size="md" />
              </Column>
              
            </Column>
          </Grid>
        </Grid>
        </>
        }
        {(documentIAS.ldeliveryPoints !== '' && documentIAS.ldeliveryPoints !== undefined) &&
          <>
            <h2 className="style-title-section">          
              Delivery Points
            </h2>
            <Grid>
              <Column lg={8}>
                <Column className="rows-general-information" >
                  <p className="style-text-docview-idwitherror"><b>Delivery Points:</b></p>
                  <TextInput className="style-input-docview-idwitherror" id="text-input-1" type="text" disabled={true} value={documentIAS.ldeliveryPoints} size="md" />
                </Column>
              </Column>
            </Grid>
          </>
        }
        <div className="button-form" style={{margin: "1rem 0rem 10rem 0rem"}}>
          
          <Button onClick={goHomeScreen} className="button-info-title" size="md" >Back</Button>    
          
          {enableRejectButtons &&
            <>  
              {(countryWithRTV || userApplicationRol.includes('ApAdmin')) &&              
                <Button onClick={openReturnToVendor} className="button-info-title" size="md" >Return to Vendor</Button>              
              }
              {(countryWithHold || userApplicationRol.includes('ApAdmin')) &&
                <Button onClick={openHoldPaymentModalS1} className="button-info-title" size="md" >Hold Payment</Button>
              }        
            </>
          }
          {enableCancelHoldButton &&
            <Button onClick={openCancelHoldPaymentModal} className="button-info-title" size="md" >Cancel Hold Payment</Button>
          }
          {enableCancelRTVButton &&
            <Button onClick={openCancelReturnToVendor} className="button-info-title" size="md" >Cancel Return to Vendor</Button>
          }
          {enableCancelApprovalButtons &&
            <Button onClick={cancelApproval}  className="button-info-title" size="md" >Cancel Approval</Button>
          }
          {enableReassingButton && 
            <Button onClick={openReassignModal} className="button-info-title" size="md" >Reassign</Button>
          } 
          {enableAllOptionsButtons  && 
            <>              
              {(countryWithRTV || userApplicationRol.includes('ApAdmin')) &&
                <Button onClick={openReturnToVendor} className="button-info-title" size="md" >Return to Vendor</Button>
              }
              {(countryWithHold || userApplicationRol.includes('ApAdmin')) &&
                <Button onClick={openHoldPaymentModalS1} className="button-info-title" size="md" >Hold Payment</Button>                            
              }
            </>
          }
          {enableCommonUserButtonOption &&
            <>
              <Button onClick={openCommentModal} className="button-info-title" size="md" >Comment</Button>
              <Button onClick={openApprovalModal} className="button-info-title" size="md" >Approve</Button>
              <Button onClick={processSave} className="button-info-title" size="md" >Save</Button>  
            </>
          }
        {enableRejectMessageForApprovedInvoices &&
          <Grid style={{margin: "1rem 0rem 10rem 0rem"}} >
            <Column lg={12}>
              <p>The document has already been fully approved. To block or reject the payment, please open a 
              request called "Resolve invoice issues" on <a target="_blank" and rel="noopener noreferrer" href="https://ibm.service-now.com/Procurement@IBM">Procurement@IBM.</a></p>

              <p>Select "Submit a request", choose "IBM Requester actions" from the categories, then click on
              request type "Resolve invoice issues".</p>
            </Column>
          </Grid>
        }
                    
        </div>
      </TableContainer > 
      </Column>     
      </Grid>
      <Modal
        className="onboarding-modal"
        modalHeading="Please Select Department or Project"
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closeAccountinModal}
        onRequestSubmit={addAccountingToInput}
        onSecondarySubmit={closeAccountinModal}
        open={accountingUnitModal}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'md'}
        >
          <Tabs sstyle={{marginTop: "2rem"}}             
            onChange={(e) => {handleTabAccountingChange(e)}}>
          <TabList aria-label="List of tabs" contained >
            <Tab>Department</Tab>
            {lBalanceSheet.length > 0 && 
              <Tab>Balance Sheet</Tab>
            }
          </TabList>
          <TabPanels>
            <TabPanel>
            <Grid lg={4} mg={4} style={{width: "50rem"}} className="ids-second-step">
            <Column md={7} lg={7} style={{marginTop: '2rem'}}>
              <ComboBox 
                id="select-departament1"
                onChange={(e) => setDepartmentSelected(e.selectedItem)}
                helperText="Department:" labelText="" 
                titleText=""
                disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}
                items={caapsDepartmentToShow} 
                selectedItem={departmentAccountToInput}
                itemToString={item => item != null && item.depanumb != undefined ? item.key.depacode.trim() + '-' +item.depanumb.trim() + '-' + item.depaname.trim() : ''} 
                onInputChange={(inputText) => debouncedSearchDepartment(inputText)}
                placeholder="Search department"/>                                                    
            </Column>
          </Grid>
          <Grid lg={16} mg={16} style={{width: "50rem"}}>
            {lMinors.length > 0 &&
            <Column inline md={7} lg={7} style={{marginTop: '2rem'}}>
                <ComboBox id="select-minor1"
                  disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}
                  onInputChange={(inputText) => debouncedSearchMinor(inputText)}
                  onChange={(e) => setMinorSelected(e.selectedItem === null ? '' : e.selectedItem.minor)}
                  itemToString={item => item != null && item.minor != undefined ? item.minor.trim() : ''} 
                  items={caapsMinorToShow} 
                  selectedItem={minorAccountToInput}
                  placeholder="Search minor"
                  helperText="Minor:" labelText=""/>                                  
              </Column>
              }
            <Column inline md={1} lg={1} style={{marginTop: '2rem'}}>
              <p style={{marginBottom: '1rem'}}>OR</p>            
            </Column>
            <Column inline md={7} lg={7} style={{marginTop: '2rem'}}>
                <ComboBox id="select-project1"
                  disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}
                  onChange={(e) => setProjectSelected(getProyectRuAsString(e.selectedItem))}
                  onInputChange={(inputText) => debouncedSearchProject(inputText)}
                  helperText="Project:" labelText=""
                  placeholder="Search project"
                  itemToString={item => item != null && item.key != undefined ? item.key.projecod.trim() : ''} 
                  selectedItem={projectAccountToInput}
                  items={caapsProjectsToShow}
                  />
              </Column>
          </Grid>
          
            </TabPanel>
            <TabPanel>
              {lBalanceSheet.length > 0 &&
              <Grid lg={8} mg={8} className="ids-second-step" style={{width: "50rem"}}>

                <Column md={7} lg={7} style={{marginTop: '2rem'}}>
                  <Select id="select-commodity1"
                    key={"key-select-commodity"+keyCountBalanceSheet}
                    disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}
                    onChange={(e) => setBalanceSheetSelected(e.target.value)}
                    defaultValue={defaultBalanceSheet}
                    helperText="Balance Sheet:" labelText="">
                    <SelectItem value="" text="Select Balance Sheet" />
                    {lBalanceSheet.map((row) => (                                                        
                      <SelectItem value={getBalanceSheetRuAsString(row)} text={getBalanceSheetRuAsString(row)} />                                      
                    ))}
                  </Select>            
                </Column>
            </Grid>                      
            }
            </TabPanel>  
            {documentIAS.zone === 'EMEA' && lCommSerial.length > 0 &&
            <Grid lg={8} mg={8} className="ids-second-step" style={{width: "50rem"}}>
              <Column md={7} lg={7} style={{marginTop: '2rem'}}>
                <Select  id="idSelectCommcodeEmea"
                disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}
                  onChange={(e) => processCommoditySelected(e.target.value)}
                  helperText="Commodity Code:" labelText=""                  
                  defaultValue={documentIAS.commcode}>
                  <SelectItem value="" text="Select Commodity" />
                  {lCommSerial.map((row) => (                                                        
                    <SelectItem value={row.key.commcode} text={row.key.commcode+'-'+row.description} />                                                                                
                  ))}
                </Select>            
              </Column>
            </Grid>              
          }          
          </TabPanels>
        </Tabs>                    
      </Modal>
      <Modal
        className="onboarding-modal"
        modalHeading="Please provide the accounting information, will be saved only the selected tab"
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closeAccountinModalAP}
        onRequestSubmit={addAccountingToInput}
        onSecondarySubmit={closeAccountinModalAP}
        open={accountingUnitModalAP}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'lg'}
        >
        <Grid lg={16} mg={16} style={{ width: "85rem", marginBottom: "1rem"}}>
          <Column md={2} lg={2} style={{ marginTop: '1rem' }}>
            <p style={{ textAlignVertical: "center", textAlign: "right", marginTop: "0.75rem" }}>*Commodity:</p>
          </Column>
          <Column inline md={4} lg={4} style={{ marginTop: '1rem' }}>
            <Select id="idSelectCommcodeAp" 
                defaultValue={commcodeToInput.commcode}                
                key={commcodeToInput.commcode + commcodeToInput.key}
                disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}
                onChange={(e) => processCommoditySelected(e.target.value)}
                helperText=""
                labelText="">
              <SelectItem value="" text="Select Commodity" />
              {iERPCommoditiesList.map((row) => (                                                        
                <SelectItem value={row.commcode} text={row.commcode+'--'+row.commname+'--'+row.commclass} />                                                                                
              ))}
            </Select>
          </Column>
          <Column md={2} lg={2} style={{ marginTop: '1rem' }}>
            <p style={{ textAlignVertical: "center", textAlign: "right", marginTop: "0.75rem" }}>Item Description:</p>
          </Column>
          <Column inline md={4} lg={4} style={{ marginTop: '1rem' }}>
            <TextInput id="text-input-1" 
              disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}
              key={itemDescriptionToInput+'keyTextInputComment'}
              defaultValue={itemDescriptionToInput}
              onChange={(e) => setItemDescription(e.target.value)} 
              type="text" labelText="" helperText="" />
          </Column>
        </Grid>
        <Tabs style={{marginTop: "1rem"}} 
          selectedIndex={tabValuePreSelected}       
             
          onChange={(e) => {handleTabAccountingChangeAp(e)}}>
          <TabList aria-label="List of tabs" contained activation="manual">
            <Tab disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}>Expense</Tab>
            <Tab disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}>Balance Sheet</Tab>
            <Tab disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}>OIOC (Others)</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <Grid lg={16} mg={16} style={{ width: "75rem" }}>
                <Column md={2} lg={2} style={{ marginTop: '1rem' }}>
                  <p style={{ textAlignVertical: "center", textAlign: "right", marginTop: "0.75rem" }}>*Gl Account:</p>
                </Column>
                <Column inline md={4} lg={4} style={{ marginTop: '1rem' }}>
                  <ComboBox onChange={(input) => {processSelectGlAccount(input,1)}} 
                    id="idGlAccountCombobox1" 
                    key='keyGlAccountCombobox1'
                    items={ierpGlAccountsToShow} 
                    disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}
                    selectedItem={glAccountValueToInput1.code === '' ? '' : glAccountValueToInput1}
                    itemToString={item => item ? item.code.trim() + ' -- ' +item.desc.trim() : ''} 
                    placeholder="Search Gl Account" 
                    onInputChange={(inputText) => debouncedSearchGlAccount(inputText,1)}/>                  
                </Column>
                <Column md={2} lg={2} style={{ marginTop: '1rem' }}>
                </Column>
                <Column md={2} lg={2} style={{ marginTop: '1rem' }}>
                  <p style={{ textAlignVertical: "center", textAlign: "right", marginTop: "0.75rem" }}>*Cost Center:</p>
                </Column>
                <Column inline md={4} lg={4} style={{ marginTop: '1rem' }}>
                  <ComboBox onChange={(input) => {processSelectCostCenter(input)}} 
                    id="idCostCenterCombobox1" 
                    key='keyCostCenterCombobox1'
                    disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}
                    selectedItem={costCenterValueToInput1.code==='' ? '':costCenterValueToInput1}
                    items={ierpCostCenterToShow} 
                    itemToString={item => item ? item.code.trim() + ' -- ' +item.desc.trim() : ''} 
                    placeholder="Search Cost Center" 
                    onInputChange={(inputText) => debouncedSearchCostCenter(inputText)}/>
                </Column>
                
              </Grid>
              <Grid lg={16} mg={16} style={{ width: "75rem" }}>
                <Column md={2} lg={2} style={{ marginTop: '1rem' }}>
                  <p style={{ textAlignVertical: "center", textAlign: "right", marginTop: "0.75rem" }}>
                    {enableMandatoryInternalOrderTab1 && 
                      <span>*</span>
                    }  
                    Internal Order:
                  </p>
                </Column>
                <Column inline md={4} lg={4} style={{ marginTop: '1rem' }}>
                <ComboBox onChange={(input) => {processSelectInternalOrder(input)}} 
                  id="idInternalOrderCombobox1" 
                  disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}
                  selectedItem={internalOrderValueToInput1.code === ''? '':internalOrderValueToInput1}
                  items={ierpInternalOrderToShow} 
                  itemToString={item => item ? item.code.trim() + ' -- ' +item.desc.trim() : ''} 
                  placeholder="Search Internal Order" 
                  onInputChange={(inputText) => debouncedSearchInternalOrder(inputText)}/>
                </Column>
                <Column md={1} lg={1} style={{ marginTop: '1rem' }}>                  
                </Column>
                <Column md={1} lg={1} style={{ marginTop: '1rem' }}>
                </Column>
                <Column md={2} lg={2} style={{ marginTop: '1rem' }}>
                  <p style={{ textAlignVertical: "center", textAlign: "right", marginTop: "0.75rem" }}>
                    {enableMandatoryWbsTab1 && 
                      <span>*</span>
                    }
                    WBS:</p>
                </Column>
                <Column inline md={4} lg={4} style={{ marginTop: '1rem' }}>
                  <ComboBox onChange={(input) => {processSelectWbs(input)}} 
                    id="idWBSCombobox" 
                    disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}
                    selectedItem={wbsValueToInput1.code==='' ? '':wbsValueToInput1}
                    items={ierpWbsToShow} 
                    itemToString={item => item ? item.code.trim() + ' -- ' +item.desc.trim() : ''} 
                    placeholder="Search Wbs" 
                    onInputChange={(inputText) => debouncedSearchWbs(inputText)}/>
                </Column>
              </Grid>
            </TabPanel>
            <TabPanel>
              <Grid lg={16} mg={16} style={{ width: "75rem" }}>
                  <Column md={2} lg={2} style={{ marginTop: '1rem' }}>
                    <p style={{ textAlignVertical: "center", textAlign: "right", marginTop: "0.75rem" }}>
                      *Gl Account:
                      </p>
                  </Column>
                  <Column inline md={4} lg={4} style={{ marginTop: '1rem' }}>
                  <ComboBox onChange={(input) => {processSelectGlAccount(input,2)}} 
                    id="idGlAccountCombobox2" 
                    key='keyGlAccountCombobox2'
                    disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}
                    items={ierpGlAccountsToShow} 
                    selectedItem={ glAccountValueToInput2.code === '' ? '' : glAccountValueToInput2}                    
                    itemToString={ item => item  ? item.code.trim() + ' -- ' +item.desc.trim() : '' } 
                    placeholder="Search Gl Account" 
                    onInputChange={(inputText) => debouncedSearchGlAccount(inputText,2)}/>
                  </Column>
                  <Column md={2} lg={2} style={{ marginTop: '1rem' }}>
                  </Column>
                  <Column md={2} lg={2} style={{ marginTop: '1rem' }}>
                    <p style={{ textAlignVertical: "center", textAlign: "right", marginTop: "0.75rem" }}>
                      *Profit Center:
                    </p>
                  </Column>
                  <Column inline md={4} lg={4} style={{ marginTop: '1rem' }}>
                  <ComboBox onChange={(input) => {processSelectProfitCenter(input)}} 
                    id="idProfitCenterCombobox2" 
                    key='keyProfitCenterCombobox2'
                    disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}
                    selectedItem={profitCenterValueToInput2.code === '' ? '' : profitCenterValueToInput2}
                    items={ierpProfitCenterToShow} 
                    itemToString={item => item ? item.code.trim() + ' -- ' +item.desc.trim() : ''} 
                    placeholder="Search Profit Center" 
                    onInputChange={(inputText) => debouncedSearchProfitCenter(inputText)}/>
                  </Column>
                  <Column md={1} lg={1} style={{ marginTop: '1rem' }}>                    
                  </Column>
                </Grid>
                <Grid lg={16} mg={16} style={{ width: "75rem" }}>
                  <Column md={2} lg={2} style={{ marginTop: '1rem' }}>
                    <p style={{ textAlignVertical: "center", textAlign: "right", marginTop: "0.75rem" }}>
                      {enableMandatoryInternalOrderTab2 &&
                        <span>*</span>
                      }
                      Internal Order:
                    </p>
                  </Column>
                  <Column inline md={4} lg={4} style={{ marginTop: '1rem' }}>
                    <ComboBox onChange={(input) => {processSelectInternalOrder(input)}} 
                      id="idInternalOrderCombobox2" 
                      disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}
                      selectedItem={internalOrderValueToInput2.code === '' ? '' : internalOrderValueToInput2}
                      items={ierpInternalOrderToShow} 
                      itemToString={item => item ? item.code.trim() + ' -- ' +item.desc.trim() : ''} 
                      placeholder="Search Internal Order" 
                      onInputChange={(inputText) => debouncedSearchInternalOrder(inputText)}/>
                  </Column>
                  <Column md={1} lg={1} style={{ marginTop: '1rem' }}>                    
                  </Column>
                  <Column md={1} lg={1} style={{ marginTop: '1rem' }}>
                  </Column>
                  <Column md={2} lg={2} style={{ marginTop: '1rem' }}>
                    <p style={{ textAlignVertical: "center", textAlign: "right", marginTop: "0.75rem" }}>
                      {enableMandatoryTransactionTypeTab2 && 
                        <span>*</span>                      
                      }
                      Transaction Type:
                    </p>
                  </Column>
                  <Column inline md={4} lg={4} style={{ marginTop: '1rem' }}>
                    <ComboBox onChange={(input) => {processSelectTransactionType(input)}} 
                      id="idTransactionTypeCombobox" 
                      disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}
                      selectedItem={transactionTypeValueToInput2.code === '' ? '' : transactionTypeValueToInput2}
                      items={ierpTransactionTypeToShow} 
                      itemToString={item => item ? item.code.trim() + ' -- ' +item.desc.trim() : ''} 
                      placeholder="Search Transaction Type" 
                      onInputChange={(inputText) => debouncedSearchTransactionType(inputText)}/>
                  </Column>
                </Grid>
            </TabPanel>
            <TabPanel>
              <Grid lg={16} mg={16} style={{ width: "75rem" }}>
                  <Column md={2} lg={2} style={{ marginTop: '1rem' }}>
                    <p style={{ textAlignVertical: "center", textAlign: "right", marginTop: "0.75rem" }}>*Gl Account:</p>
                  </Column>
                  <Column inline md={4} lg={4} style={{ marginTop: '1rem' }}>
                  <ComboBox onChange={(input) => {processSelectGlAccount(input,3)}} 
                    id="idGlAccountCombobox3" 
                    disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}
                    selectedItem={glAccountValueToInput3.code === '' ? '' : glAccountValueToInput3}
                    items={ierpGlAccountsToShow} 
                    itemToString={item => item ? item.code.trim() + ' -- ' +item.desc.trim() : ''} 
                    placeholder="Search Gl Account" 
                    onInputChange={(inputText) => debouncedSearchGlAccount(inputText,3)}/>
                  </Column>
                  <Column md={2} lg={2} style={{ marginTop: '1rem' }}>
                  </Column>
                  <Column md={2} lg={2} style={{ marginTop: '1rem' }}>
                    <p style={{ textAlignVertical: "center", textAlign: "right", marginTop: "0.75rem" }}>
                      {enableMandatoryCostCenterTab3 &&
                        <span>*</span>
                      }
                    Cost Center:</p>
                  </Column>
                  <Column inline md={4} lg={4} style={{ marginTop: '1rem' }}>
                    <ComboBox onChange={(input) => {processSelectCostCenter(input)}} 
                    id="idCostCenterCombobox2" 
                    disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}
                    selectedItem={costCenterValueToInput3.code === '' ? '' : costCenterValueToInput3}
                    items={ierpCostCenterToShow} 
                    itemToString={item => item ? item.code.trim() + ' -- ' +item.desc.trim() : ''} 
                    placeholder="Search Cost Center" 
                    onInputChange={(inputText) => debouncedSearchCostCenter(inputText)}/>
                  </Column>
                  <Column md={1} lg={1} style={{ marginTop: '1rem' }}>                    
                  </Column>
                </Grid>
                <Grid lg={16} mg={16} style={{ width: "75rem" }}>
                  <Column md={2} lg={2} style={{ marginTop: '1rem' }}>
                    <p style={{ textAlignVertical: "center", textAlign: "right", marginTop: "0.75rem" }}>
                      {enableMandatoryProfitCenterTab3 &&
                        <span>*</span>
                      }
                      Profit Center:
                    </p>
                  </Column>
                  <Column inline md={4} lg={4} style={{ marginTop: '1rem' }}>
                  <ComboBox onChange={(input) => {processSelectProfitCenter(input)}} 
                    id="idProfitCenterCombobox3" 
                    key="keyProfitCenterCombobox3" 
                    disabled={!(hasTurn.current && actualRol.current === 'FirstApprover')}
                    selectedItem={profitCenterValueToInput3.code === '' ? '' : profitCenterValueToInput3}
                    items={ierpProfitCenterToShow} 
                    itemToString={item => item ? item.code.trim() + ' -- ' +item.desc.trim() : ''} 
                    placeholder="Search Profit Center" 
                    onInputChange={(inputText) => debouncedSearchProfitCenter(inputText)}/>
                  </Column>
                  <Column md={1} lg={1} style={{ marginTop: '1rem' }}>                    
                  </Column>
                  <Column md={1} lg={1} style={{ marginTop: '1rem' }}>
                  </Column>
                </Grid>
            </TabPanel>
          </TabPanels>
          {errorMessageAccountingAp!='' &&
            <p style={{fontWeight:'bold', fontSize:'18px',textAlign:'center'}}>{errorMessageAccountingAp}</p>
          }
          {enableWithholdingPreSelectTable && 
            <Grid >
              <Column inline md={4} lg={4} >
              <DataTable
                key={'keyDataTableWithholdings'}
                rows={rowsForeingWithholding}              
                headers={headersForeingWithholdingAp}
                render={({
                  rows,
                  headers,
                  getHeaderProps,
                  getRowProps,
                  getTableProps,
                  getSelectionProps
                }) => (
                  <TableContainer 
                  title=' '
                  description='Withholding Data to be Added'
                  className={"style-table-unit-info"}>
                    <Table {...getSelectionProps()}>
                      <TableHead>
                        <TableRow>
                          {headers.map(header => (
                            <TableHeader {...getSelectionProps({ header })}>
                              {header.header}
                            </TableHeader>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows.map((row, id) => (
                          <TableRow {...getRowProps({ row })}>
                            {row.cells.map((cell) => (
                              <TableCell key={id} >{cell.value}</TableCell>
                            ))}
                        </TableRow>                        
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
                />
              </Column>
            </Grid>
          }
          {enableWithholdingSearchId && 
            <Grid>
              <Column md={10} lg={9} style={{ marginLeft: '2.5rem' }}>
                <p id="idPForLinkWithholdingId"><a
					  					href="https://w3.ibm.com/w3publisher/buy-ibm-user-resources-jp/tax-witholding"
					  					target="_blank">Click here to answer some questions to get the
					  					corresponding Witholding ID</a></p>
              </Column>
            </Grid>
          }
          {enableRenderingWithholdingIdInput &&
            <Grid lg={16} mg={16} style={{ width: "85rem", marginBottom: "1rem"}}>            
              <Column md={2} lg={2} style={{ marginTop: '1rem' }}>
                <p style={{ textAlignVertical: "center", textAlign: "right", marginTop: "0.75rem" }}>* Withholding ID:</p>
              </Column>
              <Column inline md={4} lg={4} style={{ marginTop: '1rem' }}>
                <TextInput id="text-input-1" 
                  key={'keyTextInputWithholdingId'+withholdingIdDefaultValueSelected}
                  defaultValue={withholdingIdDefaultValueSelected}
                  disabled={disableWithholdingIdInput}
                  maxCount={4}
                  enableCounter={true}
                  onChange={(e) => setWithholdingId(e.target.value)} 
                  type="text" labelText="" helperText="" />
              </Column>
            </Grid>
          }
          {enableRenderingWithholdingTaxSelect &&
          <>
            <Grid lg={8} mg={8} style={{ width: "80rem"}}>
              <Column md={16} lg={16} style={{ marginTop: '1rem' }}>
                <p style={{fontWeight: 'bold'}}>The withholding tax type and code will be seleted by the withholding reviewer, please don't forget to add him</p>
              </Column>
            </Grid>
            <Grid lg={16} mg={16} style={{ width: "85rem", marginBottom: "1rem"}}>
              <Column md={2} lg={2} style={{ marginTop: '1rem' }}>
                <p style={{ textAlignVertical: "center", textAlign: "right", marginTop: "0.75rem" }}>Withholding Taxes:</p>
              </Column>
              <Column inline md={4} lg={4} style={{ marginTop: '1rem' }}>
                <Select id="idWithholdingTaxes" 
                    disabled={disabledWithholdingTaxSelect}
                    defaultValue={withholdingCodeDefaultValueSelect}                
                    key={'keyWithholdingTaxes'+withholdingCodeDefaultValueSelect}
                    onChange={(e) => processWithholdingTaxes(e.target.value)}
                    helperText=""
                    labelText="">
                  <SelectItem value="Select One" text="Select One" />
                  {ierpWithholding.map((row) => (                                                        
                    <SelectItem value={row.wht_code+'-'+row.wht_type} text={row.wht_code+'-'+row.wht_type+'-'+row.gensendesc} />                                                                                
                  ))}                                                                                                             
                </Select>
              </Column>
            </Grid>
            </>
          }
          {enableRenderOnShoreRadioButton &&
            <Grid lg={16} mg={16} style={{ width: "85rem", marginBottom: "1rem"}}>
              <Column  lg={8} md={8}>
                <p>Please select if the item is onshore or offshore:</p>  
                  <RadioButtonGroup name="radio-button-group-onshore-ap" valueSelected={onShoreValueSelected} className="general-info-radio">                    
                    <RadioButton disabled={disableOnShoreRadioButtons} labelText="On Shore" value={"Y"} 
                      id="radio-onshore-1"
                      onClick={(e) => processOnShoreRadioButton(e.target.value)}/>
                    <RadioButton disabled={disableOnShoreRadioButtons} labelText="Off Shore" value={"N"} 
                       id="radio-offshore-2" 
                      onClick={(e) => processOnShoreRadioButton(e.target.value)}/>
                  </RadioButtonGroup>
              </Column>
            </Grid>
          }
          {enableRenderOnShorePercentage && 
            <Grid lg={16} mg={16} style={{ width: "85rem", marginBottom: "1rem"}}>            
              <Column md={2} lg={2} >
                <p style={{ textAlignVertical: "center", textAlign: "right", marginTop: "0.75rem" ,width:'10rem'}}>
                  Percentage On Shore:
                </p>
              </Column>
              <Column inline md={4} lg={4} >
                <TextInput id="text-input-1" 
                  key={'keyTextInputOnShore'+defaultPercentageOnshore}
                  defaultValue={defaultPercentageOnshore}             
                  disabled={disableOnShorePercentage}                   
                  onBlur={(e) => controlValueForPercentage(e)}
                  onChange={(e) => setPercentageOnshore(e.target.value)} 
                  type="text" labelText="" helperText="" />
              </Column>
            </Grid>
          }
        </Tabs>
       
        <p style={{ textAlignVertical: "center", textAlign: "left", marginTop: "0.75rem" }}>Mandatory Fields (*)</p>
        <h4 style={{ textAlignVertical: "center", textAlign: "left", marginTop: "0.75rem" }}>Only the selected tab will be saved</h4>
      </Modal>
      <Modal
        onRequestClose={closeShowMsgDD2Modal}
        onRequestSubmit={closeShowMsgDD2Modal}
        onSecondarySubmit={closeShowMsgDD2Modal}
        open={showMsgDD2Modal}
        modalHeading="Direct Debit already paid:"
        primaryButtonText="Ok">        
        <p>The payment will not be effective only will be booked at accounting level</p>        
      </Modal>
      <Modal
        className="onboarding-modal"
        modalHeading="Please, in order to find a employees put name or email data"
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closeFindEmployeesModal}
        onRequestSubmit={() => processEmployeeSelected()}
        onSecondarySubmit={closeFindEmployeesModal}
        open={findEmployeesModal}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'lg'}
        >
          <Grid lg={16} mg={16} style={{width: "80rem"}}>
            <Column md={3} lg={3} style={{ marginTop: '2rem' }}>
              <p style={{ textAlignVertical: "center", textAlign: "right", marginTop: "0.75rem" }}>Find Approver:</p>
            </Column>
            <Column inline md={5} lg={5} style={{ marginTop: '2rem' }}>
              <TextInput size="md" placeholder="Search Approver" labelText=""  
                helperText='(please enter 3 chars for the search)'
                ref={inputSearchInviteEmployee}
                closeButtonLabelText="Clear search input" id="search-invited-approver" 
                onChange={(e) => {debouncedSetInvitedEmployee(e.target.value)}} 
                 />
            </Column>
            <Column md={1} lg={1} style={{ marginTop: '2rem' }}>
              <Button size="md" className="" onClick={() => searchInvitedEmployee(invitedEmployee)} style={{ paddingRight: "0.1rem", width: "9rem" }}>Find</Button>
            </Column>
            <Column md={1} lg={1} style={{ marginTop: '2rem' }}>
            </Column>
            <Column md={5} lg={5} style={{ marginTop: '2rem', marginLeft: '1rem' }}>
              {invitedEmployeeResponse.length > 0 && 
                <Select id="select-commodity1" helperText="" labelText="" defaultValue="Select an option" 
                  onChange={(e) => {selectNewApprover(invitedEmployeeResponse[e.target.value], approvalRole)}}>
                  <SelectItem value={"Select an option"} text="Select an option" />
                  {invitedEmployeeResponse.map((employee, id) => (
                    <SelectItem value={id} text={employee.name + " => " + employee.mail} />
                  ))}
                </Select>}
            </Column>
          </Grid>
                       
      </Modal>

      <Modal
        className="onboarding-modal"
        modalHeading="Please add a comment with no more than 300 characters:"
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closeCommentModal}
        onRequestSubmit={submitCommentModal}
        onSecondarySubmit={closeCommentModal}
        open={commentModal}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'lg'}
        > 
            <Column md={3} lg={3} style={{ marginTop: '2rem' }}>
              <TextArea labelText=""                 
                counterMode="character"
                enableCounter="true"
                maxCount={300}
                onChange={(e) => updateComment(e.target.value)}
                defaultValue={documentIAS.comment}
                rows={4} id="text-area-1" />
            </Column>                       
      </Modal>
      <Modal
        className="onboarding-modal"
        modalHeading={messageForModalApproveInvoice}
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closeApprovalModal}
        onRequestSubmit={submitApprovalModal}
        onSecondarySubmit={closeApprovalModal}
        open={approvalModal}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'lg'}
        >
            <Column md={3} lg={3} style={{ marginTop: '2rem' }}>              
            </Column>             
      </Modal>
      <Modal
        className="onboarding-modal"
        modalHeading=""
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closeChangeCommodity}
        onRequestSubmit={submitChangeCommodity}
        onSecondarySubmit={closeChangeCommodity}
        open={changeCommodityLA}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'lg'}
        >
          
            {documentIAS.zone === 'LA' &&
            <Grid lg={8} mg={8} className="ids-second-step" style={{width: "50rem"}}>
              <Column md={7} lg={7} style={{marginTop: '2rem'}}>
                <Select style={{width: "15rem"}} id="idSelectCommcodeLA"
                  onChange={(e) => processCommoditySelected(e.target.value)}
                  helperText="Commodity Code:" labelText=""                  
                  defaultValue={documentIAS.commcode}>
                  <SelectItem value="" text="Select Commodity" />
                  {lCommSerial.map((row) => (                                                        
                    <SelectItem value={row.key.commcode} text={row.key.commcode+'-'+row.description} />                                                                                
                  ))}
                </Select>            
              </Column>
            </Grid>              
            }           
          
      </Modal>

      <Modal
        className="onboarding-modal"
        modalHeading=""
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closeReturnToVendor}
        onRequestSubmit={submitReturnToVendor}
        onSecondarySubmit={closeReturnToVendor}
        open={returnToVendor}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'lg'}
        >
          
          <Column md={3} lg={3} style={{ marginTop: '2rem' }}>              
            <p>
              You are about to return a document to the Supplier. Please take the 
              legal and tax <br/> regulations of the country into account.
            </p>            
            <p>
              Please note, by rejecting a document sent by the Supplier to request payment
              for goods, you are <br/> responsible to fulfill the required procedures of 
              returning the products and to cancel any fiscal document.
            </p>                          
          </Column>                    
      </Modal>

      <Modal
        className="onboarding-modal"
        modalHeading=""
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closeReturnToVendorOverdue}
        onRequestSubmit={closeReturnToVendorOverdue}
        
        open={returnToVendorOverdue}
        primaryButtonText="Ok"
        
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'lg'}
        >
          
          <Column md={3} lg={3} style={{ marginTop: '2rem' }}>              
            <p>{messageReturnToVendorOverdue}</p>              
          </Column>                    
      </Modal>
      <Modal
        className="onboarding-modal"
        modalHeading={<strong>This action exceeds the legal period</strong>}
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closeReturnToVendorOverdue2}
        onRequestSubmit={submitReturnToVendorOverdue2}
        primaryButtonDisabled={!isCheckedReturnToVendor2}
        open={returnToVendorOverdue2}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'lg'}
        >                  
          <Column md={3} lg={3} style={{ marginTop: '2rem' }}>              
            <p>The return is already agreed with the supplier</p>              
          </Column>                   
          <Column md={3} lg={3} style={{ marginTop: '2rem' }}>              
            <p>Tax approval has already been agreed</p>              
          </Column>                   
          <Column md={3} lg={3} style={{ marginTop: '2rem' }}>              
            <p>I take care for the monitoring</p>              
          </Column>         
                    
          <Column md={3} lg={3} style={{ marginTop: '2rem' }}>              
            <Checkbox id="idCheckBoxReturnToVendor" onChange={(_,{checked}) => setIsCheckedReturnToVendor2(checked)}
              labelText={'As requester I accept that I have fulfilled the conditions described in this screen'}>
            </Checkbox>
          </Column>                                   
      </Modal>
      <Modal
        className="onboarding-modal"
        modalHeading={<><strong>Please, enter the email of the supplier</strong></>}
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closeReturnToVendor2}
        onRequestSubmit={submitReturnToVendor2}
        primaryButtonDisabled={isFirstRTVEmailInvalid}
        open={returnToVendor2}        
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'lg'}
        > 
          
          
          <Column md={3} lg={3} style={{ marginTop: '2rem' }}>              
            <TextInput id="idTextInputEmailRTV1" onChange={(e) => validateFirstEmail(e.target.value)} placeholder="john.doe@domain.com"></TextInput>
          </Column>     
          {enableSecondEmailRTV &&
            <Column md={3} lg={3} style={{ marginTop: '2rem' }}>              
              <TextInput id="idTextInputEmailRTV2" onChange={(e) => setSecondEmailRTV(e.target.value)} placeholder="john.doe@domain.com"></TextInput>
            </Column>         
          }          
          {enableThirdEmailRTV && 
            <Column md={3} lg={3} style={{ marginTop: '2rem' }}>              
              <TextInput id="idTextInputEmailRTV3" onChange={(e) => setThirdEmailRTV(e.target.value)} placeholder="john.doe@domain.com"></TextInput>
            </Column>         
          }
          {errorMessageReturnToVendor2Modal!= '' &&
            <Column md={3} lg={3} style={{ marginTop: '2rem' }}>                               
              <p className="error-p">{errorMessageReturnToVendor2Modal}</p>
            </Column>     
          }
          {!enableThirdEmailRTV && 
            <Column md={3} lg={3} style={{ marginTop: '2rem' }}>     
              <Button kind="ghost" renderIcon={AddAlt}                             
                iconDescription="Add new email" 
                size="sm" title="Add new email" 
                onClick={addNewEmail}>Add new email
              </Button>                      
            </Column>          
          }                    
          {showRemoveEmailRTV &&
            <Button kind="danger--ghost" 
              renderIcon={SubtractAlt}                
              iconDescription="Remove Email" 
              size="sm" title="Remove Email" 
              onClick={removeNewEmail}>Remove Last Email
            </Button>         
          }                                             
      </Modal>
      <Modal
        className="onboarding-modal"
        modalHeading=''
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closeReturnToVendor3}
        onRequestSubmit={submitReturnToVendor3}        
        open={returnToVendor3}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'lg'}
        >                  
          <Grid>
            <Column md={7} lg={16} style={{marginBottom:'12px'}}>              
              <h6 style={{marginBottom:'12px'}}><b>*Please select the reason for this action</b></h6>
              <Select size="lg"
                labelText=""                
                id="select-Rtv-reason-rejection"
                onChange={(e) => processSelectionReasonRtv(e.target.selectedOptions)}                
                >
                <SelectItem
                  label="Select One" value="0"
                />
                {rtvReasonList.map((element,index) => (
                  <SelectItem label={element} value={index+1}/>
                ))}
              </Select>    
            </Column>     
            <Column md={7} lg={16} >              
              <h6><b>{documentIAS.zone !== 'AP' && <span>*</span>}Please attach the evidence</b></h6>
              <FileUploader labelTitle=""
                        ref={fileUploaderRefference => (myRtvFileUploadRefference.current = fileUploaderRefference)}                         
                        buttonLabel="Add Attachment" 
                        buttonKind="primary" size="lg" filenameStatus="edit" 
                        multiple={false} 
                        onChange={(e) => {processRejectionAttachment(e)}} 
                        onDelete={() => setRtvAttachmentToSave({})}
                        disabled={false} iconDescription="Delete file" name="" />
            </Column>
            {enableRenderTextAreaReasonReject &&
              <Column md={7} lg={16} style={{marginBottom:'6px'}}>        
                <h6 style={{marginBottom:'6px'}}><b>*Reject Reason</b></h6>  
                <TextArea labelText=""                 
                  counterMode="character"
                  enableCounter="true"
                  maxCount={300}
                  onChange={(e) => setRtvReasonOtherRejection(e.target.value)}
                  defaultValue={''}
                  rows={4} id="text-area-1" />
              </Column>         
            }
            <Column md={7} lg={16} >        
            <h6 style={{marginBottom:'6px'}}><b>Additional comment</b></h6>  
              <TextArea labelText=""                 
                counterMode="character"
                enableCounter="true"
                maxCount={300}
                onChange={(e) => processCommentToRtv(e.target.value)}
                defaultValue={''}
                rows={4} id="text-area-1" />
            </Column>                       
            </Grid>
                                                                           
      </Modal>

      <Modal
        className="onboarding-modal"
        modalHeading=''
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closeReturnToVendor4}
        onRequestSubmit={submitReturnToVendor4}        
        open={returnToVendor4}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'lg'}
        >                  
          <Grid>
            <Column lg={16}>
              <p style={{fontSize:'14px'}}><b>Do you agree?</b></p>
              <p style={{fontSize:'14px'}}><b>You are returning a document to the Supplier.</b></p>
              
              <p style={{fontSize:'14px'}}><b>Suppliers mails:</b> {firstEmailRTV}
                {secondEmailRTV !== ''&& ','+secondEmailRTV}
                {thirdEmailRTV !== ''&& ','+thirdEmailRTV}</p>
              <p style={{fontSize:'14px'}}><b>Reason for rejection:</b> {rtvReasonRejection.label === 'Others' ? rtvReasonOtherRejection : rtvReasonRejection.label}</p>
              <p style={{fontSize:'14px'}}><b>Aditional comments:</b> {commentToRtv}</p>
              <p style={{fontSize:'14px'}}><b>Attachments:</b> {rtvAttachmentToSave.name}</p>
            </Column>
          </Grid>

      </Modal>

      <Modal
        className="onboarding-modal"
        modalHeading=''
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closeCancelReturnToVendor}
        onRequestSubmit={ () => submitCancelRejection('CancelRTV')}        
        open={cancelReturnToVendor}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'lg'}
        >                  
          <Grid>
            <Column lg={16}>
            <TextArea labelText="You are canceling the return to vendor of this document. Please enter a reason"                 
                counterMode="character"
                enableCounter="true"
                maxCount={300}
                onChange={(e) => processSetReasonToCancelRejection(e.target.value)}                
                rows={4} id="text-area-1" />
            </Column>
          </Grid>
      </Modal>
      <MessageModal messageCallback={messageResponse.current} messageModalCallback={messageModal} closeMessageModalCallback={closeMessageModal}/>
      <Modal
        className="onboarding-modal"
        modalHeading=""
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closePaymentModalS1}
        onRequestSubmit={holdPaymentGoS2}
        onSecondarySubmit={closePaymentModalS1}
        open={holdPaymentModalS1}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'md'}
      >
        <div className="hold-payment-modal">
          <p>Please take the legal and tax regulations of the country into account and remember that you are 
            <br /> about to withhold a supplier payment. This document will be analyzed by Accounts Payable.</p>          
        </div>
      </Modal>
      <Modal
        className="onboarding-modal"
        modalHeading="Still want to continue?"
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closePaymentModalS2}
        onRequestSubmit={holdPaymentGoS3}
        onSecondarySubmit={closePaymentModalS2}
        open={holdPaymentModalS2}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'md'}
      >
        <div className="hold-payment-modal">
          <p className="hold-payment-modal" >You are about to withhold a supplier payment. If it is unjustified, it can lead to late payment fees and/or possible litigation.</p>
        </div>
      </Modal>
      <Modal
        className="onboarding-modal"
        modalHeading="Choose the option that applies:"
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closePaymentModalS3}
        onRequestSubmit={holdPaymentGoS4}
        onSecondarySubmit={closePaymentModalS3}
        open={holdPaymentModalS3}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'md'}
      >
        <div className="hold-payment-modal">
          <RadioButtonGroup name="radio-button-group" className="general-info-radio" orientation="vertical">
            <RadioButton labelText="Correction Letter" value="correlation" id="radio-correction-letter" onClick={(e) => {setHoldPaymentCause(e.target.value); setHoldPaymentCauseLabel(e.target.labels[0].innerText)}} />
            <RadioButton labelText="Litigation" value="litigation" id="radio-litigation" onClick={(e) => {setHoldPaymentCause(e.target.value); setHoldPaymentCauseLabel(e.target.labels[0].innerText)}} />
            <RadioButton labelText="Waiting for a Credit" value="waitingCredit" id="radio-waiting-credit" onClick={(e) => {setHoldPaymentCause(e.target.value); setHoldPaymentCauseLabel(e.target.labels[0].innerText)}} />
            <RadioButton labelText="Invoice Details Incorrect" value="invoiceIncorrect" id="radio-invoice-incorrect" onClick={(e) => {setHoldPaymentCause(e.target.value); setHoldPaymentCauseLabel(e.target.labels[0].innerText)}} />
            <RadioButton labelText="Other" value="Other" id="radio-other" onClick={(e) => {setHoldPaymentCause(e.target.value); setHoldPaymentCauseLabel(e.target.labels[0].innerText)}} />
          </RadioButtonGroup>
        </div>
      </Modal>
      <Modal
        className="onboarding-modal"
        modalHeading="Please enter a justification of Hold Payment"
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closePaymentModalS4}
        onRequestSubmit={holdPaymentGoS5}
        onSecondarySubmit={closePaymentModalS4}
        open={holdPaymentModalS4}
        primaryButtonDisabled={holdPaymentCause === 'Other' && holdPaymentJustification.length < 5}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'md'}
      >
        <div className="hold-payment-modal">
          
        <TextArea labelText={holdPaymentCause === 'Other' ? "* This field required at least 5 characters" : ''}
                  counterMode="character"
                  enableCounter="true"
                  maxCount={300}
                  onChange={(e) => setHoldPaymentJustification(e.target.value)}
                  defaultValue={''}
                  rows={4} id="hold-payment-justification" />          
          <h4 className="label-in-modal">Provide supporting documentation to keep supplier and buyer aware</h4>
          <FileUploader
            labelTitle=""
            buttonLabel="Add Attachment"
            buttonKind="primary" size="lg" filenameStatus="edit"
            multiple={false}
            onChange={(e) => {processRejectionAttachment(e)}}
            onDelete={() => setRtvAttachmentToSave({})}
            disabled={false}
            iconDescription="Delete file"
            name="" />
        </div>
      </Modal>
      <Modal
        className="onboarding-modal"
        modalHeading=""
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closePaymentModalS5}
        onRequestSubmit={submitHoldPayment}
        onSecondarySubmit={closePaymentModalS5}
        open={holdPaymentModalS5}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'md'}
      >
                 
        <Grid>
          <Column lg={16}>
            <p style={{fontSize:'14px'}}><b>Do you agree?</b></p>
            <p style={{fontSize:'14px'}}><b>You are about to withhold a supplier payment. If it is unjustified, it can lead to late payment fees and/or possible litigation.</b></p>
            <p style={{fontSize:'14px'}}><b>Please take the legal and tax regulations of the country into account. This document will be analyzed by Accounts Payable.</b></p>
            <p style={{fontSize:'14px'}}><b>Hold payment cause: </b> {holdPaymentCauseLabel}</p>
            <p style={{fontSize:'14px'}}><b>Hold payment justification: </b> {holdPaymentJustification}</p>
            <p style={{fontSize:'14px'}}><b>Attachments: </b> {rtvAttachmentToSave.name}</p>
          </Column>
        </Grid>
        
      </Modal>
      <Modal
        className="onboarding-modal"
        modalHeading=''
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closeCancelHoldPaymentModal}
        onRequestSubmit={() => submitCancelRejection('CancelHOLD')}        
        open={cancelHoldPaymentModal}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'lg'}
        >                  
          <Grid>
            <Column lg={16}>
            <TextArea labelText="You are cancelling the Hold Payment. Please enter a reason"                 
                counterMode="character"
                enableCounter="true"
                maxCount={300}
                onChange={(e) => processSetReasonToCancelRejection(e.target.value)}                
                rows={4} id="text-area-1" />
            </Column>
          </Grid>
      </Modal>

      <Modal
        className="onboarding-modal"
        modalHeading="Please, confirm:"
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closeConfirmModal}
        onRequestSubmit={() => finalSubmitRequest('Approve')}
        onSecondarySubmit={closeConfirmModal}
        open={confirmModal}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'md'}
      >
        <div className="hold-payment-modal">
          <p>{confirmModalMessage}</p>
        </div>
      </Modal>

      <Modal
        className="onboarding-modal"
        modalHeading="Please, confirm:"
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closeConfirmSpecialsCategories}
        onRequestSubmit={() => submitApprovalModalWithComodityConfirmation()}
        onSecondarySubmit={closeConfirmSpecialsCategories}
        open={confirmSpecialsCategories}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'md'}
      >
        <div className="hold-payment-modal">
          <p>{MESSAGE_CONFIRM_SPECIAL_CATEGORIES}</p>
        </div>
      </Modal>
      <ModalRequestEmployee modalRequestEmployeeCallback={modalRequestEmployee} closeModalRequestEmployeeCallback={closeModalRequestEmployee}/>
      <SessionController messageLostSessionCallback={messageSessionLost} />
    </>
  );
};

export default DocumentView;